import { GraphQLClient } from "graphql-request"
import * as Dom from "graphql-request/src/types.dom"
import gql from "graphql-tag"
export type Maybe<T> = T | undefined
export type InputMaybe<T> = T | undefined
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  Date: string
  DateTime: string
  MarkdownText: any
}

export type AddFavoriteInput = {
  /** id of an album, video or performance work */
  contentId: Scalars["ID"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type AddFavoritePayload = {
  __typename: "AddFavoritePayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Favorite>
}

export type Album = Node & {
  __typename: "Album"
  /** The album artists and groups as displayed on the DG website, comma separated. */
  artistAndGroupDisplayInfo: Maybe<Scalars["String"]>
  artists: Maybe<ArtistWithRoleConnection>
  atmosUpc: Maybe<Scalars["String"]>
  /** The album's booklet */
  booklet: Maybe<Booklet>
  copyright: Scalars["String"]
  curatedContent: Array<CuratedContentContainerV2>
  dgStoreUrl: Maybe<Scalars["String"]>
  /** Epochs ordered by relevance to this album. Derived from works through their composers, ordered by work count (descending). The first item is always the primary epoch. */
  epochsByRelevance: Array<Epoch>
  /** Genres ordered by relevance to this album. Returns the album's primary genre if set, otherwise genres from tracks ordered by track count (descending). The first item is always the primary genre. */
  genresByRelevance: Array<Genre>
  groups: Array<Group>
  /** The ID of an object */
  id: Scalars["ID"]
  label: Label
  originalReleaseDate: Maybe<Scalars["Date"]>
  partners: Array<Partner>
  phonographicCopyright: Scalars["String"]
  pictures: Array<Picture>
  releaseDate: Maybe<Scalars["Date"]>
  /** @deprecated Use curatedContent instead */
  sliders: Array<CuratedContentContainer>
  supplementaryText: Maybe<Scalars["MarkdownText"]>
  title: Scalars["String"]
  /** Total duration of all tracks combined in seconds */
  totalDuration: Scalars["Int"]
  trackSets: Array<TrackSet>
  upc: Scalars["String"]
  updatedAt: Scalars["DateTime"]
}

export type AlbumArtistsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  by?: InputMaybe<ArtistOrdering>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
  role?: InputMaybe<ArtistRoleFilter>
}

export type AlbumCuratedContentArgs = {
  options: InputMaybe<CuratedContentOptionsInput>
}

export type AlbumConnection = {
  __typename: "AlbumConnection"
  edges: Array<AlbumEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

export type AlbumEdge = {
  __typename: "AlbumEdge"
  cursor: Scalars["String"]
  node: Album
}

export type AlbumWithArtistRoleConnection = {
  __typename: "AlbumWithArtistRoleConnection"
  edges: Array<AlbumWithArtistRoleEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

export type AlbumWithArtistRoleEdge = {
  __typename: "AlbumWithArtistRoleEdge"
  cursor: Scalars["String"]
  node: Album
  role: Role
}

export type AlgoliaConfig = {
  __typename: "AlgoliaConfig"
  /** Algolia public API key */
  apiKey: Scalars["String"]
  /** Algolia application ID */
  applicationId: Scalars["String"]
  /** Algolia API endpoint URL */
  endpointUrl: Scalars["String"]
  /** Algolia search index name */
  indexName: Scalars["String"]
  /** Algolia suggestions index name */
  suggestionsIndexName: Scalars["String"]
}

export type ApiError = {
  message: Scalars["String"]
  path: Array<Scalars["String"]>
}

export type ApplicationConfig = {
  __typename: "ApplicationConfig"
  /** Algolia search configuration */
  algolia: Maybe<AlgoliaConfig>
  /** Search service configuration */
  search: Maybe<SearchConfig>
}

export type Article = Node & {
  __typename: "Article"
  articleType: Maybe<Scalars["String"]>
  artists: Maybe<ArtistFromArticleConnection>
  date: Scalars["DateTime"]
  /** External ID (Relay global ID) for the article */
  externalId: Scalars["String"]
  groups: Maybe<GroupFromArticleConnection>
  headline: Scalars["String"]
  /** The ID of an object */
  id: Scalars["ID"]
  pictures: Array<Picture>
  seoDescription: Maybe<Scalars["String"]>
  seoKeywords: Maybe<Scalars["String"]>
  subHeadline: Maybe<Scalars["String"]>
  teaserHeadline: Maybe<Scalars["String"]>
  teaserSubHeadline: Maybe<Scalars["String"]>
  teaserText: Maybe<Scalars["String"]>
  text: Scalars["String"]
}

export type ArticleArtistsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type ArticleGroupsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type ArticleConnection = {
  __typename: "ArticleConnection"
  edges: Array<ArticleEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

export type ArticleEdge = {
  __typename: "ArticleEdge"
  cursor: Scalars["String"]
  node: Article
}

export type ArticleWithArtistConnection = {
  __typename: "ArticleWithArtistConnection"
  edges: Array<ArticleWithArtistEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

export type ArticleWithArtistEdge = {
  __typename: "ArticleWithArtistEdge"
  cursor: Scalars["String"]
  node: Article
}

export type ArticleWithGroupConnection = {
  __typename: "ArticleWithGroupConnection"
  edges: Array<ArticleWithGroupEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

export type ArticleWithGroupEdge = {
  __typename: "ArticleWithGroupEdge"
  cursor: Scalars["String"]
  node: Article
}

export type Artist = Node & {
  __typename: "Artist"
  albums: Maybe<AlbumWithArtistRoleConnection>
  articles: Maybe<ArticleWithArtistConnection>
  biography: Maybe<Scalars["String"]>
  courtesyOf: Maybe<Scalars["String"]>
  curatedContent: Array<CuratedContentContainerV2>
  /** Year string made up out of integers. No guarantees on length. */
  dateOfBirth: Maybe<Scalars["String"]>
  /** Year string made up out of integers. No guarantees on length. */
  dateOfDeath: Maybe<Scalars["String"]>
  epoch: Maybe<Epoch>
  /** The ID of an object */
  id: Scalars["ID"]
  /** URL that links to the artist's klassikakzente page. Only available for 'de' locale. */
  klassikAkzenteUrl: Maybe<Scalars["String"]>
  metaDescription: Maybe<Scalars["String"]>
  metaTitle: Maybe<Scalars["String"]>
  name: Scalars["String"]
  /** Credit for the photographer who created the teaser image. */
  photographer: Maybe<Scalars["String"]>
  pictures: Array<Picture>
  roles: Array<Role>
  /** @deprecated Use curatedContent instead */
  sliders: Array<CuratedContentContainer>
  sortLetter: Maybe<Scalars["String"]>
  sortName: Maybe<Scalars["String"]>
  supplementaryText: Maybe<Scalars["MarkdownText"]>
  title: Maybe<Scalars["String"]>
  updatedAt: Scalars["DateTime"]
}

export type ArtistAlbumsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type ArtistArticlesArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type ArtistCuratedContentArgs = {
  options: InputMaybe<CuratedContentOptionsInput>
}

export type ArtistConnection = {
  __typename: "ArtistConnection"
  edges: Array<ArtistEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

export type ArtistEdge = {
  __typename: "ArtistEdge"
  cursor: Scalars["String"]
  node: Artist
}

export type ArtistFromArticleConnection = {
  __typename: "ArtistFromArticleConnection"
  edges: Array<ArtistFromArticleEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

export type ArtistFromArticleEdge = {
  __typename: "ArtistFromArticleEdge"
  cursor: Scalars["String"]
  node: Artist
}

export type ArtistOrdering = {
  direction: InputMaybe<SortDirection>
  sort: InputMaybe<ArtistSort>
}

/** Only return artists that hold one of the specified roles on this asset */
export const ArtistRoleFilter = {
  /** All roles */
  All: "ALL",
  /** Conductors */
  Conductors: "CONDUCTORS",
  /** Vocal and Instrumental Solists */
  Soloists: "SOLOISTS",
} as const

export type ArtistRoleFilter =
  (typeof ArtistRoleFilter)[keyof typeof ArtistRoleFilter]
export const ArtistSort = {
  /** Manual Sort Order fixed by editors in the AdminUI. */
  Position: "POSITION",
} as const

export type ArtistSort = (typeof ArtistSort)[keyof typeof ArtistSort]
export type ArtistWithRoleConnection = {
  __typename: "ArtistWithRoleConnection"
  edges: Array<ArtistWithRoleEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

export type ArtistWithRoleEdge = {
  __typename: "ArtistWithRoleEdge"
  cursor: Scalars["String"]
  node: Artist
  role: Role
}

export type AuthorizeDeviceForUserInput = {
  /** Code of the device the user wants to authorize */
  userCode: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type AuthorizeDeviceForUserInputPayload = {
  __typename: "AuthorizeDeviceForUserInputPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The authorized device */
  result: Maybe<Device>
}

export type Banner = {
  __typename: "Banner"
  description: Scalars["String"]
  link: Scalars["String"]
  pictures: Array<Picture>
  title: Scalars["String"]
}

export type BasicError = ApiError & {
  __typename: "BasicError"
  code: Scalars["String"]
  message: Scalars["String"]
  path: Array<Scalars["String"]>
}

/** Link to a blog article on Klassikakzente */
export type BlogArticleLink = Node & {
  __typename: "BlogArticleLink"
  artistScreenName: Scalars["String"]
  date: Scalars["DateTime"]
  headline: Scalars["String"]
  /** The ID of an object */
  id: Scalars["ID"]
  typeDisplayName: Scalars["String"]
  url: Scalars["String"]
}

export type Booklet = {
  __typename: "Booklet"
  /** The URL to the booklet PDF */
  pdfUrl: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type CancelSubscriptionPayload = {
  __typename: "CancelSubscriptionPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<SubscriptionCancelation>
}

export type ChangePasswordInput = {
  newPassword: Scalars["String"]
  newPasswordConfirmation: Scalars["String"]
  oldPassword: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type ChangePasswordPayload = {
  __typename: "ChangePasswordPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type ChangeStripePaymentMethodPayload = {
  __typename: "ChangeStripePaymentMethodPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<SetupIntentClientSecret>
}

export type ChangeStripeSubscriptionPlanInput = {
  productId: Scalars["String"]
  prorationDate: Scalars["Int"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type ChangeStripeSubscriptionPlanPayload = {
  __typename: "ChangeStripeSubscriptionPlanPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type CheckChurnPreventionOfferPayload = {
  __typename: "CheckChurnPreventionOfferPayload"
  /** Discount Offer details */
  discountOffer: Maybe<DiscountOffer>
}

export type CheckETicketPayload = {
  __typename: "CheckETicketPayload"
  /** Voucher metadata when a valid code is given */
  voucher: Maybe<Voucher>
}

export type CheckRegistrationDataInput = {
  email: InputMaybe<Scalars["String"]>
}

export const Client = {
  Android: "ANDROID",
  AndroidTv: "ANDROID_TV",
  Ios: "IOS",
  SmartTv: "SMART_TV",
  Tvos: "TVOS",
  VisionOs: "VISION_OS",
  Web: "WEB",
} as const

export type Client = (typeof Client)[keyof typeof Client]
export type CollectAddress = {
  __typename: "CollectAddress"
  city: Maybe<Scalars["String"]>
  country: Maybe<Scalars["String"]>
  district: Maybe<Scalars["String"]>
  firstLine: Maybe<Scalars["String"]>
  name: Maybe<Scalars["String"]>
  province: Maybe<Scalars["String"]>
  secondLine: Maybe<Scalars["String"]>
  state: Maybe<Scalars["String"]>
  zipCode: Maybe<Scalars["String"]>
}

export type ConfirmPurchaseAmazonInput = {
  customerId: Scalars["String"]
  receiptId: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type ConfirmPurchaseAmazonPayload = {
  __typename: "ConfirmPurchaseAmazonPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type ConfirmPurchaseAppleInput = {
  transactionJws: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type ConfirmPurchaseApplePayload = {
  __typename: "ConfirmPurchaseApplePayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type ConfirmPurchaseGoogleInput = {
  token: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type ConfirmPurchaseGooglePayload = {
  __typename: "ConfirmPurchaseGooglePayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type ConfirmPurchaseSamsungInput = {
  purchaseId: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type ConfirmPurchaseSamsungPayload = {
  __typename: "ConfirmPurchaseSamsungPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type ConsentTrackingInput = {
  consent: TrackingConsentType
  service: TrackingServiceType
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type ConsentTrackingPayload = {
  __typename: "ConsentTrackingPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type Country = {
  __typename: "Country"
  displayName: Scalars["String"]
  iso: Scalars["String"]
}

export type Coupon = {
  __typename: "Coupon"
  durationInMonths: Maybe<Scalars["Int"]>
  name: Scalars["String"]
  percentOff: Scalars["Float"]
  /** List of productIds this coupon is limited to. Applies to all productIds when empty. */
  productIdsLimitedTo: Array<Scalars["String"]>
  promotionCode: Scalars["String"]
}

export type CreateGiftLinkInput = {
  /** ID of the content to share */
  contentId: Scalars["String"]
  /** Time of a start for playable media in seconds (default: 0) */
  timeStart: InputMaybe<Scalars["Int"]>
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type CreateGiftLinkPayload = {
  __typename: "CreateGiftLinkPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<CreateGiftLinkResult>
}

export type CreateGiftLinkResult = {
  __typename: "CreateGiftLinkResult"
  /** The gift link URL */
  link: Scalars["String"]
  /** User remaining quota */
  userRemainingQuota: Scalars["Int"]
}

export type CuePoint = {
  __typename: "CuePoint"
  /** Offset of the cue-point marker within this performance work in seconds. Starts at zero again for each performance work. */
  mark: Scalars["Int"]
  title: Scalars["String"]
}

export type CuratedContent = {
  __typename: "CuratedContent"
  /** @deprecated use curated_content instead */
  contentContainers: Array<CuratedContentContainer>
  curatedContent: Array<CuratedContentContainerV2>
  metaDescription: Maybe<Scalars["String"]>
  metaTitle: Maybe<Scalars["String"]>
  /** Navigation items for curated content. Returns all published curated content items excluding predefined slugs (discover, live, audio, landing_page, search, campaign, video). Items are sorted alphabetically by title in the current locale. Returns nil if the current item has a predefined slug or if no navigation slider exists. */
  navigation: Maybe<ListSlider>
  pictures: Array<Picture>
  /**
   * CAUTION: Returns fixed value `discover` for all newer content-slugs.
   * @deprecated use `slugV2` instead
   */
  slug: CuratedContentSlug
  /** Can be freely set by editors, guaranteed to be url-safe */
  slugV2: Scalars["String"]
  /** @deprecated use stage_slider instead */
  stage: Array<StageItem>
  stageSlider: Array<StageItemV2>
  supplementaryText: Maybe<Scalars["String"]>
  title: Scalars["String"]
}

export type CuratedContentCuratedContentArgs = {
  first: InputMaybe<Scalars["Int"]>
  options: InputMaybe<CuratedContentOptionsInput>
}

export type CuratedContentContainer = Banner | Slider

export type CuratedContentContainerV2 = Banner | ListSlider

/** Representation of `CuratedContent` when referenced in a slider. */
export type CuratedContentLink = Node & {
  __typename: "CuratedContentLink"
  /** The ID of an object */
  id: Scalars["ID"]
  pictures: Array<Picture>
  /** Can be freely set by editors, guaranteed to be url-safe. */
  slugV2: Scalars["String"]
  title: Scalars["String"]
}

export type CuratedContentOptionsInput = {
  profile: InputMaybe<CuratedContentProfile>
}

export const CuratedContentProfile = {
  /** No server-side geo filtering (backwards compatible) */
  Default: "DEFAULT",
  /** Server-side geo filtering enabled */
  Filtered: "FILTERED",
} as const

export type CuratedContentProfile =
  (typeof CuratedContentProfile)[keyof typeof CuratedContentProfile]
/** Do not use! Curated Content can now be created by editors. Contains only original values. */
export const CuratedContentSlug = {
  Audio: "AUDIO",
  Campaign: "CAMPAIGN",
  Discover: "DISCOVER",
  LandingPage: "LANDING_PAGE",
  Live: "LIVE",
  Search: "SEARCH",
  Video: "VIDEO",
} as const

export type CuratedContentSlug =
  (typeof CuratedContentSlug)[keyof typeof CuratedContentSlug]
export type DeletePushTokenInput = {
  /** Required, provide device push token to delete */
  pushToken: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type DeletePushTokenPayload = {
  __typename: "DeletePushTokenPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** Delete push token */
  result: Maybe<Scalars["Boolean"]>
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type DeleteUserPayload = {
  __typename: "DeleteUserPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<User>
}

export type DenyDeviceInput = {
  /** Code of the device the user wants to deny (cancel the device flow) */
  userCode: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type DenyDeviceInputPayload = {
  __typename: "DenyDeviceInputPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The denied pending device */
  result: Maybe<Device>
}

export type Device = {
  __typename: "Device"
  deviceInfo: Scalars["String"]
  /** UUID that is also part of a devices JWTs */
  id: Scalars["String"]
  insertedAt: Scalars["DateTime"]
  /** The last time the device info was updated OR login OR token refresh happened */
  updatedAt: Scalars["DateTime"]
}

export type DiscountOffer = {
  __typename: "DiscountOffer"
  /** Currency of the discounted amount */
  currency: Maybe<Scalars["String"]>
  /** Amount to be paid after discount is applied to the current plan. Amounts are Stripe amounts, so they need to be converted before display */
  discountedAmount: Maybe<Scalars["Int"]>
  /** Can be repeating or forever. */
  duration: Scalars["String"]
  /** Duration in months, null when duration is forever. */
  durationInMonths: Maybe<Scalars["Int"]>
  /** Percentage off discount */
  percentageOff: Maybe<Scalars["String"]>
}

export type EditorialPlaylist = Node & {
  __typename: "EditorialPlaylist"
  curatedContent: Array<CuratedContentContainerV2>
  description: Scalars["String"]
  /** The ID of an object */
  id: Scalars["ID"]
  metaDescription: Maybe<Scalars["String"]>
  metaTitle: Maybe<Scalars["String"]>
  pictures: Array<Picture>
  sections: Array<EditorialPlaylistSection>
  supplementaryText: Maybe<Scalars["MarkdownText"]>
  title: Scalars["String"]
  totalDuration: Scalars["Int"]
  totalItems: Scalars["Int"]
  /** Contrary to eg. VodConcerts, there is only one Playlist-Type. This is for easier display of a translated type label in sliders, eg. for mixed contexts. */
  typeDisplayName: Scalars["String"]
}

export type EditorialPlaylistCuratedContentArgs = {
  options: InputMaybe<CuratedContentOptionsInput>
}

export type EditorialPlaylistSection = {
  __typename: "EditorialPlaylistSection"
  description: Maybe<Scalars["String"]>
  items: Array<PlaylistItem>
  title: Maybe<Scalars["String"]>
}

export type Epoch = Node & {
  __typename: "Epoch"
  composers: Array<Artist>
  curatedContent: Array<CuratedContentContainerV2>
  description: Maybe<Scalars["String"]>
  endYear: Maybe<Scalars["Int"]>
  /** The ID of an object */
  id: Scalars["ID"]
  metaDescription: Maybe<Scalars["String"]>
  metaTitle: Maybe<Scalars["String"]>
  pictures: Array<Picture>
  /** @deprecated Use curatedContent instead */
  sliders: Array<CuratedContentContainer>
  startYear: Maybe<Scalars["Int"]>
  subtitle: Maybe<Scalars["String"]>
  supplementaryText: Maybe<Scalars["MarkdownText"]>
  title: Scalars["String"]
  updatedAt: Scalars["DateTime"]
}

export type EpochCuratedContentArgs = {
  options: InputMaybe<CuratedContentOptionsInput>
}

export type EpochConnection = {
  __typename: "EpochConnection"
  edges: Array<EpochEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

export type EpochEdge = {
  __typename: "EpochEdge"
  cursor: Scalars["String"]
  node: Epoch
}

export type ExternalAuthInput = {
  provider: ExternalAuthProvider
  token: Scalars["String"]
}

export const ExternalAuthProvider = {
  Mondia: "MONDIA",
} as const

export type ExternalAuthProvider =
  (typeof ExternalAuthProvider)[keyof typeof ExternalAuthProvider]
export const FacetType = {
  Composers: "COMPOSERS",
  Conductors: "CONDUCTORS",
  Ensembles: "ENSEMBLES",
  Soloists: "SOLOISTS",
  Venue: "VENUE",
} as const

export type FacetType = (typeof FacetType)[keyof typeof FacetType]
export type Favorite = Node & {
  __typename: "Favorite"
  content: FavoriteContent
  /** The ID of an object */
  id: Scalars["ID"]
  insertedAt: Scalars["DateTime"]
  updatedAt: Scalars["DateTime"]
}

export type FavoriteConnection = {
  __typename: "FavoriteConnection"
  edges: Array<FavoriteEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
  updatedAt: Scalars["DateTime"]
}

export type FavoriteContent =
  | Album
  | EditorialPlaylist
  | PerformanceWork
  | Video

export type FavoriteEdge = {
  __typename: "FavoriteEdge"
  cursor: Scalars["String"]
  node: Favorite
}

export type FavoriteOrdering = {
  direction: InputMaybe<SortDirection>
  sort: InputMaybe<FavoriteSort>
}

export const FavoriteRemovalContentType = {
  /** Remove all album favorites */
  Audio: "AUDIO",
  /** Editorial playlist content type */
  EditorialPlaylist: "EDITORIAL_PLAYLIST",
  /** Remove all video and performance work favorites */
  Video: "VIDEO",
} as const

export type FavoriteRemovalContentType =
  (typeof FavoriteRemovalContentType)[keyof typeof FavoriteRemovalContentType]
export const FavoriteSort = {
  Id: "ID",
  UpdatedAt: "UPDATED_AT",
} as const

export type FavoriteSort = (typeof FavoriteSort)[keyof typeof FavoriteSort]
export const FavoriteType = {
  /** Return only albums */
  Album: "ALBUM",
  /** Return albums and editorial playlists */
  AlbumAndEditorialPlaylist: "ALBUM_AND_EDITORIAL_PLAYLIST",
  /** Return all types of content */
  All: "ALL",
  /** Return only editorial playlists */
  EditorialPlaylist: "EDITORIAL_PLAYLIST",
  /** Return only performance works */
  PerformanceWork: "PERFORMANCE_WORK",
  /** Return videos and performance works */
  PerformanceWorkAndVideo: "PERFORMANCE_WORK_AND_VIDEO",
  /** Return only videos */
  Video: "VIDEO",
} as const

export type FavoriteType = (typeof FavoriteType)[keyof typeof FavoriteType]
/** Payload of this mutation - contains either a result on success or a list of errors */
export type GeneratePinCodePayload = {
  __typename: "GeneratePinCodePayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<PinCode>
}

export type Genre = Node & {
  __typename: "Genre"
  curatedContent: Array<CuratedContentContainerV2>
  /** The ID of an object */
  id: Scalars["ID"]
  metaDescription: Maybe<Scalars["String"]>
  metaTitle: Maybe<Scalars["String"]>
  pictures: Array<Picture>
  /** @deprecated Use curatedContent instead */
  sliders: Array<CuratedContentContainer>
  supplementaryText: Maybe<Scalars["MarkdownText"]>
  title: Scalars["String"]
  updatedAt: Scalars["DateTime"]
}

export type GenreCuratedContentArgs = {
  options: InputMaybe<CuratedContentOptionsInput>
}

export type GenreConnection = {
  __typename: "GenreConnection"
  edges: Array<GenreEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

export type GenreEdge = {
  __typename: "GenreEdge"
  cursor: Scalars["String"]
  node: Genre
}

export const GeoAccessMode = {
  Allow: "ALLOW",
  Deny: "DENY",
} as const

export type GeoAccessMode = (typeof GeoAccessMode)[keyof typeof GeoAccessMode]
export type GeoinfoPayload = {
  __typename: "GeoinfoPayload"
  /** An ISO 3166-1 two letter country code for the country the implicit or explicit ip resides in OR the user country (when called authenticated) */
  countryCode: Scalars["String"]
  /** An ISO 4217 three letter currency code connected to the country code and supported by DG OR the currency used for the first Stripe subscription */
  currencyCode: Scalars["String"]
  /** The IP address that was used to lookup the country code */
  ip: Scalars["String"]
}

export type Group = Node & {
  __typename: "Group"
  albums: Array<Album>
  articles: Maybe<ArticleWithGroupConnection>
  curatedContent: Array<CuratedContentContainerV2>
  description: Maybe<Scalars["String"]>
  footnote: Maybe<Scalars["String"]>
  /** The ID of an object */
  id: Scalars["ID"]
  name: Scalars["String"]
  /** Credit for the photographer who created the teaser image. */
  photographer: Maybe<Scalars["String"]>
  pictures: Array<Picture>
  /** @deprecated Use curatedContent instead */
  sliders: Array<CuratedContentContainer>
  sortLetter: Maybe<Scalars["String"]>
  supplementaryText: Maybe<Scalars["MarkdownText"]>
  type: GroupType
  typeDisplayName: Scalars["String"]
  updatedAt: Scalars["DateTime"]
  vodConcerts: Maybe<VodConcertConnection>
}

export type GroupArticlesArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type GroupCuratedContentArgs = {
  options: InputMaybe<CuratedContentOptionsInput>
}

export type GroupVodConcertsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type GroupConnection = {
  __typename: "GroupConnection"
  edges: Array<GroupEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

export type GroupEdge = {
  __typename: "GroupEdge"
  cursor: Scalars["String"]
  node: Group
}

export type GroupFromArticleConnection = {
  __typename: "GroupFromArticleConnection"
  edges: Array<GroupFromArticleEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

export type GroupFromArticleEdge = {
  __typename: "GroupFromArticleEdge"
  cursor: Scalars["String"]
  node: Group
}

export const GroupType = {
  Band: "BAND",
  ChamberEnsemble: "CHAMBER_ENSEMBLE",
  ChamberOrchestra: "CHAMBER_ORCHESTRA",
  Choir: "CHOIR",
  Combo: "COMBO",
  Duo: "DUO",
  Ensemble: "ENSEMBLE",
  Octett: "OCTETT",
  Orchestra: "ORCHESTRA",
  Quartet: "QUARTET",
  Trio: "TRIO",
  Various: "VARIOUS",
} as const

export type GroupType = (typeof GroupType)[keyof typeof GroupType]
export const ItemSortOrder = {
  Custom: "CUSTOM",
} as const

export type ItemSortOrder = (typeof ItemSortOrder)[keyof typeof ItemSortOrder]
export type Label = Node & {
  __typename: "Label"
  /** The ID of an object */
  id: Scalars["ID"]
  title: Scalars["String"]
}

export type ListSlider = {
  __typename: "ListSlider"
  headline: Scalars["String"]
  id: Scalars["String"]
  items: Array<SliderItem>
  layout: Maybe<SliderLayout>
  totalResults: Scalars["Int"]
}

export type ListSliderItemsArgs = {
  first: InputMaybe<Scalars["Int"]>
  sizeOverrides: InputMaybe<SliderSizeOverridesInput>
  sliderPageSize: InputMaybe<Scalars["Int"]>
}

export type LiveConcert = Node & {
  __typename: "LiveConcert"
  artists: Maybe<ArtistWithRoleConnection>
  /** The live concert's booklet */
  booklet: Maybe<Booklet>
  copyright: Maybe<Scalars["String"]>
  courtesyOf: Maybe<Scalars["String"]>
  curatedContent: Array<CuratedContentContainerV2>
  /** The end time of the first stream stream (not reruns) */
  endTime: Scalars["DateTime"]
  /** The max of the concerts end time and the end time of all reruns */
  finalEndTime: Scalars["DateTime"]
  /** A list of countries used to evaluate the geoblocking of the stream delivery. */
  geoAccessCountries: Array<Scalars["String"]>
  /** Geo access mode mode. DENY=blocked in specified countries, ALLOW=allowed in specified countries */
  geoAccessMode: GeoAccessMode
  groups: Array<Group>
  /** The ID of an object */
  id: Scalars["ID"]
  isAtmos: Scalars["Boolean"]
  /** Always returns `false`. HDR-Content is currently not available, but might be in the future */
  isHdr: Scalars["Boolean"]
  isLossless: Scalars["Boolean"]
  isrc: Maybe<Scalars["String"]>
  licensor: Maybe<Scalars["String"]>
  longFormConcertIntroduction: Maybe<Scalars["String"]>
  maxResolution: MaxResolution
  metaDescription: Maybe<Scalars["String"]>
  metaTitle: Maybe<Scalars["String"]>
  partners: Array<Partner>
  performanceWorks: Array<LivePerformanceWork>
  photographer: Maybe<Scalars["String"]>
  pictures: Array<Picture>
  /** Once all reruns have concluded, this live concert is planned to become a VoD-concert */
  plannedForVod: Scalars["Boolean"]
  production: Maybe<Scalars["String"]>
  /** The level that is needed for a user to access the stream-content. U1=everyone, U2=needs account, U3=needs account + ticket */
  publicationLevel: PublicationLevel
  reruns: Array<LiveConcertRerun>
  /** Maximum length: 25 characters */
  seriesTitle: Maybe<Scalars["String"]>
  /** Maximum length 750 characters */
  shortDescription: Maybe<Scalars["String"]>
  /** @deprecated Use curatedContent instead */
  sliders: Array<CuratedContentContainer>
  /** The start time of the first stream (not reruns) */
  startTime: Scalars["DateTime"]
  /**
   * Live stream configuration
   * @deprecated Use `stream_variants` instead
   */
  stream: LiveStream
  /** The start time of the first stream (not reruns), start of pre-rolls, etc. */
  streamStartTime: Maybe<Scalars["DateTime"]>
  streamVariants: Array<StreamVariant>
  /** Maximum length: 25 characters */
  subtitle: Maybe<Scalars["String"]>
  supplementaryText: Maybe<Scalars["MarkdownText"]>
  /**
   * The max of the concerts end time and the end time of all reruns
   * @deprecated Renamed to avoid confusion with `takedownDate` in `video` and `vodConcert`. Use field `finalEndTime` instead
   */
  takedownDate: Maybe<Scalars["DateTime"]>
  /** Maximum length: 70 characters */
  title: Scalars["String"]
  /** The estimated total duration of the concert in seconds. */
  totalDuration: Scalars["Int"]
  trailerIsrc: Maybe<Scalars["String"]>
  /** @deprecated Use `trailer_stream_variants` instead */
  trailerStream: Maybe<Stream>
  trailerStreamVariants: Array<StreamVariant>
  type: LiveConcertType
  typeDisplayName: Scalars["String"]
  updatedAt: Scalars["DateTime"]
  videoDirector: Maybe<Scalars["String"]>
  vodConcert: Maybe<VodConcert>
}

export type LiveConcertArtistsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  by?: InputMaybe<ArtistOrdering>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
  role?: InputMaybe<ArtistRoleFilter>
}

export type LiveConcertCuratedContentArgs = {
  options: InputMaybe<CuratedContentOptionsInput>
}

export type LiveConcertConnection = {
  __typename: "LiveConcertConnection"
  edges: Array<LiveConcertEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

export type LiveConcertEdge = {
  __typename: "LiveConcertEdge"
  cursor: Scalars["String"]
  node: LiveConcert
}

export type LiveConcertReminder = {
  __typename: "LiveConcertReminder"
  liveConcertId: Scalars["String"]
  rerunId: Maybe<Scalars["String"]>
  startTime: Scalars["DateTime"]
}

export type LiveConcertRerun = {
  __typename: "LiveConcertRerun"
  endTime: Scalars["DateTime"]
  id: Scalars["String"]
  startTime: Scalars["DateTime"]
  /** @deprecated Use `liveConcert.streamVariants` instead. Streams on Reruns and root live concert are always identical. */
  stream: RerunStream
  streamStartTime: Maybe<Scalars["DateTime"]>
}

export const LiveConcertType = {
  Live: "LIVE",
  Premiere: "PREMIERE",
} as const

export type LiveConcertType =
  (typeof LiveConcertType)[keyof typeof LiveConcertType]
/** Different than `PerformanceWork`, because for live there is no stream and no cue points */
export type LivePerformanceWork = Node & {
  __typename: "LivePerformanceWork"
  artists: Maybe<ArtistWithRoleConnection>
  /** Estimated duration of the performance work in seconds */
  duration: Scalars["Int"]
  groups: Maybe<GroupConnection>
  /** The ID of an object */
  id: Scalars["ID"]
  isrc: Scalars["String"]
  work: Work
}

/** Different than `PerformanceWork`, because for live there is no stream and no cue points */
export type LivePerformanceWorkArtistsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  by?: InputMaybe<ArtistOrdering>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
  role?: InputMaybe<ArtistRoleFilter>
}

/** Different than `PerformanceWork`, because for live there is no stream and no cue points */
export type LivePerformanceWorkGroupsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type LiveStream = {
  __typename: "LiveStream"
  publicationLevel: PublicationLevel
  streamType: StreamType
  url: Scalars["String"]
}

export type LogOutUserInput = {
  /** Optional, provide device push token to disable push notifications after log out */
  pushToken: InputMaybe<Scalars["String"]>
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type LogOutUserPayload = {
  __typename: "LogOutUserPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** Log out */
  result: Maybe<Scalars["Boolean"]>
}

export type LoginUserWithPinCodeInput = {
  /**
   * This affiliate group is applied to the user on successful login when the following conditions are met:
   * * User's account is not older than 30m
   * * User's existing affiliate_group is null or "general-web"
   *
   * Affiliates for TV apps are set this way because of the following:
   * * Users cannot create accounts via TV app, so the TV app cannot set the affiliate upon registration
   * * Affiliate cannot be reliably passed to the device that the user will use to register an account
   *
   * This flow allows us to attribute the registration to the TV app manufacturer through the login flow
   *
   * Sample: "store-appletv"
   */
  affiliateGroup: InputMaybe<Scalars["String"]>
  /** Optional unique and stable identifier for the device */
  clientDeviceId: InputMaybe<Scalars["String"]>
  /** Identifier for the device used e.g. "Firefox 97 (macOS 12.2.1)" or "iPhone 13 (iOS 15.3.1) " */
  deviceInfo: Scalars["String"]
  /** Use either the exact 8-digit PIN code or its 4-digit prefix */
  pinCode: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type LoginUserWithPinCodePayload = {
  __typename: "LoginUserWithPinCodePayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<UserAndToken>
}

export const MaxResolution = {
  Resolution_4K: "RESOLUTION_4K",
  ResolutionHd: "RESOLUTION_HD",
  ResolutionSd: "RESOLUTION_SD",
} as const

export type MaxResolution = (typeof MaxResolution)[keyof typeof MaxResolution]
export type MondiaSubscriptionManagementDetails = {
  __typename: "MondiaSubscriptionManagementDetails"
  mondiaProductId: Maybe<Scalars["Int"]>
  operatorLogoUrl: Maybe<Scalars["String"]>
  operatorName: Maybe<Scalars["String"]>
  packageId: Maybe<Scalars["Int"]>
  productName: Maybe<Scalars["String"]>
  subscriptionId: Maybe<Scalars["ID"]>
  subscriptionStatus: Maybe<Scalars["String"]>
  tenantUrl: Maybe<Scalars["String"]>
  territoryName: Maybe<Scalars["String"]>
}

export type MondiaTokenProductDetails = {
  __typename: "MondiaTokenProductDetails"
  operatorLogoUrl: Maybe<Scalars["String"]>
  operatorName: Maybe<Scalars["String"]>
  packageDuration: Maybe<Scalars["String"]>
  packageId: Maybe<Scalars["Int"]>
  productId: Maybe<Scalars["Int"]>
  productName: Maybe<Scalars["String"]>
  subscriptionId: Maybe<Scalars["ID"]>
  subscriptionStatus: Maybe<Scalars["String"]>
  tenantUrl: Maybe<Scalars["String"]>
  territoryName: Maybe<Scalars["String"]>
}

export type MondiaTokenProductDetailsInput = {
  token: Scalars["String"]
}

export type Movement = Node & {
  __typename: "Movement"
  /** The ID of an object */
  id: Scalars["ID"]
  title: Scalars["String"]
}

export type Node = {
  /** The ID of the object. */
  id: Scalars["ID"]
}

export type NodeConnectionConnection = {
  __typename: "NodeConnectionConnection"
  edges: Array<NodeConnectionEdge>
  pageInfo: PageInfo
  /** The maximum publication_level of all items in this content container */
  publicationLevel: Maybe<PublicationLevel>
  totalResults: Scalars["Int"]
}

export type NodeConnectionEdge = {
  __typename: "NodeConnectionEdge"
  cursor: Scalars["String"]
  node: Node
}

export const OsIdType = {
  Android: "ANDROID",
  AndroidTv: "ANDROID_TV",
  Ios: "IOS",
  TvOs: "TV_OS",
  VisionOs: "VISION_OS",
} as const

export type OsIdType = (typeof OsIdType)[keyof typeof OsIdType]
export type PageInfo = {
  __typename: "PageInfo"
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars["String"]>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"]
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"]
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars["String"]>
}

export type Partner = Node & {
  __typename: "Partner"
  albums: Array<Album>
  curatedContent: Array<CuratedContentContainerV2>
  description: Maybe<Scalars["String"]>
  /** The ID of an object */
  id: Scalars["ID"]
  liveConcerts: Array<LiveConcert>
  metaDescription: Maybe<Scalars["String"]>
  metaTitle: Maybe<Scalars["String"]>
  name: Scalars["String"]
  /** Credit for the photographer who created the teaser image. */
  photographer: Maybe<Scalars["String"]>
  pictures: Array<Picture>
  /** @deprecated Use curatedContent instead */
  sliders: Array<CuratedContentContainer>
  sortLetter: Maybe<Scalars["String"]>
  subtype: Maybe<PartnerSubtype>
  subtypeDisplayName: Maybe<Scalars["String"]>
  supplementaryText: Maybe<Scalars["MarkdownText"]>
  type: PartnerType
  typeDisplayName: Scalars["String"]
  updatedAt: Scalars["DateTime"]
  vodConcerts: Array<VodConcert>
}

export type PartnerCuratedContentArgs = {
  options: InputMaybe<CuratedContentOptionsInput>
}

export type PartnerConnection = {
  __typename: "PartnerConnection"
  edges: Array<PartnerEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

export type PartnerEdge = {
  __typename: "PartnerEdge"
  cursor: Scalars["String"]
  node: Partner
}

export const PartnerSubtype = {
  ChamberMusicHall: "CHAMBER_MUSIC_HALL",
  Club: "CLUB",
  ConcertHall: "CONCERT_HALL",
  OpenAir: "OPEN_AIR",
  OperaHouse: "OPERA_HOUSE",
  Theatre: "THEATRE",
} as const

export type PartnerSubtype =
  (typeof PartnerSubtype)[keyof typeof PartnerSubtype]
export const PartnerType = {
  Curator: "CURATOR",
  Festival: "FESTIVAL",
  FocusTopic: "FOCUS_TOPIC",
  ProductionCompany: "PRODUCTION_COMPANY",
  RecordingCompany: "RECORDING_COMPANY",
  Series: "SERIES",
  Sponsor: "SPONSOR",
  Venue: "VENUE",
} as const

export type PartnerType = (typeof PartnerType)[keyof typeof PartnerType]
export type PaymentIntentClientSecret = {
  __typename: "PaymentIntentClientSecret"
  clientSecret: Scalars["String"]
}

export const PaymentProvider = {
  Amazon: "AMAZON",
  Apple: "APPLE",
  Google: "GOOGLE",
  Mondia: "MONDIA",
  None: "NONE",
  Samsung: "SAMSUNG",
  Stripe: "STRIPE",
} as const

export type PaymentProvider =
  (typeof PaymentProvider)[keyof typeof PaymentProvider]
export type PerformanceWork = Node & {
  __typename: "PerformanceWork"
  artists: Maybe<ArtistWithRoleConnection>
  cuePoints: Array<CuePoint>
  /** Duration of the work in seconds */
  duration: Scalars["Int"]
  groups: Maybe<GroupConnection>
  /** The ID of an object */
  id: Scalars["ID"]
  isrc: Scalars["String"]
  /**
   * The stream for the performance work
   * @deprecated Use `stream_variants` instead
   */
  stream: Stream
  /** The stream variants for the performance work */
  streamVariants: Array<StreamVariant>
  vodConcert: VodConcert
  work: Work
}

export type PerformanceWorkArtistsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  by?: InputMaybe<ArtistOrdering>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
  role?: InputMaybe<ArtistRoleFilter>
}

export type PerformanceWorkGroupsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type Picture = Node & {
  __typename: "Picture"
  /** The ID of an object */
  id: Scalars["ID"]
  type: PictureType
  url: Scalars["String"]
}

export const PictureType = {
  Banner: "BANNER",
  Cover: "COVER",
  ImmersiveEnvironmentImage: "IMMERSIVE_ENVIRONMENT_IMAGE",
  Logo: "LOGO",
  Teaser: "TEASER",
  TeaserSquare: "TEASER_SQUARE",
} as const

export type PictureType = (typeof PictureType)[keyof typeof PictureType]
export type PinCode = {
  __typename: "PinCode"
  expiresAt: Scalars["DateTime"]
  /** 8-digit PIN code. Login is also possible with its 4-digit prefix and clients may choose to display that instead */
  pinCode: Scalars["String"]
}

/** V2 Playback History - tracks what content was played in which container context (used by web clients) */
export type Playback = Node & {
  __typename: "Playback"
  /** Will be null for videos and if a playback is queried by its own id and the content has since become unavailable. */
  container: Maybe<PlaybackContainer>
  content: PlaybackContent
  /** The ID of an object */
  id: Scalars["ID"]
  insertedAt: Scalars["DateTime"]
  playedAt: Scalars["DateTime"]
  updatedAt: Scalars["DateTime"]
}

/** V2 Playback History Connection - paginated list of playback events (distinct from V1 PlaybackProgress) */
export type PlaybackConnection = {
  __typename: "PlaybackConnection"
  edges: Array<PlaybackEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

/** The container context where content was played (album, playlist, concert, or null for videos) */
export type PlaybackContainer = Album | EditorialPlaylist | VodConcert

/** The actual content that was played (track, video, or performance work) */
export type PlaybackContent = PerformanceWork | Track | Video

export type PlaybackEdge = {
  __typename: "PlaybackEdge"
  cursor: Scalars["String"]
  node: Playback
}

export type PlaybackOrdering = {
  direction: InputMaybe<SortDirection>
  sort: InputMaybe<PlaybackSort>
}

export type PlaybackProgress = Node & {
  __typename: "PlaybackProgress"
  content: PlaybackProgressContent
  /** The ID of an object */
  id: Scalars["ID"]
  insertedAt: Scalars["DateTime"]
  /** Playback position in seconds */
  mark: Scalars["Int"]
  updatedAt: Scalars["DateTime"]
}

export type PlaybackProgressConnection = {
  __typename: "PlaybackProgressConnection"
  edges: Array<PlaybackProgressEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

export type PlaybackProgressContent = PerformanceWork | Track | Video

export type PlaybackProgressEdge = {
  __typename: "PlaybackProgressEdge"
  cursor: Scalars["String"]
  node: PlaybackProgress
}

export type PlaybackProgressOrdering = {
  direction: InputMaybe<SortDirection>
  sort: InputMaybe<FavoriteSort>
}

export const PlaybackProgressType = {
  /** Return only the most recently played track for an album, useful for displaying the most recently played albums. */
  Album: "ALBUM",
  /** Return all types of content */
  All: "ALL",
  /** Return only performance works */
  PerformanceWork: "PERFORMANCE_WORK",
  /** Return videos and performance works */
  PerformanceWorkAndVideo: "PERFORMANCE_WORK_AND_VIDEO",
  /** Return only tracks */
  Track: "TRACK",
  /** Return only videos */
  Video: "VIDEO",
} as const

export type PlaybackProgressType =
  (typeof PlaybackProgressType)[keyof typeof PlaybackProgressType]
export type PlaybackProgressV2 = Node & {
  __typename: "PlaybackProgressV2"
  /** The ID of an object */
  id: Scalars["ID"]
  insertedAt: Scalars["DateTime"]
  /** Playback position in seconds */
  mark: Scalars["Int"]
  updatedAt: Scalars["DateTime"]
}

export const PlaybackSort = {
  Id: "ID",
  /** Sort by the timestamp when the playback happened */
  PlayedAt: "PLAYED_AT",
} as const

export type PlaybackSort = (typeof PlaybackSort)[keyof typeof PlaybackSort]
/** Filter types for V2 playback history queries */
export const PlaybackType = {
  /** Return most recent V2 playback per album (useful for 'recently played albums' UIs) */
  Album: "ALBUM",
  /** Return most recent V2 playback per album and playlist (useful for 'recently played albums and playlists' UIs) */
  AlbumAndEditorialPlaylist: "ALBUM_AND_EDITORIAL_PLAYLIST",
  /** Return all V2 playback events */
  All: "ALL",
  /** Return most recent V2 playback per playlist (useful for 'recently played playlists' UIs) */
  EditorialPlaylist: "EDITORIAL_PLAYLIST",
  /** Return V2 playbacks for performance works only */
  PerformanceWork: "PERFORMANCE_WORK",
  /** Return V2 playbacks for videos and performance works only */
  PerformanceWorkAndVideo: "PERFORMANCE_WORK_AND_VIDEO",
  /** Return V2 playbacks for tracks only */
  Track: "TRACK",
  /** Return V2 playbacks for videos only */
  Video: "VIDEO",
} as const

export type PlaybackType = (typeof PlaybackType)[keyof typeof PlaybackType]
export type PlaylistItem = Track

export type PostalAddress = {
  __typename: "PostalAddress"
  city: Maybe<Scalars["String"]>
  country: Maybe<Scalars["String"]>
  district: Maybe<Scalars["String"]>
  firstLine: Maybe<Scalars["String"]>
  insertedAt: Scalars["DateTime"]
  province: Maybe<Scalars["String"]>
  secondLine: Maybe<Scalars["String"]>
  /** @deprecated Use province instead */
  state: Maybe<Scalars["String"]>
  updatedAt: Scalars["DateTime"]
  zipCode: Maybe<Scalars["String"]>
}

export type Price = {
  __typename: "Price"
  /**
   * ATTENTION: The amount is currency dependent wether it supports
   *   fractions are not e.g. EUR/USD in cents, JPY full Yen only. This is relevant for displaying formatted prices.
   *
   *   Maybe lower compared to amountUndiscounted, if a coupon is applied.
   */
  amount: Scalars["Int"]
  /** The amount without any discount applied */
  amountUndiscounted: Scalars["Int"]
  currency: Scalars["String"]
  id: Scalars["String"]
}

export type ProductPurchaseStatus = {
  __typename: "ProductPurchaseStatus"
  collectAddress: Maybe<CollectAddress>
  products: Maybe<Array<PurchaseProduct>>
  purchaseCurrency: Maybe<Scalars["String"]>
  purchaseDate: Maybe<Scalars["String"]>
  purchaseId: Maybe<Scalars["String"]>
  purchasePrice: Maybe<Scalars["String"]>
  status: Scalars["String"]
}

export type ProductStripe = {
  __typename: "ProductStripe"
  /** id of product */
  id: Scalars["String"]
  /** The price for the current user based on their region */
  price: Price
  /** @deprecated Use `price` instead containing user's country based price */
  prices: Maybe<Array<Price>>
  productId: Maybe<Scalars["String"]>
}

export type Province = {
  __typename: "Province"
  code: Scalars["String"]
  displayName: Scalars["String"]
}

export const PublicationLevel = {
  AccountRequired: "ACCOUNT_REQUIRED",
  NoAuthentication: "NO_AUTHENTICATION",
  TicketRequired: "TICKET_REQUIRED",
} as const

export type PublicationLevel =
  (typeof PublicationLevel)[keyof typeof PublicationLevel]
export type PurchaseProduct = {
  __typename: "PurchaseProduct"
  description: Maybe<Scalars["String"]>
  /** Stripe ID of the product used as a gift */
  id: Scalars["String"]
  image: Scalars["String"]
  localizationKey: Maybe<Scalars["String"]>
  name: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type ReactivateSubscriptionPayload = {
  __typename: "ReactivateSubscriptionPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Ticket>
}

export type RecordPlaybackProgressInput = {
  /** Client identifier */
  client: Client
  /** Information on the device the client is running on */
  clientDevice: Scalars["String"]
  /** Client Unix timestamp in seconds */
  clientTimestamp: Scalars["Int"]
  /** Client version */
  clientVersion: Scalars["String"]
  /** id of a Track, Video, PerformanceWork or LiveConcert */
  contentId: Scalars["ID"]
  /** The heartbeat rate in seconds */
  heartbeatRate: Scalars["Int"]
  /** Playback position in seconds */
  mark: Scalars["Int"]
}

export type RecordPlaybackProgressInputV2 = {
  /** Client identifier */
  client: Client
  /** Information on the device the client is running on */
  clientDevice: Scalars["String"]
  /** Client Unix timestamp in seconds */
  clientTimestamp: Scalars["Int"]
  /** Client version */
  clientVersion: Scalars["String"]
  /** id of the container context: Album (for Track), EditorialPlaylist (for Track), Concert (for PerformanceWork), or Video (for standalone Video) */
  containerId: Scalars["ID"]
  /** id of a Track, Video, or PerformanceWork to track playback for */
  contentId: Scalars["ID"]
  /** The heartbeat rate in seconds */
  heartbeatRate: Scalars["Int"]
  /** Playback position in seconds */
  mark: Scalars["Int"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type RecordPlaybackProgressPayload = {
  __typename: "RecordPlaybackProgressPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<PlaybackProgress>
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type RecordPlaybackProgressPayloadV2 = {
  __typename: "RecordPlaybackProgressPayloadV2"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<PlaybackProgressV2>
}

export const RecordingSetting = {
  Live: "LIVE",
  Studio: "STUDIO",
  Unknown: "UNKNOWN",
} as const

export type RecordingSetting =
  (typeof RecordingSetting)[keyof typeof RecordingSetting]
/** Payload of this mutation - contains either a result on success or a list of errors */
export type RedeemChurnPreventionOfferPayload = {
  __typename: "RedeemChurnPreventionOfferPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type RedeemETicketPayload = {
  __typename: "RedeemETicketPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<RedeemETicketResult>
}

export type RedeemETicketResult = {
  __typename: "RedeemETicketResult"
  /** Ticket generated from the code */
  ticket: Maybe<Ticket>
  /** Voucher used to redeem the ticket */
  voucher: Maybe<Voucher>
}

export type RegisterUserInput = {
  academicTitle: InputMaybe<Scalars["String"]>
  affiliateGroup: InputMaybe<Scalars["String"]>
  agreeToTos: Scalars["Boolean"]
  /** Optional unique and stable identifier for the device */
  clientDeviceId: InputMaybe<Scalars["String"]>
  country: InputMaybe<Scalars["String"]>
  /** An HMACSHA384 based JWT with `{"device_identifier": "<device_identifier>"}` payload. It has to contain the appropriate "kid" (Key ID) in the headers */
  deviceIdentifier: InputMaybe<Scalars["String"]>
  /** Identifier for the device used e.g. "Firefox 97 (macOS 12.2.1)" or "iPhone 13 (iOS 15.3.1) " */
  deviceInfo: Scalars["String"]
  email: Scalars["String"]
  externalAuth: InputMaybe<ExternalAuthInput>
  firstName: InputMaybe<Scalars["String"]>
  lastName: InputMaybe<Scalars["String"]>
  locale: Scalars["String"]
  /** Meta param that identifies a click conversion event https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc */
  metaFbc: InputMaybe<Scalars["String"]>
  /** Meta param that identifies the client that generated the conversion event https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc */
  metaFbp: InputMaybe<Scalars["String"]>
  /** User consent for meta tracking */
  metaTrackingAllowed: InputMaybe<Scalars["Boolean"]>
  /** User consent for mixpanel tracking */
  mixpanelTrackingAllowed: InputMaybe<Scalars["Boolean"]>
  /** Optional os identifier of the device */
  osId: InputMaybe<OsIdType>
  password: Scalars["String"]
  sendNewsletter: InputMaybe<Scalars["Boolean"]>
  title: InputMaybe<Scalars["String"]>
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type RegisterUserPayload = {
  __typename: "RegisterUserPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<UserAndToken>
}

export type RegistrationDataCheckResult = {
  __typename: "RegistrationDataCheckResult"
  emailLikelyValid: Maybe<Scalars["Boolean"]>
}

export type RemoveDeviceInput = {
  /** UUID of the device from the users device list */
  id: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type RemoveDeviceInputPayload = {
  __typename: "RemoveDeviceInputPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** UUID of the removed device */
  result: Maybe<Scalars["String"]>
}

export type RemoveFavoriteByContentIdInput = {
  /** id of favorited content e.g. an id of an album */
  contentId: Scalars["ID"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type RemoveFavoriteByContentIdPayload = {
  __typename: "RemoveFavoriteByContentIdPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type RemoveFavoriteByContentTypeInput = {
  contentType: StreamType
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type RemoveFavoriteByContentTypePayload = {
  __typename: "RemoveFavoriteByContentTypePayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type RemoveFavoriteByContentTypeV2Input = {
  contentType: FavoriteRemovalContentType
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type RemoveFavoriteByContentTypeV2Payload = {
  __typename: "RemoveFavoriteByContentTypeV2Payload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type RemoveFavoriteByIdInput = {
  /** id of a favorite */
  id: Scalars["ID"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type RemoveFavoriteByIdPayload = {
  __typename: "RemoveFavoriteByIdPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type RerunStream = {
  __typename: "RerunStream"
  publicationLevel: PublicationLevel
  streamType: StreamType
  url: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type ResendEmailConfirmationPayload = {
  __typename: "ResendEmailConfirmationPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type ResetAllPlaybackProgressInput = {
  contentType: InputMaybe<StreamType>
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type ResetAllPlaybackProgressPayload = {
  __typename: "ResetAllPlaybackProgressPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type ResetPasswordInput = {
  newPassword: Scalars["String"]
  token: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type ResetPasswordPayload = {
  __typename: "ResetPasswordPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type ResolveArticleIdResponse = {
  __typename: "ResolveArticleIdResponse"
  externalId: Scalars["String"]
}

export type Role = Node & {
  __typename: "Role"
  displayName: Scalars["String"]
  /** The ID of an object */
  id: Scalars["ID"]
  type: RoleType
}

export type RoleConnection = {
  __typename: "RoleConnection"
  edges: Array<RoleEdge>
  pageInfo: PageInfo
}

export type RoleEdge = {
  __typename: "RoleEdge"
  cursor: Scalars["String"]
  node: Role
}

export const RoleType = {
  Arrangement: "ARRANGEMENT",
  Author: "AUTHOR",
  ChorusMaster: "CHORUS_MASTER",
  Composer: "COMPOSER",
  Conductor: "CONDUCTOR",
  Director: "DIRECTOR",
  Engineer: "ENGINEER",
  InstrumentalSoloist: "INSTRUMENTAL_SOLOIST",
  Mixing: "MIXING",
  Orchestrator: "ORCHESTRATOR",
  Other: "OTHER",
  Production: "PRODUCTION",
  VocalSoloist: "VOCAL_SOLOIST",
} as const

export type RoleType = (typeof RoleType)[keyof typeof RoleType]
export type RootMutationType = {
  __typename: "RootMutationType"
  addFavorite: Maybe<AddFavoritePayload>
  /** Authorize a device for the current user - the device is added to the users list of devices */
  authorizeDeviceForUser: Maybe<AuthorizeDeviceForUserInputPayload>
  cancelStripeSubscription: Maybe<CancelSubscriptionPayload>
  changePassword: Maybe<ChangePasswordPayload>
  changeStripePaymentMethod: Maybe<ChangeStripePaymentMethodPayload>
  changeStripeSubscriptionPlan: Maybe<ChangeStripeSubscriptionPlanPayload>
  confirmPurchaseAmazon: Maybe<ConfirmPurchaseAmazonPayload>
  confirmPurchaseApple: Maybe<ConfirmPurchaseApplePayload>
  confirmPurchaseGoogle: Maybe<ConfirmPurchaseGooglePayload>
  confirmPurchaseSamsung: Maybe<ConfirmPurchaseSamsungPayload>
  consentTracking: Maybe<ConsentTrackingPayload>
  createGiftLink: Maybe<CreateGiftLinkPayload>
  /** Delete push token from user */
  deletePushToken: Maybe<DeletePushTokenPayload>
  deleteUser: Maybe<DeleteUserPayload>
  /** Deny an authorization request for the given device of the current user */
  denyDevice: Maybe<DenyDeviceInputPayload>
  generatePinCode: Maybe<GeneratePinCodePayload>
  /** Notify backend that user log out from app */
  logOutUser: Maybe<LogOutUserPayload>
  loginUserWithPinCode: Maybe<LoginUserWithPinCodePayload>
  reactivateStripeSubscription: Maybe<ReactivateSubscriptionPayload>
  /** @deprecated Use `recordPlaybackProgressV2` */
  recordPlaybackProgress: Maybe<RecordPlaybackProgressPayload>
  recordPlaybackProgressV2: Maybe<RecordPlaybackProgressPayloadV2>
  redeemChurnPreventionOffer: Maybe<RedeemChurnPreventionOfferPayload>
  redeemETicketCode: Maybe<RedeemETicketPayload>
  registerUser: Maybe<RegisterUserPayload>
  /** Remove a previously authorized device of the current user */
  removeDevice: Maybe<RemoveDeviceInputPayload>
  /** Remove a favorite by the id of the favorited content, eg. `album_xxx` */
  removeFavoriteByContentId: Maybe<RemoveFavoriteByContentIdPayload>
  /**
   * Removes ALL favorites of a content type at once
   * @deprecated Use `remove_favorite_by_content_type_v2`
   */
  removeFavoriteByContentType: Maybe<RemoveFavoriteByContentTypePayload>
  /** Removes ALL favorites of a content type at once */
  removeFavoriteByContentTypeV2: Maybe<RemoveFavoriteByContentTypeV2Payload>
  /** Remove the favorite by its own id, eg. `favorite_xxx` */
  removeFavoriteById: Maybe<RemoveFavoriteByIdPayload>
  resendEmailConfirmation: Maybe<ResendEmailConfirmationPayload>
  resetAllPlaybackProgress: Maybe<ResetAllPlaybackProgressPayload>
  resetPassword: Maybe<ResetPasswordPayload>
  sendChangeEmailAddressEmail: Maybe<SendChangeEmailAddressEmailPayload>
  sendResetPasswordEmail: Maybe<SendResetPasswordEmailPayload>
  setCancelationReason: Maybe<SetCancelationReasonPayload>
  setupProductPurchase: Maybe<SetupProductPurchasePayload>
  subscribeDgNewsletter: Maybe<SubscribeDgNewsletterPayload>
  subscribeStagePlusEmailNotification: Maybe<SubscribeStagePlusEmailNotificationPayload>
  subscribeViaStripe: Maybe<SubscribeViaStripePayload>
  subscribeViaStripeV2: Maybe<SubscribeViaStripeV2Payload>
  switchLiveConcertReminder: Maybe<SwitchLiveConcertReminderPayload>
  updateCollectAddress: Maybe<UpdateCollectAddressPayload>
  /** Register device for push notification and update device info */
  updateDevice: Maybe<UpdateDeviceInputPayload>
  updateNewsletterInfo: Maybe<UpdateNewsletterInfoPayload>
  /** @deprecated Use updateShippingAddress instead */
  updatePostalAddress: Maybe<UpdatePostalAddressPayload>
  updateShippingAddress: Maybe<UpdateShippingAddressPayload>
  updateTrackingInformation: Maybe<UpdateTrackingInformationPayload>
  updateUser: Maybe<UpdateUserPayload>
}

export type RootMutationTypeAddFavoriteArgs = {
  input: InputMaybe<AddFavoriteInput>
}

export type RootMutationTypeAuthorizeDeviceForUserArgs = {
  input: InputMaybe<AuthorizeDeviceForUserInput>
}

export type RootMutationTypeChangePasswordArgs = {
  input: InputMaybe<ChangePasswordInput>
}

export type RootMutationTypeChangeStripeSubscriptionPlanArgs = {
  input: InputMaybe<ChangeStripeSubscriptionPlanInput>
}

export type RootMutationTypeConfirmPurchaseAmazonArgs = {
  input: InputMaybe<ConfirmPurchaseAmazonInput>
}

export type RootMutationTypeConfirmPurchaseAppleArgs = {
  input: InputMaybe<ConfirmPurchaseAppleInput>
}

export type RootMutationTypeConfirmPurchaseGoogleArgs = {
  input: InputMaybe<ConfirmPurchaseGoogleInput>
}

export type RootMutationTypeConfirmPurchaseSamsungArgs = {
  input: InputMaybe<ConfirmPurchaseSamsungInput>
}

export type RootMutationTypeConsentTrackingArgs = {
  input: InputMaybe<ConsentTrackingInput>
}

export type RootMutationTypeCreateGiftLinkArgs = {
  input: CreateGiftLinkInput
}

export type RootMutationTypeDeletePushTokenArgs = {
  input: InputMaybe<DeletePushTokenInput>
}

export type RootMutationTypeDenyDeviceArgs = {
  input: InputMaybe<DenyDeviceInput>
}

export type RootMutationTypeLogOutUserArgs = {
  input: InputMaybe<LogOutUserInput>
}

export type RootMutationTypeLoginUserWithPinCodeArgs = {
  input: InputMaybe<LoginUserWithPinCodeInput>
}

export type RootMutationTypeRecordPlaybackProgressArgs = {
  input: InputMaybe<RecordPlaybackProgressInput>
}

export type RootMutationTypeRecordPlaybackProgressV2Args = {
  input: RecordPlaybackProgressInputV2
}

export type RootMutationTypeRedeemETicketCodeArgs = {
  code: Scalars["String"]
}

export type RootMutationTypeRegisterUserArgs = {
  input: InputMaybe<RegisterUserInput>
}

export type RootMutationTypeRemoveDeviceArgs = {
  input: InputMaybe<RemoveDeviceInput>
}

export type RootMutationTypeRemoveFavoriteByContentIdArgs = {
  input: InputMaybe<RemoveFavoriteByContentIdInput>
}

export type RootMutationTypeRemoveFavoriteByContentTypeArgs = {
  input: InputMaybe<RemoveFavoriteByContentTypeInput>
}

export type RootMutationTypeRemoveFavoriteByContentTypeV2Args = {
  input: InputMaybe<RemoveFavoriteByContentTypeV2Input>
}

export type RootMutationTypeRemoveFavoriteByIdArgs = {
  input: InputMaybe<RemoveFavoriteByIdInput>
}

export type RootMutationTypeResetAllPlaybackProgressArgs = {
  input: InputMaybe<ResetAllPlaybackProgressInput>
}

export type RootMutationTypeResetPasswordArgs = {
  input: InputMaybe<ResetPasswordInput>
}

export type RootMutationTypeSendChangeEmailAddressEmailArgs = {
  input: InputMaybe<SendChangeEmailAddressEmailInput>
}

export type RootMutationTypeSendResetPasswordEmailArgs = {
  input: InputMaybe<SendResetPasswordEmailInput>
}

export type RootMutationTypeSetCancelationReasonArgs = {
  input: InputMaybe<SetCancelationReasonInput>
}

export type RootMutationTypeSetupProductPurchaseArgs = {
  input: InputMaybe<SetupProductPurchaseInput>
}

export type RootMutationTypeSubscribeDgNewsletterArgs = {
  input: InputMaybe<SubscribeDgNewsletterInput>
}

export type RootMutationTypeSubscribeViaStripeArgs = {
  input: InputMaybe<SubscribeViaStripeInput>
}

export type RootMutationTypeSubscribeViaStripeV2Args = {
  input: InputMaybe<SubscribeViaStripeInput>
}

export type RootMutationTypeSwitchLiveConcertReminderArgs = {
  input: InputMaybe<SwitchLiveConcertReminderInput>
}

export type RootMutationTypeUpdateCollectAddressArgs = {
  input: InputMaybe<UpdateCollectAddressInput>
}

export type RootMutationTypeUpdateDeviceArgs = {
  input: InputMaybe<UpdateDeviceInput>
}

export type RootMutationTypeUpdateNewsletterInfoArgs = {
  input: InputMaybe<UpdateNewsletterInfoInput>
}

export type RootMutationTypeUpdatePostalAddressArgs = {
  input: InputMaybe<UpdatePostalAddressInput>
}

export type RootMutationTypeUpdateShippingAddressArgs = {
  input: InputMaybe<UpdateShippingAddressInput>
}

export type RootMutationTypeUpdateTrackingInformationArgs = {
  input: InputMaybe<UpdateTrackingInformationInput>
}

export type RootMutationTypeUpdateUserArgs = {
  input: InputMaybe<UpdateUserInput>
}

export type RootQueryType = {
  __typename: "RootQueryType"
  album: Maybe<Album>
  albums: Maybe<AlbumConnection>
  /** Get current application configuration */
  applicationConfig: Maybe<ApplicationConfig>
  /** Returns a list of recent Klassikakzente blog article links */
  articles: Array<BlogArticleLink>
  artist: Maybe<Artist>
  artists: Maybe<ArtistConnection>
  cancelationReasons: Array<Scalars["String"]>
  checkChurnPreventionOffer: Maybe<CheckChurnPreventionOfferPayload>
  checkETicketCode: Maybe<CheckETicketPayload>
  checkRegistrationData: Maybe<RegistrationDataCheckResult>
  countries: Array<Country>
  /** @deprecated Old query with enum args. Curated Content can now be created editorially. Use `curatedContentPage` instead. */
  curatedContent: CuratedContent
  curatedContentPage: CuratedContent
  currentUser: Maybe<User>
  editorialPlaylist: Maybe<EditorialPlaylist>
  epoch: Maybe<Epoch>
  epochs: Maybe<EpochConnection>
  favoriteByContentId: Maybe<Favorite>
  favoritesByVodConcertId: Maybe<Array<Maybe<Favorite>>>
  genre: Maybe<Genre>
  genres: Maybe<GenreConnection>
  geoinfo: Maybe<GeoinfoPayload>
  group: Maybe<Group>
  groups: Maybe<GroupConnection>
  listLiveConcertReminders: Maybe<Array<Maybe<LiveConcertReminder>>>
  liveConcert: Maybe<LiveConcert>
  liveConcertReminder: Maybe<Array<Maybe<LiveConcertReminder>>>
  liveConcerts: Maybe<LiveConcertConnection>
  mondiaTokenProductDetails: MondiaTokenProductDetails
  news: Maybe<Article>
  newsArticles: Maybe<ArticleConnection>
  node: Maybe<Node>
  partner: Maybe<Partner>
  partners: Maybe<PartnerConnection>
  playbackProgressByContentId: Maybe<PlaybackProgress>
  previewSubscriptionPlanStripe: SubscriptionPlanPreviewStripe
  productPurchaseStatus: Maybe<ProductPurchaseStatus>
  productsStripe: Array<ProductStripe>
  /** Returns a list of provinces of the specified country */
  provinces: Array<Province>
  resolveArticleId: ResolveArticleIdResponse
  role: Maybe<Role>
  roles: Maybe<RoleConnection>
  schemaVersion: Scalars["Int"]
  searchByFacetType: Maybe<SearchByFacetTypeResult>
  searchByFacetValue: Maybe<SearchByFacetValueResult>
  /** Only used by SmartTV-devices as they have too little resources for on device-processing. Do not use with with search-as-you-type-searches as the performance would not be good enough. */
  searchByText: Maybe<SearchByTextResult>
  slider: Maybe<Slider>
  specialOffers: Maybe<SpecialOfferResult>
  subscriptionPlansAmazon: Array<SubscriptionPlanAmazon>
  subscriptionPlansApple: Array<SubscriptionPlanApple>
  subscriptionPlansGoogle: Array<SubscriptionPlanGoogle>
  subscriptionPlansSamsung: Array<SubscriptionPlanSamsung>
  subscriptionPlansStripe: SubscriptionPlansStripe
  userGiftLinkQuota: Maybe<UserGiftLinkQuota>
  video: Maybe<Video>
  videos: VideoConnection
  vodConcert: Maybe<VodConcert>
  vodConcerts: Maybe<VodConcertConnection>
  work: Maybe<Work>
}

export type RootQueryTypeAlbumArgs = {
  id: Scalars["ID"]
}

export type RootQueryTypeAlbumsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type RootQueryTypeArtistArgs = {
  id: Scalars["ID"]
}

export type RootQueryTypeArtistsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
  role: InputMaybe<RoleType>
}

export type RootQueryTypeCheckETicketCodeArgs = {
  code: Scalars["String"]
}

export type RootQueryTypeCheckRegistrationDataArgs = {
  input: CheckRegistrationDataInput
}

export type RootQueryTypeCuratedContentArgs = {
  slug: CuratedContentSlug
}

export type RootQueryTypeCuratedContentPageArgs = {
  slug: Scalars["String"]
}

export type RootQueryTypeEditorialPlaylistArgs = {
  id: Scalars["ID"]
}

export type RootQueryTypeEpochArgs = {
  id: Scalars["ID"]
}

export type RootQueryTypeEpochsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type RootQueryTypeFavoriteByContentIdArgs = {
  contentId: Scalars["ID"]
}

export type RootQueryTypeFavoritesByVodConcertIdArgs = {
  contentId: Scalars["ID"]
}

export type RootQueryTypeGenreArgs = {
  id: Scalars["ID"]
}

export type RootQueryTypeGenresArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type RootQueryTypeGeoinfoArgs = {
  ip: InputMaybe<Scalars["String"]>
}

export type RootQueryTypeGroupArgs = {
  id: Scalars["ID"]
}

export type RootQueryTypeGroupsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type RootQueryTypeLiveConcertArgs = {
  id: Scalars["ID"]
}

export type RootQueryTypeLiveConcertReminderArgs = {
  liveConcertId: Scalars["ID"]
}

export type RootQueryTypeLiveConcertsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type RootQueryTypeMondiaTokenProductDetailsArgs = {
  input: MondiaTokenProductDetailsInput
}

export type RootQueryTypeNewsArgs = {
  id: Scalars["ID"]
}

export type RootQueryTypeNewsArticlesArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type RootQueryTypeNodeArgs = {
  id: Scalars["ID"]
}

export type RootQueryTypePartnerArgs = {
  id: Scalars["ID"]
}

export type RootQueryTypePartnersArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
  type: InputMaybe<PartnerType>
}

export type RootQueryTypePlaybackProgressByContentIdArgs = {
  contentId: Scalars["ID"]
}

export type RootQueryTypePreviewSubscriptionPlanStripeArgs = {
  productId: Scalars["String"]
}

export type RootQueryTypeProductPurchaseStatusArgs = {
  purchaseId: InputMaybe<Scalars["String"]>
}

export type RootQueryTypeProvincesArgs = {
  countryCode: Scalars["String"]
}

export type RootQueryTypeResolveArticleIdArgs = {
  kaId: Scalars["Int"]
}

export type RootQueryTypeRoleArgs = {
  id: Scalars["ID"]
}

export type RootQueryTypeRolesArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type RootQueryTypeSearchByFacetTypeArgs = {
  input: InputMaybe<SearchByFacetTypeInput>
}

export type RootQueryTypeSearchByFacetValueArgs = {
  input: InputMaybe<SearchByFacetValueInput>
}

export type RootQueryTypeSearchByTextArgs = {
  input: InputMaybe<SearchByTextInput>
}

export type RootQueryTypeSliderArgs = {
  id: Scalars["ID"]
}

export type RootQueryTypeSubscriptionPlansStripeArgs = {
  couponCode: InputMaybe<Scalars["String"]>
}

export type RootQueryTypeVideoArgs = {
  id: Scalars["ID"]
}

export type RootQueryTypeVideosArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type RootQueryTypeVodConcertArgs = {
  id: Scalars["ID"]
}

export type RootQueryTypeVodConcertsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type RootQueryTypeWorkArgs = {
  id: Scalars["ID"]
}

export type SearchAlbum = {
  __typename: "SearchAlbum"
  albumTracks: Array<Maybe<Scalars["String"]>>
  albumWorks: Array<Maybe<Scalars["String"]>>
  artists: Array<Maybe<Scalars["String"]>>
  artistsAndGroups: Scalars["String"]
  id: Scalars["String"]
  images: Array<Maybe<SearchImage>>
  title: Scalars["String"]
}

export type SearchAlbumsResult = {
  __typename: "SearchAlbumsResult"
  items: Array<SearchAlbum>
  totalResults: Scalars["Int"]
}

export type SearchArtist = {
  __typename: "SearchArtist"
  id: Scalars["String"]
  images: Array<SearchImage>
  name: Scalars["String"]
  roles: Array<Maybe<Scalars["String"]>>
  sortName: Scalars["String"]
}

export type SearchArtistsResult = {
  __typename: "SearchArtistsResult"
  items: Array<SearchArtist>
  totalResults: Scalars["Int"]
}

export type SearchByFacetTypeInput = {
  facetType: FacetType
  /** Only return facets with a minimum of 'minContentItems' content items. */
  minContentItems: InputMaybe<Scalars["Int"]>
}

export type SearchByFacetTypeResult = {
  __typename: "SearchByFacetTypeResult"
  /** The sections for this facet, sorted by glyphs. */
  sections: Array<SearchByFacetTypeSection>
}

export type SearchByFacetTypeSection = {
  __typename: "SearchByFacetTypeSection"
  glyph: Scalars["String"]
  /** The items in this section, sorted by their normalized sort name (Unicode Normalization Form D, stripped of non-whitelisted characters). Should be displayed in exactly this order in the client. */
  items: Array<SearchGlyphItem>
}

export type SearchByFacetValueInput = {
  facetType: FacetType
  facetValue: Scalars["String"]
}

export type SearchByFacetValueResult = {
  __typename: "SearchByFacetValueResult"
  albums: SearchAlbumsResult
  artists: SearchArtistsResult
  documentaries: SearchVideosResult
  editorialPlaylists: SearchEditorialPlaylistsResult
  groups: SearchGroupsResult
  id: Scalars["String"]
  imageUrl: Scalars["String"]
  interviews: SearchVideosResult
  liveConcerts: SearchLiveConcertsResult
  partners: SearchPartnersResult
  shorts: SearchVideosResult
  subtitle: Scalars["String"]
  title: Scalars["String"]
  vodConcerts: SearchVodConcertsResult
}

export type SearchByFacetValueResultAlbumsArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByFacetValueResultArtistsArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByFacetValueResultDocumentariesArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByFacetValueResultEditorialPlaylistsArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByFacetValueResultGroupsArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByFacetValueResultInterviewsArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByFacetValueResultLiveConcertsArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByFacetValueResultPartnersArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByFacetValueResultShortsArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByFacetValueResultVodConcertsArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByTextInput = {
  text: Scalars["String"]
}

export type SearchByTextResult = {
  __typename: "SearchByTextResult"
  albums: SearchAlbumsResult
  artists: SearchArtistsResult
  documentaries: SearchVideosResult
  editorialPlaylists: SearchEditorialPlaylistsResult
  groups: SearchGroupsResult
  interviews: SearchVideosResult
  liveConcerts: SearchLiveConcertsResult
  partners: SearchPartnersResult
  shorts: SearchVideosResult
  vodConcerts: SearchVodConcertsResult
}

export type SearchByTextResultAlbumsArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByTextResultArtistsArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByTextResultDocumentariesArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByTextResultEditorialPlaylistsArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByTextResultGroupsArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByTextResultInterviewsArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByTextResultLiveConcertsArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByTextResultPartnersArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByTextResultShortsArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchByTextResultVodConcertsArgs = {
  first: InputMaybe<Scalars["Int"]>
  offset: InputMaybe<Scalars["Int"]>
}

export type SearchConfig = {
  __typename: "SearchConfig"
  /** Attributes to retrieve from Algolia */
  attributesToRetrieve: Array<Scalars["String"]>
  /** Available facet types for search */
  facetTypes: Array<Scalars["String"]>
  /** Fields to include in the search response */
  responseFields: Array<Scalars["String"]>
}

export type SearchEditorialPlaylist = {
  __typename: "SearchEditorialPlaylist"
  artists: Array<Maybe<Scalars["String"]>>
  description: Scalars["String"]
  id: Scalars["String"]
  images: Array<SearchImage>
  title: Scalars["String"]
  typeDisplayName: Scalars["String"]
}

export type SearchEditorialPlaylistsResult = {
  __typename: "SearchEditorialPlaylistsResult"
  items: Array<SearchEditorialPlaylist>
  totalResults: Scalars["Int"]
}

export type SearchGlyphItem = {
  __typename: "SearchGlyphItem"
  count: Scalars["Int"]
  id: Scalars["String"]
  label: Scalars["String"]
}

export type SearchGroup = {
  __typename: "SearchGroup"
  id: Scalars["String"]
  images: Array<SearchImage>
  name: Scalars["String"]
  subtype: Scalars["String"]
}

export type SearchGroupsResult = {
  __typename: "SearchGroupsResult"
  items: Array<SearchGroup>
  totalResults: Scalars["Int"]
}

export type SearchImage = {
  __typename: "SearchImage"
  type: Scalars["String"]
  url: Scalars["String"]
}

export type SearchLiveConcert = {
  __typename: "SearchLiveConcert"
  artists: Array<Maybe<Scalars["String"]>>
  endDate: Scalars["String"]
  finalEndTime: Scalars["String"]
  geoAccessCountries: Array<Maybe<Scalars["String"]>>
  geoAccessMode: Scalars["String"]
  id: Scalars["String"]
  images: Array<Maybe<SearchImage>>
  liveConcertType: Scalars["String"]
  partners: Array<Maybe<Scalars["String"]>>
  plannedForVod: Scalars["Boolean"]
  publicationLevel: Scalars["String"]
  startDate: Scalars["String"]
  subtitle: Scalars["String"]
  title: Scalars["String"]
  typeDisplayName: Scalars["String"]
}

export type SearchLiveConcertsResult = {
  __typename: "SearchLiveConcertsResult"
  items: Array<SearchLiveConcert>
  totalResults: Scalars["Int"]
}

export type SearchPartner = {
  __typename: "SearchPartner"
  description: Scalars["String"]
  id: Scalars["String"]
  images: Array<SearchImage>
  name: Scalars["String"]
  partnerSubtype: Scalars["String"]
  partnerType: Scalars["String"]
}

export type SearchPartnersResult = {
  __typename: "SearchPartnersResult"
  items: Array<SearchPartner>
  totalResults: Scalars["Int"]
}

export type SearchVideo = {
  __typename: "SearchVideo"
  artists: Array<Maybe<Scalars["String"]>>
  duration: Scalars["Int"]
  geoAccessCountries: Array<Maybe<Scalars["String"]>>
  geoAccessMode: Scalars["String"]
  id: Scalars["String"]
  images: Array<Maybe<SearchImage>>
  publicationLevel: Scalars["String"]
  subtitle: Scalars["String"]
  title: Scalars["String"]
  typeDisplayName: Scalars["String"]
  videoType: Scalars["String"]
}

export type SearchVideosResult = {
  __typename: "SearchVideosResult"
  items: Array<SearchVideo>
  totalResults: Scalars["Int"]
}

export type SearchVodConcert = {
  __typename: "SearchVodConcert"
  artists: Array<Maybe<Scalars["String"]>>
  duration: Scalars["Int"]
  geoAccessCountries: Array<Maybe<Scalars["String"]>>
  geoAccessMode: Scalars["String"]
  id: Scalars["String"]
  images: Array<Maybe<SearchImage>>
  partners: Array<Maybe<Scalars["String"]>>
  publicationLevel: Scalars["String"]
  subtitle: Scalars["String"]
  title: Scalars["String"]
  typeDisplayName: Scalars["String"]
  vodConcertType: Scalars["String"]
  works: Array<Maybe<Scalars["String"]>>
}

export type SearchVodConcertsResult = {
  __typename: "SearchVodConcertsResult"
  items: Array<SearchVodConcert>
  totalResults: Scalars["Int"]
}

export type SendChangeEmailAddressEmailInput = {
  newEmail: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type SendChangeEmailAddressEmailPayload = {
  __typename: "SendChangeEmailAddressEmailPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type SendResetPasswordEmailInput = {
  email: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type SendResetPasswordEmailPayload = {
  __typename: "SendResetPasswordEmailPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type SetCancelationReasonInput = {
  other: InputMaybe<Scalars["String"]>
  reasons: InputMaybe<Array<InputMaybe<Scalars["String"]>>>
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type SetCancelationReasonPayload = {
  __typename: "SetCancelationReasonPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type SetupIntentClientSecret = {
  __typename: "SetupIntentClientSecret"
  clientSecret: Scalars["String"]
}

export type SetupProductPurchase = {
  __typename: "SetupProductPurchase"
  paymentIntent: Maybe<Scalars["String"]>
  purchaseId: Scalars["String"]
  url: Maybe<Scalars["String"]>
}

export type SetupProductPurchaseInput = {
  priceId: Scalars["String"]
  successUrl: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type SetupProductPurchasePayload = {
  __typename: "SetupProductPurchasePayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<SetupProductPurchase>
}

export type Slider = Node & {
  __typename: "Slider"
  headline: Scalars["String"]
  /** The ID of an object */
  id: Scalars["ID"]
  /** @deprecated use sliderItems instead */
  items: Maybe<NodeConnectionConnection>
  layout: Maybe<SliderLayout>
  sliderItems: Maybe<SliderItemConnection>
}

export type SliderItemsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  by?: InputMaybe<ItemSortOrder>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type SliderSliderItemsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  by?: InputMaybe<ItemSortOrder>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type SliderItem =
  | Album
  | Artist
  | BlogArticleLink
  | CuratedContentLink
  | EditorialPlaylist
  | Epoch
  | Favorite
  | Genre
  | Group
  | LiveConcert
  | Partner
  | Playback
  | PlaybackProgress
  | Video
  | VodConcert
  | Work

export type SliderItemConnection = {
  __typename: "SliderItemConnection"
  edges: Array<SliderItemEdge>
  pageInfo: PageInfo
  /** The maximum publication_level of all items in this content container */
  publicationLevel: Maybe<PublicationLevel>
  totalResults: Scalars["Int"]
}

export type SliderItemEdge = {
  __typename: "SliderItemEdge"
  cursor: Scalars["String"]
  node: SliderItem
}

export const SliderLayout = {
  /** Navigation slider for curated content pages */
  Navigation: "NAVIGATION",
  /** Standard slider presentation */
  Regular: "REGULAR",
  /** Top10 chart presentation with rankings */
  WeeklyTop10: "WEEKLY_TOP10",
} as const

export type SliderLayout = (typeof SliderLayout)[keyof typeof SliderLayout]
export type SliderLayoutSizeOverrideInput = {
  /** Target slider layout */
  layout: SliderLayout
  /** Requested page size for this layout */
  pageSize: Scalars["Int"]
}

export type SliderSizeOverridesInput = {
  byLayout: InputMaybe<Array<SliderLayoutSizeOverrideInput>>
  byType: InputMaybe<Array<SliderTypenameSizeOverrideInput>>
}

export type SliderTypenameSizeOverrideInput = {
  /** Requested page size for this typename */
  pageSize: Scalars["Int"]
  /** Target GraphQL item typename (e.g. Album) */
  typename: Scalars["String"]
}

export const SortDirection = {
  Asc: "ASC",
  Desc: "DESC",
} as const

export type SortDirection = (typeof SortDirection)[keyof typeof SortDirection]
export type SpecialOfferResult = {
  __typename: "SpecialOfferResult"
  /** Stripe coupon code that the user is eligible for. The coupon code can be pre-applied to the tickets page */
  stripeCoupon: Maybe<Scalars["String"]>
}

export type StageItem = {
  __typename: "StageItem"
  /** The referenced item. Possible Types: `VodConcert`, `LiveConcert`, `Artist`, `Album`, `Video` */
  item: StageItemContent
  /**
   * An *optional* `label` override, like 'New in Archive'. Clients can decide to display this based on context
   * instead of some information from the referenced content. The label will always be returned in caps.
   */
  label: Maybe<Scalars["String"]>
  /**
   * An *optional* `subtitle` override. Clients should display this instead of the title from
   * the referenced content. Note: It is not guaranteed that all referenced content has subtitles.
   */
  subtitle: Maybe<Scalars["String"]>
  /**
   * An *optional* `title` override. Clients should display this instead of the title from
   * the referenced content.
   */
  title: Maybe<Scalars["String"]>
}

export type StageItemContent = Album | Artist | LiveConcert | Video | VodConcert

export type StageItemContentV2 =
  | Album
  | Artist
  | EditorialPlaylist
  | Group
  | LiveConcert
  | Partner
  | Video
  | VodConcert

export type StageItemV2 = {
  __typename: "StageItemV2"
  /** The referenced item. Possible Types: `VodConcert`, `LiveConcert`, `Artist`, `Album`, `Video`, `Group`, `Partner`, `EditorialPlaylist` */
  item: StageItemContentV2
  /**
   * An *optional* `label` override, like 'New in Archive'. Clients can decide to display this based on context
   * instead of some information from the referenced content. The label will always be returned in caps.
   */
  label: Maybe<Scalars["String"]>
  /**
   * An *optional* `subtitle` override. Clients should display this instead of the title from
   * the referenced content. Note: It is not guaranteed that all referenced content has subtitles.
   */
  subtitle: Maybe<Scalars["String"]>
  /**
   * An *optional* `title` override. Clients should display this instead of the title from
   * the referenced content.
   */
  title: Maybe<Scalars["String"]>
}

export type Stream = {
  __typename: "Stream"
  /** Url for potential 3D-Stream of this video. Will always be `null` for audio. */
  mvVideoUrl: Maybe<Scalars["String"]>
  publicationLevel: PublicationLevel
  streamType: StreamType
  url: Scalars["String"]
}

export const StreamManifestType = {
  HlsCombined: "HLS_COMBINED",
  HlsV2Combined: "HLS_V2_COMBINED",
  HlsV2MultichannelAudioOnly: "HLS_V2_MULTICHANNEL_AUDIO_ONLY",
  HlsV2MultichannelVideo: "HLS_V2_MULTICHANNEL_VIDEO",
  HlsV2StereoAudioOnly: "HLS_V2_STEREO_AUDIO_ONLY",
  HlsV2StereoVideo: "HLS_V2_STEREO_VIDEO",
  StereoscopicHlsCombined: "STEREOSCOPIC_HLS_COMBINED",
} as const

export type StreamManifestType =
  (typeof StreamManifestType)[keyof typeof StreamManifestType]
export const StreamType = {
  Audio: "AUDIO",
  Video: "VIDEO",
} as const

export type StreamType = (typeof StreamType)[keyof typeof StreamType]
export type StreamVariant = {
  __typename: "StreamVariant"
  /** ONLY `HLS_COMBINED` is guaranteed to be present on all assets. Manifest types are versioned. */
  manifestType: StreamManifestType
  publicationLevel: PublicationLevel
  streamType: StreamType
  url: Scalars["String"]
}

export type StripeBillingInfo = {
  __typename: "StripeBillingInfo"
  /** May be 0 when still in trial */
  amount: Scalars["Int"]
  /** Original price of the product with no discounts applied */
  amountUndiscounted: Scalars["Int"]
  /** May be null when out of the trial phase */
  billedFirstAt: Maybe<Scalars["DateTime"]>
  /** May be null when a ticket is canceled */
  billedNextAt: Maybe<Scalars["DateTime"]>
  /**
   * May be null when card info is not available (different form of payment)
   * @deprecated replaced by field paymentMethod with union type
   */
  card: Maybe<StripeCard>
  currency: Scalars["String"]
  /** Payment method used - may be null when no payment method attached yet */
  paymentMethod: Maybe<StripePaymentMethod>
}

export type StripeCard = {
  __typename: "StripeCard"
  /** Card brand. Can be amex, diners, discover, jcb, mastercard, unionpay, visa, or unknown. */
  brand: Scalars["String"]
  country: Scalars["String"]
  /** Two-digit number representing the card’s expiration month. */
  expMonth: Scalars["Int"]
  /** Four-digit number representing the card’s expiration year. */
  expYear: Scalars["Int"]
  /** Card funding type. Can be credit, debit, prepaid, or unknown. */
  funding: Scalars["String"]
  /** The last four digits of the card. */
  last4: Scalars["String"]
}

/** The Stripe client secret to pass into the Stripe JS form */
export type StripeClientSecret =
  | PaymentIntentClientSecret
  | SetupIntentClientSecret

export type StripeInvoice = {
  __typename: "StripeInvoice"
  billedAt: Scalars["DateTime"]
  currency: Scalars["String"]
  description: Scalars["String"]
  /** Discount as absolute number */
  discount: Maybe<Scalars["Int"]>
  number: Scalars["String"]
  pdfUrl: Scalars["String"]
  /** Total undiscounted */
  subtotal: Scalars["Int"]
  /** Actual total billed */
  total: Scalars["Int"]
}

export type StripeInvoiceCompact = {
  __typename: "StripeInvoiceCompact"
  billedAt: Scalars["DateTime"]
  currency: Scalars["String"]
  /** Discount as absolute number */
  discount: Maybe<Scalars["Int"]>
  /** Total undiscounted */
  subtotal: Scalars["Int"]
  /** Actual total billed */
  total: Scalars["Int"]
}

/** Payment method used - may be null when no payment method attached yet */
export type StripePaymentMethod =
  | StripePaymentMethodCard
  | StripePaymentMethodPaypal

export type StripePaymentMethodCard = {
  __typename: "StripePaymentMethodCard"
  /** Card brand. Can be amex, diners, discover, jcb, mastercard, unionpay, visa, or unknown. */
  brand: Scalars["String"]
  country: Scalars["String"]
  /** Two-digit number representing the card’s expiration month. */
  expMonth: Scalars["Int"]
  /** Four-digit number representing the card’s expiration year. */
  expYear: Scalars["Int"]
  /** Card funding type. Can be credit, debit, prepaid, or unknown. */
  funding: Scalars["String"]
  /** The last four digits of the card. */
  last4: Scalars["String"]
}

export type StripePaymentMethodPaypal = {
  __typename: "StripePaymentMethodPaypal"
  country: Scalars["String"]
  payerEmail: Scalars["String"]
  payerId: Scalars["String"]
}

export type StripeSubscription = {
  __typename: "StripeSubscription"
  /** Coupon metadata when a valid code was given and it was applied */
  coupon: Maybe<Coupon>
  /** Invoiced amount for the subscription */
  invoice: StripeInvoiceCompact
  stripeClientSecret: StripeClientSecret
  timeLimitedDiscountInfo: Maybe<StripeTimeLimitedDiscountInfo>
}

export type StripeTimeLimitedDiscountInfo = {
  __typename: "StripeTimeLimitedDiscountInfo"
  amount: Scalars["Int"]
  couponEndsAt: Scalars["DateTime"]
  durationInMonths: Scalars["Int"]
}

export type SubscribeDgNewsletterInput = {
  email: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type SubscribeDgNewsletterPayload = {
  __typename: "SubscribeDgNewsletterPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type SubscribeStagePlusEmailNotificationPayload = {
  __typename: "SubscribeStagePlusEmailNotificationPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type SubscribeViaStripeInput = {
  couponCode: InputMaybe<Scalars["String"]>
  priceId: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type SubscribeViaStripePayload = {
  __typename: "SubscribeViaStripePayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<StripeClientSecret>
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type SubscribeViaStripeV2Payload = {
  __typename: "SubscribeViaStripeV2Payload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<StripeSubscription>
}

export type SubscriptionCancelation = {
  __typename: "SubscriptionCancelation"
  ticketTerminatesAt: Scalars["DateTime"]
}

export type SubscriptionPlanAmazon = {
  __typename: "SubscriptionPlanAmazon"
  interval: SubscriptionPlanInterval
  /** Indicates if the current user can purchase this plan */
  isPurchasePossible: Scalars["Boolean"]
  productId: Scalars["String"]
  termSku: Scalars["String"]
  ticketType: Maybe<TicketType>
}

export type SubscriptionPlanApple = {
  __typename: "SubscriptionPlanApple"
  interval: SubscriptionPlanInterval
  /** Indicates if the current user can purchase this plan */
  isPurchasePossible: Scalars["Boolean"]
  productId: Scalars["String"]
}

export type SubscriptionPlanGoogle = {
  __typename: "SubscriptionPlanGoogle"
  interval: SubscriptionPlanInterval
  /** Indicates if the current user can purchase this plan */
  isPurchasePossible: Scalars["Boolean"]
  productId: Scalars["String"]
  ticketType: TicketType
}

export const SubscriptionPlanInterval = {
  Days_7: "DAYS_7",
  ETicket: "E_TICKET",
  Monthly: "MONTHLY",
  Yearly: "YEARLY",
} as const

export type SubscriptionPlanInterval =
  (typeof SubscriptionPlanInterval)[keyof typeof SubscriptionPlanInterval]
export type SubscriptionPlanPreviewStripe = {
  __typename: "SubscriptionPlanPreviewStripe"
  /** The date when the user is billed */
  billedNextAt: Scalars["DateTime"]
  /**
   * May be null when card info is not available (different form of payment)
   * @deprecated replaced by field paymentMethod with union type
   */
  card: Maybe<StripeCard>
  /** The billing currency */
  currency: Scalars["String"]
  /** The users current subscription plan price */
  currentPlan: SubscriptionPlanPriceStripe
  /** Payment method used - may be null when no payment method attached yet */
  paymentMethod: Maybe<StripePaymentMethod>
  /** Preview of the users subscription plan price */
  previewPlan: SubscriptionPlanPriceStripe
  /** The unix timestamp of the preview proration needed for plan change */
  prorationDate: Scalars["Int"]
  /** The start date of the new subscription */
  subscriptionStartsAt: Scalars["String"]
  /** The tax amount of the total */
  tax: Maybe<Scalars["Int"]>
  /** The tax percentage of the total */
  taxPercentage: Maybe<Scalars["Float"]>
  /** The total charged on the `billed_next_at` date */
  total: Scalars["Int"]
  /** The total excluding tax */
  totalExcludingTax: Scalars["Int"]
}

export type SubscriptionPlanPriceStripe = {
  __typename: "SubscriptionPlanPriceStripe"
  interval: SubscriptionPlanInterval
  price: Price
  productId: Scalars["String"]
}

export type SubscriptionPlanSamsung = {
  __typename: "SubscriptionPlanSamsung"
  interval: SubscriptionPlanInterval
  /** Indicates if the current user can purchase this plan */
  isPurchasePossible: Scalars["Boolean"]
  itemId: Scalars["String"]
  ticketType: TicketType
}

export type SubscriptionPlanStripe = {
  __typename: "SubscriptionPlanStripe"
  gift: Maybe<PurchaseProduct>
  interval: SubscriptionPlanInterval
  /** Indicates if the current user can change into this plan */
  isPlanChangeSupported: Scalars["Boolean"]
  /** Indicates if the current user can purchase this plan */
  isPurchasePossible: Scalars["Boolean"]
  /** The price for the current user */
  price: Price
  /** @deprecated Use `price` instead containing user's country based price */
  prices: Array<Price>
  productId: Scalars["String"]
  /** Indicates if a credit card or some other form of payment is required to subscribe */
  requiresPaymentMethod: Scalars["Boolean"]
  ticketType: TicketType
  trialPeriodDays: Scalars["Int"]
}

export type SubscriptionPlansStripe = {
  __typename: "SubscriptionPlansStripe"
  /** Coupon metadata when a valid code was given */
  coupon: Maybe<Coupon>
  plans: Array<SubscriptionPlanStripe>
}

export type SwitchLiveConcertReminderInput = {
  liveConcertId: Scalars["String"]
  remind: Scalars["Boolean"]
  rerunId: InputMaybe<Scalars["String"]>
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type SwitchLiveConcertReminderPayload = {
  __typename: "SwitchLiveConcertReminderPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type Ticket = {
  __typename: "Ticket"
  /** UUID that is also used to identify the order_id */
  id: Scalars["String"]
  /** Date when the subscription was started */
  insertedAt: Maybe<Scalars["DateTime"]>
  interval: SubscriptionPlanInterval
  /** Wether the current ticket is still in its trial period, will become false when the trial ends. */
  isTrial: Scalars["Boolean"]
  /** Wether the applied voucher is still active, will be false if the voucher already expired or if no voucher is present. */
  isVoucherActive: Scalars["Boolean"]
  /** Mondia-managed subscription details for the current ticket, when applicable. */
  mondiaSubscriptionManagementDetails: Maybe<MondiaSubscriptionManagementDetails>
  /** Payment method type e.g. card/paypal - currently Stripe only when a payment method has been attached to the subscription */
  paymentMethodType: Maybe<Scalars["String"]>
  paymentProvider: PaymentProvider
  status: TicketStatus
  /** NOTE: Please only query those fields when actually required, since we call the Stripe API for the data. */
  stripeBillingInfo: Maybe<StripeBillingInfo>
  ticketType: TicketType
  /** marks the date until when stream access will end */
  validUntil: Maybe<Scalars["DateTime"]>
  /** Duration of the applied voucher. The value can be forever or repeating */
  voucherDuration: Maybe<Scalars["String"]>
  /** Date when the applied voucher is expected to expire. This field is null when the duration is forever */
  voucherValidUntil: Maybe<Scalars["DateTime"]>
}

export const TicketStatus = {
  /** access to content is granted till validUntil, renews automatically. */
  Active: "ACTIVE",
  AwaitingPayment: "AWAITING_PAYMENT",
  /** either user canceled the subscription, access to content is granted till validUntil OR payments didn't recover in time / grace period expired, no access to content. */
  Canceled: "CANCELED",
  /** was canceled and then auto deleted because of not renewing or deleted by other reasons */
  Deleted: "DELETED",
  /** the last payment failed, access to content is granted till validUntil. */
  PaymentFailed: "PAYMENT_FAILED",
} as const

export type TicketStatus = (typeof TicketStatus)[keyof typeof TicketStatus]
export const TicketType = {
  ETicket: "E_TICKET",
  Free: "FREE",
  OneTimePurchase: "ONE_TIME_PURCHASE",
  Subscription: "SUBSCRIPTION",
} as const

export type TicketType = (typeof TicketType)[keyof typeof TicketType]
export type Track = Node & {
  __typename: "Track"
  album: Album
  /** Combined soloists and groups for display, comma-separated. Excludes performers that appear on every track in the album - those are shown at album level instead. May be null if all performers are common across tracks. */
  artistAndGroupDisplayInfo: Maybe<Scalars["String"]>
  /** Soloists (instrumental and vocal) credited on this track, comma-separated. Excludes soloists that appear on every track in the album (common artist filtering). Includes role name in parentheses. */
  artistDisplayInfo: Maybe<Scalars["String"]>
  /** All primary artists and groups credited on this track. Primary artists are performing/credited artists (soloists, conductors, ensembles) as opposed to production staff (producers, engineers). Unlike the *_display_info fields, no common artist filtering is applied - artists appearing on every track in the album are still included. */
  artistsAndGroups: Array<TrackArtistOrTrackGroup>
  bitDepth: Maybe<Scalars["Int"]>
  /** Composers of the work(s) on this track, derived from the root work level, comma-separated. Excludes composers common to all tracks on the album. */
  composerDisplayInfo: Maybe<Scalars["String"]>
  /** Conductors credited on this track, comma-separated. Excludes conductors that appear on every track in the album (common artist filtering). */
  conductorDisplayInfo: Maybe<Scalars["String"]>
  /** Duration of the track in seconds */
  duration: Scalars["Int"]
  /** Engineers credited on this track, comma-separated. Includes role name in parentheses. No common artist filtering applied. */
  engineerDisplayInfo: Maybe<Scalars["String"]>
  firstReleaseYear: Maybe<Scalars["Int"]>
  /** Musical groups/ensembles credited on this track, comma-separated. Excludes groups that appear on every track in the album (common artist filtering). */
  groupDisplayInfo: Maybe<Scalars["String"]>
  /** The ID of an object */
  id: Scalars["ID"]
  isrc: Maybe<Scalars["String"]>
  isrcSurround: Maybe<Scalars["String"]>
  /** Producers credited on this track, comma-separated. Includes role name in parentheses. No common artist filtering applied. */
  producerDisplayInfo: Maybe<Scalars["String"]>
  recordingCountry: Maybe<Scalars["String"]>
  recordingLocation: Maybe<Scalars["String"]>
  /** ISO 8601 formatted date. May be year or year/month only. */
  recordingSessionEnd: Maybe<Scalars["String"]>
  /** ISO 8601 formatted date. May be year or year/month only. */
  recordingSessionStart: Maybe<Scalars["String"]>
  recordingSetting: Maybe<RecordingSetting>
  sampleRate: Maybe<Scalars["Float"]>
  /**
   * The stream for the track
   * @deprecated Use `stream_variants` instead
   */
  stream: Stream
  /** The stream variants for the performance work */
  streamVariants: Array<StreamVariant>
  subtitle: Maybe<Scalars["String"]>
  technicalFormat: Maybe<Scalars["String"]>
  title: Scalars["String"]
  trackNumber: Scalars["Int"]
  /** The title of the work associated with this track from the track set. */
  workDisplayInfo: Maybe<Scalars["String"]>
}

export type TrackArtist = {
  __typename: "TrackArtist"
  id: Scalars["ID"]
  name: Scalars["String"]
  role: Role
}

export type TrackArtistOrTrackGroup = TrackArtist | TrackGroup

export type TrackGroup = {
  __typename: "TrackGroup"
  id: Scalars["ID"]
  name: Scalars["String"]
  type: GroupType
  typeDisplayName: Scalars["String"]
}

export type TrackSet = {
  __typename: "TrackSet"
  /** The artists associated with the work of the track set (will only be of type composer) */
  artists: Array<TrackSetArtist>
  /** The composer(s) of the work represented by this track set as comma-separated string. */
  composerDisplayInfo: Maybe<Scalars["String"]>
  /** The group(s) assembled from all tracks of this trackset as comma-separated string. */
  groupDisplayInfo: Maybe<Scalars["String"]>
  /** Title of the work represented by this track set. Can be empty for sub sets of a work (eg 2nd act) */
  title: Maybe<Scalars["String"]>
  trackSetNumber: Scalars["Int"]
  tracks: Array<Track>
}

export type TrackSetArtist = {
  __typename: "TrackSetArtist"
  id: Scalars["ID"]
  name: Scalars["String"]
  pictures: Array<Picture>
  role: Role
}

export const TrackingConsentType = {
  Allow: "ALLOW",
  Revoke: "REVOKE",
} as const

export type TrackingConsentType =
  (typeof TrackingConsentType)[keyof typeof TrackingConsentType]
export type TrackingMetadata = {
  __typename: "TrackingMetadata"
  userType: Maybe<Scalars["String"]>
}

export const TrackingServiceType = {
  Meta: "META",
  Mixpanel: "MIXPANEL",
} as const

export type TrackingServiceType =
  (typeof TrackingServiceType)[keyof typeof TrackingServiceType]
export type UpdateCollectAddressInput = {
  city: Scalars["String"]
  /** Must be valid ISO-3166 country code */
  country: Scalars["String"]
  district: InputMaybe<Scalars["String"]>
  firstLine: Scalars["String"]
  name: Scalars["String"]
  province: InputMaybe<Scalars["String"]>
  purchaseId: InputMaybe<Scalars["String"]>
  secondLine: InputMaybe<Scalars["String"]>
  zipCode: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type UpdateCollectAddressPayload = {
  __typename: "UpdateCollectAddressPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<CollectAddress>
}

export type UpdateDeviceInput = {
  deviceInfo: Scalars["String"]
  osId: OsIdType
  /** Device token for sending push notifications, not stored on backend */
  pushToken: Scalars["String"]
  timeZoneId: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type UpdateDeviceInputPayload = {
  __typename: "UpdateDeviceInputPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** Update device */
  result: Maybe<Device>
}

export type UpdateNewsletterInfoInput = {
  firstName: InputMaybe<Scalars["String"]>
  lastName: InputMaybe<Scalars["String"]>
  sendNewsletter: InputMaybe<Scalars["Boolean"]>
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type UpdateNewsletterInfoPayload = {
  __typename: "UpdateNewsletterInfoPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<User>
}

export type UpdatePostalAddressInput = {
  city: InputMaybe<Scalars["String"]>
  country: InputMaybe<Scalars["String"]>
  firstLine: InputMaybe<Scalars["String"]>
  secondLine: InputMaybe<Scalars["String"]>
  state: InputMaybe<Scalars["String"]>
  zipCode: InputMaybe<Scalars["String"]>
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type UpdatePostalAddressPayload = {
  __typename: "UpdatePostalAddressPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<PostalAddress>
}

export type UpdateShippingAddressInput = {
  city: Scalars["String"]
  /** Must be valid ISO-3166 country code */
  country: Scalars["String"]
  district: InputMaybe<Scalars["String"]>
  firstLine: Scalars["String"]
  province: InputMaybe<Scalars["String"]>
  secondLine: InputMaybe<Scalars["String"]>
  zipCode: Scalars["String"]
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type UpdateShippingAddressPayload = {
  __typename: "UpdateShippingAddressPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<PostalAddress>
}

export type UpdateTrackingInformationInput = {
  metaFbc: InputMaybe<Scalars["String"]>
  metaFbp: InputMaybe<Scalars["String"]>
  utmCampaign: InputMaybe<Scalars["String"]>
  utmContent: InputMaybe<Scalars["String"]>
  utmMedium: InputMaybe<Scalars["String"]>
  utmSource: InputMaybe<Scalars["String"]>
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type UpdateTrackingInformationPayload = {
  __typename: "UpdateTrackingInformationPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<Scalars["Boolean"]>
}

export type UpdateUserInput = {
  academicTitle: InputMaybe<Scalars["String"]>
  country: InputMaybe<Scalars["String"]>
  firstName: InputMaybe<Scalars["String"]>
  lastName: InputMaybe<Scalars["String"]>
  liveReminderEmail: InputMaybe<Scalars["Boolean"]>
  liveReminderPush: InputMaybe<Scalars["Boolean"]>
  locale: InputMaybe<Scalars["String"]>
  pushOptin: InputMaybe<Scalars["Boolean"]>
  sendNewsletter: InputMaybe<Scalars["Boolean"]>
  title: InputMaybe<Scalars["String"]>
}

/** Payload of this mutation - contains either a result on success or a list of errors */
export type UpdateUserPayload = {
  __typename: "UpdateUserPayload"
  /** A list of errors. Will be null if mutation succeeded. */
  errors: Maybe<Array<ApiError>>
  /** The object created/updated/deleted by the mutation. Will be null if mutation failed. */
  result: Maybe<User>
}

export type User = {
  __typename: "User"
  academicTitle: Maybe<Scalars["String"]>
  affiliateGroup: Maybe<Scalars["String"]>
  country: Scalars["String"]
  /** Every device that is connected to a user (via password grant or device auth grant */
  devices: Array<Device>
  email: Scalars["String"]
  emailVerified: Scalars["Boolean"]
  favorites: Maybe<FavoriteConnection>
  firstName: Scalars["String"]
  /** The user either used a trial period or has/had a paid ticket */
  hasTrialedBefore: Scalars["Boolean"]
  /** UUID that is also in the sub claim of the JWT */
  id: Scalars["String"]
  insertedAt: Scalars["DateTime"]
  isEligibleForGift: Scalars["Boolean"]
  /** @deprecated use is_trial on ticket instead */
  isOnTrial: Scalars["Boolean"]
  lastAuthenticatedAt: Maybe<Scalars["DateTime"]>
  lastName: Scalars["String"]
  liveReminderEmail: Scalars["Boolean"]
  liveReminderPush: Scalars["Boolean"]
  locale: Scalars["String"]
  playbacks: Maybe<PlaybackConnection>
  postalAddress: Maybe<PostalAddress>
  /** All previous inactive users subscriptions */
  previousTickets: Maybe<Array<Maybe<Ticket>>>
  pushOptin: Scalars["Boolean"]
  /** @deprecated Use playbacks instead */
  recentlyPlayed: Maybe<PlaybackProgressConnection>
  registrationCountry: Maybe<Scalars["String"]>
  sendNewsletter: Scalars["Boolean"]
  /** NOTE: Please only query those fields when actually required, since we call the Stripe API for the data. */
  stripeInvoices: Array<StripeInvoice>
  ticket: Maybe<Ticket>
  title: Maybe<Scalars["String"]>
  trackingMetadata: TrackingMetadata
  updatedAt: Scalars["DateTime"]
}

export type UserFavoritesArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  by?: InputMaybe<FavoriteOrdering>
  filter?: InputMaybe<FavoriteType>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type UserPlaybacksArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  by?: InputMaybe<PlaybackOrdering>
  filter?: InputMaybe<PlaybackType>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type UserRecentlyPlayedArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  by?: InputMaybe<PlaybackProgressOrdering>
  filter?: InputMaybe<PlaybackProgressType>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
}

export type UserAndToken = {
  __typename: "UserAndToken"
  accessToken: Scalars["String"]
  refreshToken: Scalars["String"]
  user: User
}

export type UserGiftLinkQuota = {
  __typename: "UserGiftLinkQuota"
  /** Number of gift links remaining */
  userRemainingQuota: Scalars["Int"]
}

export type ValidationError = ApiError & {
  __typename: "ValidationError"
  field: Scalars["String"]
  message: Scalars["String"]
  path: Array<Scalars["String"]>
  validation: Scalars["String"]
}

export type Video = Node & {
  __typename: "Video"
  /** Video is available from this date */
  archiveReleaseDate: Maybe<Scalars["DateTime"]>
  artists: Maybe<ArtistWithRoleConnection>
  copyright: Maybe<Scalars["String"]>
  courtesyOf: Maybe<Scalars["String"]>
  curatedContent: Array<CuratedContentContainerV2>
  description: Maybe<Scalars["String"]>
  /** The duration of the video in seconds. */
  duration: Scalars["Int"]
  /** Epochs derived from the video's work through its composers. If the video has a work assigned, returns epochs of all composers, ordered by epoch ID. Returns empty list if video has no work, or work has no composers with epochs. */
  epochsByRelevance: Array<Epoch>
  /** Genres ordered by relevance to this video based on the associated work. The first item is the primary genre. */
  genresByRelevance: Array<Genre>
  /** A list of countries used to evaluate the geoblocking of the stream delivery. */
  geoAccessCountries: Array<Scalars["String"]>
  /** Geo access mode mode. DENY=blocked in specified countries, ALLOW=allowed in specified countries */
  geoAccessMode: GeoAccessMode
  groups: Array<Group>
  /** The ID of an object */
  id: Scalars["ID"]
  isAtmos: Scalars["Boolean"]
  /** Always returns `false`. HDR-Content is currently not available, but might be in the future */
  isHdr: Scalars["Boolean"]
  isLossless: Scalars["Boolean"]
  isrc: Maybe<Scalars["String"]>
  licensor: Maybe<Scalars["String"]>
  maxResolution: MaxResolution
  metaDescription: Maybe<Scalars["String"]>
  metaTitle: Maybe<Scalars["String"]>
  photographer: Maybe<Scalars["String"]>
  pictures: Array<Picture>
  production: Maybe<Scalars["String"]>
  /** Production was finalized on this date */
  productionDate: Maybe<Scalars["Date"]>
  /** The level that is needed for a user to access the video-stream. U1=everyone, U2=needs account, U3=needs account + ticket */
  publicationLevel: PublicationLevel
  /** @deprecated Use curatedContent instead */
  sliders: Array<CuratedContentContainer>
  /**
   * The stream for the video
   * @deprecated Use `stream_variants` instead
   */
  stream: Stream
  /** The stream variants for the video */
  streamVariants: Array<StreamVariant>
  subtitle: Maybe<Scalars["String"]>
  supplementaryText: Maybe<Scalars["MarkdownText"]>
  /** Video is available until this date */
  takedownDate: Maybe<Scalars["DateTime"]>
  title: Scalars["String"]
  trailerIsrc: Maybe<Scalars["String"]>
  /** @deprecated Use `trailer_stream_variants` instead */
  trailerStream: Maybe<Stream>
  trailerStreamVariants: Array<StreamVariant>
  type: VideoType
  typeDisplayName: Scalars["String"]
  updatedAt: Scalars["DateTime"]
  /** The datetime the video was inserted, to be used for SEO */
  uploadDate: Scalars["DateTime"]
  videoDirector: Maybe<Scalars["String"]>
}

export type VideoArtistsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  by?: InputMaybe<ArtistOrdering>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
  role: InputMaybe<ArtistRoleFilter>
}

export type VideoCuratedContentArgs = {
  options: InputMaybe<CuratedContentOptionsInput>
}

export type VideoConnection = {
  __typename: "VideoConnection"
  edges: Array<VideoEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

export type VideoEdge = {
  __typename: "VideoEdge"
  cursor: Scalars["String"]
  node: Video
}

export const VideoType = {
  Documentary: "DOCUMENTARY",
  Interview: "INTERVIEW",
  Short: "SHORT",
} as const

export type VideoType = (typeof VideoType)[keyof typeof VideoType]
export type VodConcert = Node & {
  __typename: "VodConcert"
  /** The concert was first aired on this date */
  airDate: Scalars["Date"]
  /** The concert is available from this date */
  archiveReleaseDate: Maybe<Scalars["DateTime"]>
  artists: Maybe<ArtistWithRoleConnection>
  /** The VOD concert's booklet */
  booklet: Maybe<Booklet>
  /** Copyright Credit */
  copyright: Maybe<Scalars["String"]>
  /** A courtesy credit for an appearing artist, usually given in the form "[artist]" appears courtesy of "[label]" */
  courtesyOf: Maybe<Scalars["String"]>
  curatedContent: Array<CuratedContentContainerV2>
  /** Epochs ordered by relevance to this concert. Derived from works through their composers, ordered by work count (descending). The first item is always the primary epoch. */
  epochsByRelevance: Array<Epoch>
  /** Genres ordered by relevance to this concert based on work count (descending). The first item is the primary genre. */
  genresByRelevance: Array<Genre>
  /** A list of countries used to evaluate the geoblocking of the stream delivery. */
  geoAccessCountries: Array<Scalars["String"]>
  /** Geo access mode mode. DENY=blocked in specified countries, ALLOW=allowed in specified countries */
  geoAccessMode: GeoAccessMode
  groups: Array<Group>
  /** The ID of an object */
  id: Scalars["ID"]
  isAtmos: Scalars["Boolean"]
  /** Always returns `false`. HDR-Content is currently not available, but might be in the future */
  isHdr: Scalars["Boolean"]
  /** Always returns `false`. Immersive-Content is currently not available, but might be in the future */
  isImmersive: Scalars["Boolean"]
  isLossless: Scalars["Boolean"]
  isMvVideo: Scalars["Boolean"]
  isrc: Maybe<Scalars["String"]>
  /** Licensor Credit */
  licensor: Maybe<Scalars["String"]>
  longFormConcertIntroduction: Maybe<Scalars["String"]>
  maxResolution: MaxResolution
  metaDescription: Maybe<Scalars["String"]>
  metaTitle: Maybe<Scalars["String"]>
  partners: Array<Partner>
  performanceWorks: Array<PerformanceWork>
  /** Photogapher Credit */
  photographer: Maybe<Scalars["String"]>
  pictures: Array<Picture>
  /** Production Company Credit */
  production: Maybe<Scalars["String"]>
  /** Production was finalized on this date */
  productionDate: Maybe<Scalars["Date"]>
  /** The level that is needed for a user to access the video-stream of this concert. U1=everyone, U2=needs account, U3=needs account + ticket */
  publicationLevel: PublicationLevel
  /** Maximum length: 25 characters */
  seriesTitle: Maybe<Scalars["String"]>
  /** Maximum length 750 characters */
  shortDescription: Maybe<Scalars["String"]>
  /** @deprecated Use curatedContent instead */
  sliders: Array<CuratedContentContainer>
  /** Maximum length: 25 characters */
  subtitle: Maybe<Scalars["String"]>
  supplementaryText: Maybe<Scalars["MarkdownText"]>
  /** The concert is available till this date */
  takedownDate: Maybe<Scalars["DateTime"]>
  /** Maximum length: 70 characters */
  title: Scalars["String"]
  /** The total duration of the concert in seconds. */
  totalDuration: Scalars["Int"]
  trailerIsrc: Maybe<Scalars["String"]>
  /** @deprecated Use `trailer_stream_variants` instead */
  trailerStream: Maybe<Stream>
  trailerStreamVariants: Array<StreamVariant>
  type: VodConcertType
  typeDisplayName: Scalars["String"]
  updatedAt: Scalars["DateTime"]
  /** The datetime the concert was inserted, to be used for SEO */
  uploadDate: Scalars["DateTime"]
  /** Video Director Credit */
  videoDirector: Maybe<Scalars["String"]>
}

export type VodConcertArtistsArgs = {
  after: InputMaybe<Scalars["String"]>
  before: InputMaybe<Scalars["String"]>
  by?: InputMaybe<ArtistOrdering>
  first: InputMaybe<Scalars["Int"]>
  last: InputMaybe<Scalars["Int"]>
  role?: InputMaybe<ArtistRoleFilter>
}

export type VodConcertCuratedContentArgs = {
  options: InputMaybe<CuratedContentOptionsInput>
}

export type VodConcertConnection = {
  __typename: "VodConcertConnection"
  edges: Array<VodConcertEdge>
  pageInfo: PageInfo
  totalResults: Scalars["Int"]
}

export type VodConcertEdge = {
  __typename: "VodConcertEdge"
  cursor: Scalars["String"]
  node: VodConcert
}

export const VodConcertType = {
  Concert: "CONCERT",
  Dance: "DANCE",
  Opera: "OPERA",
} as const

export type VodConcertType =
  (typeof VodConcertType)[keyof typeof VodConcertType]
export type Voucher = {
  __typename: "Voucher"
  /** The projected valid_until of the ticket that will be created if this voucher is used. */
  calculatedValidUntil: Maybe<Scalars["DateTime"]>
  code: Scalars["String"]
  duration: Maybe<Scalars["Int"]>
  interval: Maybe<Scalars["String"]>
  voucherType: Maybe<Scalars["String"]>
}

export type Work = Node & {
  __typename: "Work"
  arrangers: Array<Artist>
  composers: Array<Artist>
  copyright: Maybe<Scalars["String"]>
  curatedContent: Array<CuratedContentContainerV2>
  epochs: Array<Epoch>
  genre: Maybe<Genre>
  /** The ID of an object */
  id: Scalars["ID"]
  librettists: Array<Artist>
  movements: Array<Movement>
  publisher: Maybe<Scalars["String"]>
  title: Scalars["String"]
  yearOfComposition: Maybe<Scalars["Int"]>
}

export type WorkCuratedContentArgs = {
  options: InputMaybe<CuratedContentOptionsInput>
}

export type AccountSettingsQueryVariables = Exact<{ [key: string]: never }>

export type AccountSettingsQuery = {
  __typename: "RootQueryType"
  currentUser:
    | {
        __typename: "User"
        academicTitle: string | undefined
        country: string
        email: string
        firstName: string
        lastName: string
        locale: string
        sendNewsletter: boolean
        title: string | undefined
        postalAddress:
          | {
              __typename: "PostalAddress"
              city: string | undefined
              country: string | undefined
              firstLine: string | undefined
              secondLine: string | undefined
              state: string | undefined
              zipCode: string | undefined
            }
          | undefined
      }
    | undefined
}

export type ArtistCollectionPageQueryVariables = Exact<{
  artistId: Scalars["ID"]
  sliderPageSize?: InputMaybe<Scalars["Int"]>
}>

export type ArtistCollectionPageQuery = {
  __typename: "RootQueryType"
  artist:
    | {
        __typename: "Artist"
        id: string
        name: string
        title: string | undefined
        biography: string | undefined
        dateOfBirth: string | undefined
        dateOfDeath: string | undefined
        courtesyOf: string | undefined
        roles: Array<{
          __typename: "Role"
          id: string
          type: RoleType
          displayName: string
        }>
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        curatedContent: Array<
          | {
              __typename: "Banner"
              description: string
              link: string
              title: string
              pictures: Array<{
                __typename: "Picture"
                id: string
                url: string
                type: PictureType
              }>
            }
          | {
              __typename: "ListSlider"
              id: string
              headline: string
              totalResults: number
              layout: SliderLayout | undefined
              items: Array<
                | {
                    __typename: "Album"
                    artistAndGroupDisplayInfo: string | undefined
                    id: string
                    title: string
                    atmosUpc: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Artist"
                    id: string
                    name: string
                    roles: Array<{
                      __typename: "Role"
                      id: string
                      type: RoleType
                      displayName: string
                    }>
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "BlogArticleLink" }
                | {
                    __typename: "CuratedContentLink"
                    id: string
                    title: string
                    slugV2: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "EditorialPlaylist"
                    id: string
                    title: string
                    description: string
                    metaTitle: string | undefined
                    typeDisplayName: string
                    metaDescription: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Epoch"
                    id: string
                    endYear: number | undefined
                    startYear: number | undefined
                    title: string
                    subtitle: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Favorite" }
                | {
                    __typename: "Genre"
                    id: string
                    title: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Group"
                    id: string
                    name: string
                    typeDisplayName: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "LiveConcert"
                    endTime: string
                    id: string
                    publicationLevel: PublicationLevel
                    startTime: string
                    streamStartTime: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    finalEndTime: string
                    plannedForVod: boolean
                    liveConcertType: LiveConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    reruns: Array<{
                      __typename: "LiveConcertRerun"
                      streamStartTime: string | undefined
                      endTime: string
                      startTime: string
                      stream: {
                        __typename: "RerunStream"
                        publicationLevel: PublicationLevel
                        streamType: StreamType
                        url: string
                      }
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Partner"
                    id: string
                    name: string
                    typeDisplayName: string
                    subtypeDisplayName: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Playback" }
                | { __typename: "PlaybackProgress" }
                | {
                    __typename: "Video"
                    id: string
                    archiveReleaseDate: string | undefined
                    title: string
                    subtitle: string | undefined
                    duration: number
                    type: VideoType
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    isAtmos: boolean
                    maxResolution: MaxResolution
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "VodConcert"
                    id: string
                    archiveReleaseDate: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    totalDuration: number
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    maxResolution: MaxResolution
                    vodConcertType: VodConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Work"
                    id: string
                    title: string
                    movements: Array<{
                      __typename: "Movement"
                      id: string
                      title: string
                    }>
                    composers: Array<{
                      __typename: "Artist"
                      id: string
                      name: string
                    }>
                    genre:
                      | { __typename: "Genre"; id: string; title: string }
                      | undefined
                  }
              >
            }
        >
        epoch: { __typename: "Epoch"; id: string; title: string } | undefined
      }
    | undefined
}

export type AudioDetailPageQueryVariables = Exact<{
  albumId: Scalars["ID"]
  sliderPageSize?: InputMaybe<Scalars["Int"]>
}>

export type AudioDetailPageQuery = {
  __typename: "RootQueryType"
  album:
    | {
        __typename: "Album"
        artistAndGroupDisplayInfo: string | undefined
        atmosUpc: string | undefined
        id: string
        title: string
        totalDuration: number
        releaseDate: string | undefined
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        trackSets: Array<{
          __typename: "TrackSet"
          composerDisplayInfo: string | undefined
          title: string | undefined
          trackSetNumber: number
          tracks: Array<{
            __typename: "Track"
            id: string
            artistDisplayInfo: string | undefined
            artistAndGroupDisplayInfo: string | undefined
            composerDisplayInfo: string | undefined
            duration: number
            title: string
            trackNumber: number
            album: { __typename: "Album"; id: string }
            streamVariants: Array<{
              __typename: "StreamVariant"
              manifestType: StreamManifestType
              url: string
              publicationLevel: PublicationLevel
            }>
          }>
        }>
        curatedContent: Array<
          | {
              __typename: "Banner"
              description: string
              link: string
              title: string
              pictures: Array<{
                __typename: "Picture"
                id: string
                url: string
                type: PictureType
              }>
            }
          | {
              __typename: "ListSlider"
              id: string
              headline: string
              totalResults: number
              layout: SliderLayout | undefined
              items: Array<
                | {
                    __typename: "Album"
                    artistAndGroupDisplayInfo: string | undefined
                    id: string
                    title: string
                    atmosUpc: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Artist"
                    id: string
                    name: string
                    roles: Array<{
                      __typename: "Role"
                      id: string
                      type: RoleType
                      displayName: string
                    }>
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "BlogArticleLink" }
                | {
                    __typename: "CuratedContentLink"
                    id: string
                    title: string
                    slugV2: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "EditorialPlaylist"
                    id: string
                    title: string
                    description: string
                    metaTitle: string | undefined
                    typeDisplayName: string
                    metaDescription: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Epoch"
                    id: string
                    endYear: number | undefined
                    startYear: number | undefined
                    title: string
                    subtitle: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Favorite" }
                | {
                    __typename: "Genre"
                    id: string
                    title: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Group"
                    id: string
                    name: string
                    typeDisplayName: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "LiveConcert"
                    endTime: string
                    id: string
                    publicationLevel: PublicationLevel
                    startTime: string
                    streamStartTime: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    finalEndTime: string
                    plannedForVod: boolean
                    liveConcertType: LiveConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    reruns: Array<{
                      __typename: "LiveConcertRerun"
                      streamStartTime: string | undefined
                      endTime: string
                      startTime: string
                      stream: {
                        __typename: "RerunStream"
                        publicationLevel: PublicationLevel
                        streamType: StreamType
                        url: string
                      }
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Partner"
                    id: string
                    name: string
                    typeDisplayName: string
                    subtypeDisplayName: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Playback" }
                | { __typename: "PlaybackProgress" }
                | {
                    __typename: "Video"
                    id: string
                    archiveReleaseDate: string | undefined
                    title: string
                    subtitle: string | undefined
                    duration: number
                    type: VideoType
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    isAtmos: boolean
                    maxResolution: MaxResolution
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "VodConcert"
                    id: string
                    archiveReleaseDate: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    totalDuration: number
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    maxResolution: MaxResolution
                    vodConcertType: VodConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Work"
                    id: string
                    title: string
                    movements: Array<{
                      __typename: "Movement"
                      id: string
                      title: string
                    }>
                    composers: Array<{
                      __typename: "Artist"
                      id: string
                      name: string
                    }>
                    genre:
                      | { __typename: "Genre"; id: string; title: string }
                      | undefined
                  }
              >
            }
        >
        artists:
          | {
              __typename: "ArtistWithRoleConnection"
              edges: Array<{
                __typename: "ArtistWithRoleEdge"
                role: {
                  __typename: "Role"
                  id: string
                  type: RoleType
                  displayName: string
                }
                node: {
                  __typename: "Artist"
                  id: string
                  name: string
                  sortName: string | undefined
                }
              }>
            }
          | undefined
        groups: Array<{
          __typename: "Group"
          id: string
          name: string
          typeDisplayName: string
        }>
        epochsByRelevance: Array<{
          __typename: "Epoch"
          id: string
          title: string
        }>
        genresByRelevance: Array<{
          __typename: "Genre"
          id: string
          title: string
        }>
      }
    | undefined
}

export type CountriesQueryVariables = Exact<{ [key: string]: never }>

export type CountriesQuery = {
  __typename: "RootQueryType"
  countries: Array<{ __typename: "Country"; iso: string; displayName: string }>
}

export type CuratedContentPageQueryVariables = Exact<{
  slug: Scalars["String"]
  sliderPageSize?: InputMaybe<Scalars["Int"]>
}>

export type CuratedContentPageQuery = {
  __typename: "RootQueryType"
  curatedContentPage: {
    __typename: "CuratedContent"
    title: string
    metaTitle: string | undefined
    metaDescription: string | undefined
    navigation:
      | {
          __typename: "ListSlider"
          id: string
          headline: string
          totalResults: number
          layout: SliderLayout | undefined
          items: Array<
            | {
                __typename: "Album"
                artistAndGroupDisplayInfo: string | undefined
                id: string
                title: string
                atmosUpc: string | undefined
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
              }
            | {
                __typename: "Artist"
                id: string
                name: string
                roles: Array<{
                  __typename: "Role"
                  id: string
                  type: RoleType
                  displayName: string
                }>
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
              }
            | { __typename: "BlogArticleLink" }
            | {
                __typename: "CuratedContentLink"
                id: string
                title: string
                slugV2: string
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
              }
            | {
                __typename: "EditorialPlaylist"
                id: string
                title: string
                description: string
                metaTitle: string | undefined
                typeDisplayName: string
                metaDescription: string | undefined
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
              }
            | {
                __typename: "Epoch"
                id: string
                endYear: number | undefined
                startYear: number | undefined
                title: string
                subtitle: string | undefined
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
              }
            | { __typename: "Favorite" }
            | {
                __typename: "Genre"
                id: string
                title: string
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
              }
            | {
                __typename: "Group"
                id: string
                name: string
                typeDisplayName: string
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
              }
            | {
                __typename: "LiveConcert"
                endTime: string
                id: string
                publicationLevel: PublicationLevel
                startTime: string
                streamStartTime: string | undefined
                subtitle: string | undefined
                title: string
                typeDisplayName: string
                geoAccessCountries: Array<string>
                geoAccessMode: GeoAccessMode
                finalEndTime: string
                plannedForVod: boolean
                liveConcertType: LiveConcertType
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
                reruns: Array<{
                  __typename: "LiveConcertRerun"
                  streamStartTime: string | undefined
                  endTime: string
                  startTime: string
                  stream: {
                    __typename: "RerunStream"
                    publicationLevel: PublicationLevel
                    streamType: StreamType
                    url: string
                  }
                }>
                streamVariants: Array<{
                  __typename: "StreamVariant"
                  manifestType: StreamManifestType
                  url: string
                  publicationLevel: PublicationLevel
                }>
                trailerStreamVariants: Array<{
                  __typename: "StreamVariant"
                  manifestType: StreamManifestType
                  url: string
                  publicationLevel: PublicationLevel
                }>
              }
            | {
                __typename: "Partner"
                id: string
                name: string
                typeDisplayName: string
                subtypeDisplayName: string | undefined
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
              }
            | { __typename: "Playback" }
            | { __typename: "PlaybackProgress" }
            | {
                __typename: "Video"
                id: string
                archiveReleaseDate: string | undefined
                title: string
                subtitle: string | undefined
                duration: number
                type: VideoType
                typeDisplayName: string
                geoAccessCountries: Array<string>
                geoAccessMode: GeoAccessMode
                publicationLevel: PublicationLevel
                takedownDate: string | undefined
                isAtmos: boolean
                maxResolution: MaxResolution
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
                streamVariants: Array<{
                  __typename: "StreamVariant"
                  manifestType: StreamManifestType
                  url: string
                  publicationLevel: PublicationLevel
                }>
                trailerStreamVariants: Array<{
                  __typename: "StreamVariant"
                  manifestType: StreamManifestType
                  url: string
                  publicationLevel: PublicationLevel
                }>
              }
            | {
                __typename: "VodConcert"
                id: string
                archiveReleaseDate: string | undefined
                subtitle: string | undefined
                title: string
                typeDisplayName: string
                totalDuration: number
                geoAccessCountries: Array<string>
                geoAccessMode: GeoAccessMode
                publicationLevel: PublicationLevel
                takedownDate: string | undefined
                maxResolution: MaxResolution
                vodConcertType: VodConcertType
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
                trailerStreamVariants: Array<{
                  __typename: "StreamVariant"
                  manifestType: StreamManifestType
                  url: string
                  publicationLevel: PublicationLevel
                }>
              }
            | {
                __typename: "Work"
                id: string
                title: string
                movements: Array<{
                  __typename: "Movement"
                  id: string
                  title: string
                }>
                composers: Array<{
                  __typename: "Artist"
                  id: string
                  name: string
                }>
                genre:
                  | { __typename: "Genre"; id: string; title: string }
                  | undefined
              }
          >
        }
      | undefined
    stageSlider: Array<{
      __typename: "StageItemV2"
      label: string | undefined
      subtitle: string | undefined
      title: string | undefined
      item:
        | {
            __typename: "Album"
            artistAndGroupDisplayInfo: string | undefined
            id: string
            title: string
            atmosUpc: string | undefined
            pictures: Array<{
              __typename: "Picture"
              id: string
              url: string
              type: PictureType
            }>
          }
        | {
            __typename: "Artist"
            id: string
            name: string
            roles: Array<{
              __typename: "Role"
              id: string
              type: RoleType
              displayName: string
            }>
            pictures: Array<{
              __typename: "Picture"
              id: string
              url: string
              type: PictureType
            }>
          }
        | {
            __typename: "EditorialPlaylist"
            id: string
            title: string
            description: string
            metaTitle: string | undefined
            typeDisplayName: string
            metaDescription: string | undefined
            pictures: Array<{
              __typename: "Picture"
              id: string
              url: string
              type: PictureType
            }>
          }
        | {
            __typename: "Group"
            id: string
            name: string
            typeDisplayName: string
            pictures: Array<{
              __typename: "Picture"
              id: string
              url: string
              type: PictureType
            }>
          }
        | {
            __typename: "LiveConcert"
            endTime: string
            id: string
            publicationLevel: PublicationLevel
            startTime: string
            streamStartTime: string | undefined
            subtitle: string | undefined
            title: string
            typeDisplayName: string
            geoAccessCountries: Array<string>
            geoAccessMode: GeoAccessMode
            finalEndTime: string
            plannedForVod: boolean
            liveConcertType: LiveConcertType
            pictures: Array<{
              __typename: "Picture"
              id: string
              url: string
              type: PictureType
            }>
            reruns: Array<{
              __typename: "LiveConcertRerun"
              streamStartTime: string | undefined
              endTime: string
              startTime: string
              stream: {
                __typename: "RerunStream"
                publicationLevel: PublicationLevel
                streamType: StreamType
                url: string
              }
            }>
            streamVariants: Array<{
              __typename: "StreamVariant"
              manifestType: StreamManifestType
              url: string
              publicationLevel: PublicationLevel
            }>
            trailerStreamVariants: Array<{
              __typename: "StreamVariant"
              manifestType: StreamManifestType
              url: string
              publicationLevel: PublicationLevel
            }>
          }
        | {
            __typename: "Partner"
            id: string
            name: string
            typeDisplayName: string
            subtypeDisplayName: string | undefined
            pictures: Array<{
              __typename: "Picture"
              id: string
              url: string
              type: PictureType
            }>
          }
        | {
            __typename: "Video"
            id: string
            archiveReleaseDate: string | undefined
            title: string
            subtitle: string | undefined
            duration: number
            type: VideoType
            typeDisplayName: string
            geoAccessCountries: Array<string>
            geoAccessMode: GeoAccessMode
            publicationLevel: PublicationLevel
            takedownDate: string | undefined
            isAtmos: boolean
            maxResolution: MaxResolution
            pictures: Array<{
              __typename: "Picture"
              id: string
              url: string
              type: PictureType
            }>
            streamVariants: Array<{
              __typename: "StreamVariant"
              manifestType: StreamManifestType
              url: string
              publicationLevel: PublicationLevel
            }>
            trailerStreamVariants: Array<{
              __typename: "StreamVariant"
              manifestType: StreamManifestType
              url: string
              publicationLevel: PublicationLevel
            }>
          }
        | {
            __typename: "VodConcert"
            id: string
            archiveReleaseDate: string | undefined
            subtitle: string | undefined
            title: string
            typeDisplayName: string
            totalDuration: number
            geoAccessCountries: Array<string>
            geoAccessMode: GeoAccessMode
            publicationLevel: PublicationLevel
            takedownDate: string | undefined
            maxResolution: MaxResolution
            vodConcertType: VodConcertType
            pictures: Array<{
              __typename: "Picture"
              id: string
              url: string
              type: PictureType
            }>
            trailerStreamVariants: Array<{
              __typename: "StreamVariant"
              manifestType: StreamManifestType
              url: string
              publicationLevel: PublicationLevel
            }>
          }
    }>
    curatedContent: Array<
      | {
          __typename: "Banner"
          description: string
          link: string
          title: string
          pictures: Array<{
            __typename: "Picture"
            id: string
            url: string
            type: PictureType
          }>
        }
      | {
          __typename: "ListSlider"
          id: string
          headline: string
          totalResults: number
          layout: SliderLayout | undefined
          items: Array<
            | {
                __typename: "Album"
                artistAndGroupDisplayInfo: string | undefined
                id: string
                title: string
                atmosUpc: string | undefined
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
              }
            | {
                __typename: "Artist"
                id: string
                name: string
                roles: Array<{
                  __typename: "Role"
                  id: string
                  type: RoleType
                  displayName: string
                }>
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
              }
            | { __typename: "BlogArticleLink" }
            | {
                __typename: "CuratedContentLink"
                id: string
                title: string
                slugV2: string
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
              }
            | {
                __typename: "EditorialPlaylist"
                id: string
                title: string
                description: string
                metaTitle: string | undefined
                typeDisplayName: string
                metaDescription: string | undefined
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
              }
            | {
                __typename: "Epoch"
                id: string
                endYear: number | undefined
                startYear: number | undefined
                title: string
                subtitle: string | undefined
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
              }
            | { __typename: "Favorite" }
            | {
                __typename: "Genre"
                id: string
                title: string
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
              }
            | {
                __typename: "Group"
                id: string
                name: string
                typeDisplayName: string
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
              }
            | {
                __typename: "LiveConcert"
                endTime: string
                id: string
                publicationLevel: PublicationLevel
                startTime: string
                streamStartTime: string | undefined
                subtitle: string | undefined
                title: string
                typeDisplayName: string
                geoAccessCountries: Array<string>
                geoAccessMode: GeoAccessMode
                finalEndTime: string
                plannedForVod: boolean
                liveConcertType: LiveConcertType
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
                reruns: Array<{
                  __typename: "LiveConcertRerun"
                  streamStartTime: string | undefined
                  endTime: string
                  startTime: string
                  stream: {
                    __typename: "RerunStream"
                    publicationLevel: PublicationLevel
                    streamType: StreamType
                    url: string
                  }
                }>
                streamVariants: Array<{
                  __typename: "StreamVariant"
                  manifestType: StreamManifestType
                  url: string
                  publicationLevel: PublicationLevel
                }>
                trailerStreamVariants: Array<{
                  __typename: "StreamVariant"
                  manifestType: StreamManifestType
                  url: string
                  publicationLevel: PublicationLevel
                }>
              }
            | {
                __typename: "Partner"
                id: string
                name: string
                typeDisplayName: string
                subtypeDisplayName: string | undefined
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
              }
            | { __typename: "Playback" }
            | { __typename: "PlaybackProgress" }
            | {
                __typename: "Video"
                id: string
                archiveReleaseDate: string | undefined
                title: string
                subtitle: string | undefined
                duration: number
                type: VideoType
                typeDisplayName: string
                geoAccessCountries: Array<string>
                geoAccessMode: GeoAccessMode
                publicationLevel: PublicationLevel
                takedownDate: string | undefined
                isAtmos: boolean
                maxResolution: MaxResolution
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
                streamVariants: Array<{
                  __typename: "StreamVariant"
                  manifestType: StreamManifestType
                  url: string
                  publicationLevel: PublicationLevel
                }>
                trailerStreamVariants: Array<{
                  __typename: "StreamVariant"
                  manifestType: StreamManifestType
                  url: string
                  publicationLevel: PublicationLevel
                }>
              }
            | {
                __typename: "VodConcert"
                id: string
                archiveReleaseDate: string | undefined
                subtitle: string | undefined
                title: string
                typeDisplayName: string
                totalDuration: number
                geoAccessCountries: Array<string>
                geoAccessMode: GeoAccessMode
                publicationLevel: PublicationLevel
                takedownDate: string | undefined
                maxResolution: MaxResolution
                vodConcertType: VodConcertType
                pictures: Array<{
                  __typename: "Picture"
                  id: string
                  url: string
                  type: PictureType
                }>
                trailerStreamVariants: Array<{
                  __typename: "StreamVariant"
                  manifestType: StreamManifestType
                  url: string
                  publicationLevel: PublicationLevel
                }>
              }
            | {
                __typename: "Work"
                id: string
                title: string
                movements: Array<{
                  __typename: "Movement"
                  id: string
                  title: string
                }>
                composers: Array<{
                  __typename: "Artist"
                  id: string
                  name: string
                }>
                genre:
                  | { __typename: "Genre"; id: string; title: string }
                  | undefined
              }
          >
        }
    >
  }
}

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>

export type CurrentUserQuery = {
  __typename: "RootQueryType"
  currentUser:
    | {
        __typename: "User"
        academicTitle: string | undefined
        affiliateGroup: string | undefined
        country: string
        email: string
        emailVerified: boolean
        firstName: string
        hasTrialedBefore: boolean
        id: string
        insertedAt: string
        lastName: string
        liveReminderEmail: boolean
        liveReminderPush: boolean
        locale: string
        pushOptin: boolean
        sendNewsletter: boolean
        title: string | undefined
        updatedAt: string
        devices: Array<{
          __typename: "Device"
          deviceInfo: string
          id: string
          insertedAt: string
          updatedAt: string
        }>
        postalAddress:
          | {
              __typename: "PostalAddress"
              city: string | undefined
              country: string | undefined
              firstLine: string | undefined
              insertedAt: string
              secondLine: string | undefined
              state: string | undefined
              updatedAt: string
              zipCode: string | undefined
            }
          | undefined
        ticket:
          | {
              __typename: "Ticket"
              paymentProvider: PaymentProvider
              status: TicketStatus
              validUntil: string | undefined
              isTrial: boolean
            }
          | undefined
      }
    | undefined
}

export type DevicesQueryVariables = Exact<{ [key: string]: never }>

export type DevicesQuery = {
  __typename: "RootQueryType"
  currentUser:
    | {
        __typename: "User"
        devices: Array<{
          __typename: "Device"
          id: string
          deviceInfo: string
          insertedAt: string
          updatedAt: string
        }>
      }
    | undefined
}

export type EditorialPlaylistPageQueryVariables = Exact<{
  editorialPlaylistId: Scalars["ID"]
  sliderPageSize?: InputMaybe<Scalars["Int"]>
}>

export type EditorialPlaylistPageQuery = {
  __typename: "RootQueryType"
  editorialPlaylist:
    | {
        __typename: "EditorialPlaylist"
        id: string
        title: string
        metaTitle: string | undefined
        metaDescription: string | undefined
        totalDuration: number
        totalItems: number
        typeDisplayName: string
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        curatedContent: Array<
          | {
              __typename: "Banner"
              description: string
              link: string
              title: string
              pictures: Array<{
                __typename: "Picture"
                id: string
                url: string
                type: PictureType
              }>
            }
          | {
              __typename: "ListSlider"
              id: string
              headline: string
              totalResults: number
              layout: SliderLayout | undefined
              items: Array<
                | {
                    __typename: "Album"
                    artistAndGroupDisplayInfo: string | undefined
                    id: string
                    title: string
                    atmosUpc: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Artist"
                    id: string
                    name: string
                    roles: Array<{
                      __typename: "Role"
                      id: string
                      type: RoleType
                      displayName: string
                    }>
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "BlogArticleLink" }
                | {
                    __typename: "CuratedContentLink"
                    id: string
                    title: string
                    slugV2: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "EditorialPlaylist"
                    id: string
                    title: string
                    description: string
                    metaTitle: string | undefined
                    typeDisplayName: string
                    metaDescription: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Epoch"
                    id: string
                    endYear: number | undefined
                    startYear: number | undefined
                    title: string
                    subtitle: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Favorite" }
                | {
                    __typename: "Genre"
                    id: string
                    title: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Group"
                    id: string
                    name: string
                    typeDisplayName: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "LiveConcert"
                    endTime: string
                    id: string
                    publicationLevel: PublicationLevel
                    startTime: string
                    streamStartTime: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    finalEndTime: string
                    plannedForVod: boolean
                    liveConcertType: LiveConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    reruns: Array<{
                      __typename: "LiveConcertRerun"
                      streamStartTime: string | undefined
                      endTime: string
                      startTime: string
                      stream: {
                        __typename: "RerunStream"
                        publicationLevel: PublicationLevel
                        streamType: StreamType
                        url: string
                      }
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Partner"
                    id: string
                    name: string
                    typeDisplayName: string
                    subtypeDisplayName: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Playback" }
                | { __typename: "PlaybackProgress" }
                | {
                    __typename: "Video"
                    id: string
                    archiveReleaseDate: string | undefined
                    title: string
                    subtitle: string | undefined
                    duration: number
                    type: VideoType
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    isAtmos: boolean
                    maxResolution: MaxResolution
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "VodConcert"
                    id: string
                    archiveReleaseDate: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    totalDuration: number
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    maxResolution: MaxResolution
                    vodConcertType: VodConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Work"
                    id: string
                    title: string
                    movements: Array<{
                      __typename: "Movement"
                      id: string
                      title: string
                    }>
                    composers: Array<{
                      __typename: "Artist"
                      id: string
                      name: string
                    }>
                    genre:
                      | { __typename: "Genre"; id: string; title: string }
                      | undefined
                  }
              >
            }
        >
        sections: Array<{
          __typename: "EditorialPlaylistSection"
          title: string | undefined
          description: string | undefined
          items: Array<{
            __typename: "Track"
            id: string
            artistDisplayInfo: string | undefined
            artistAndGroupDisplayInfo: string | undefined
            composerDisplayInfo: string | undefined
            duration: number
            title: string
            trackNumber: number
            workDisplayInfo: string | undefined
            artistsAndGroups: Array<
              | { __typename: "TrackArtist"; name: string }
              | { __typename: "TrackGroup"; name: string }
            >
            album: {
              __typename: "Album"
              id: string
              title: string
              pictures: Array<{
                __typename: "Picture"
                id: string
                url: string
                type: PictureType
              }>
            }
            streamVariants: Array<{
              __typename: "StreamVariant"
              manifestType: StreamManifestType
              url: string
              publicationLevel: PublicationLevel
            }>
          }>
        }>
      }
    | undefined
}

export type EpochPageQueryVariables = Exact<{
  epochId: Scalars["ID"]
  sliderPageSize?: InputMaybe<Scalars["Int"]>
}>

export type EpochPageQuery = {
  __typename: "RootQueryType"
  epoch:
    | {
        __typename: "Epoch"
        id: string
        title: string
        subtitle: string | undefined
        description: string | undefined
        startYear: number | undefined
        endYear: number | undefined
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        curatedContent: Array<
          | {
              __typename: "Banner"
              description: string
              link: string
              title: string
              pictures: Array<{
                __typename: "Picture"
                id: string
                url: string
                type: PictureType
              }>
            }
          | {
              __typename: "ListSlider"
              id: string
              headline: string
              totalResults: number
              layout: SliderLayout | undefined
              items: Array<
                | {
                    __typename: "Album"
                    artistAndGroupDisplayInfo: string | undefined
                    id: string
                    title: string
                    atmosUpc: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Artist"
                    id: string
                    name: string
                    roles: Array<{
                      __typename: "Role"
                      id: string
                      type: RoleType
                      displayName: string
                    }>
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "BlogArticleLink" }
                | {
                    __typename: "CuratedContentLink"
                    id: string
                    title: string
                    slugV2: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "EditorialPlaylist"
                    id: string
                    title: string
                    description: string
                    metaTitle: string | undefined
                    typeDisplayName: string
                    metaDescription: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Epoch"
                    id: string
                    endYear: number | undefined
                    startYear: number | undefined
                    title: string
                    subtitle: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Favorite" }
                | {
                    __typename: "Genre"
                    id: string
                    title: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Group"
                    id: string
                    name: string
                    typeDisplayName: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "LiveConcert"
                    endTime: string
                    id: string
                    publicationLevel: PublicationLevel
                    startTime: string
                    streamStartTime: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    finalEndTime: string
                    plannedForVod: boolean
                    liveConcertType: LiveConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    reruns: Array<{
                      __typename: "LiveConcertRerun"
                      streamStartTime: string | undefined
                      endTime: string
                      startTime: string
                      stream: {
                        __typename: "RerunStream"
                        publicationLevel: PublicationLevel
                        streamType: StreamType
                        url: string
                      }
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Partner"
                    id: string
                    name: string
                    typeDisplayName: string
                    subtypeDisplayName: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Playback" }
                | { __typename: "PlaybackProgress" }
                | {
                    __typename: "Video"
                    id: string
                    archiveReleaseDate: string | undefined
                    title: string
                    subtitle: string | undefined
                    duration: number
                    type: VideoType
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    isAtmos: boolean
                    maxResolution: MaxResolution
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "VodConcert"
                    id: string
                    archiveReleaseDate: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    totalDuration: number
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    maxResolution: MaxResolution
                    vodConcertType: VodConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Work"
                    id: string
                    title: string
                    movements: Array<{
                      __typename: "Movement"
                      id: string
                      title: string
                    }>
                    composers: Array<{
                      __typename: "Artist"
                      id: string
                      name: string
                    }>
                    genre:
                      | { __typename: "Genre"; id: string; title: string }
                      | undefined
                  }
              >
            }
        >
      }
    | undefined
}

export type FavoriteByContentIdQueryVariables = Exact<{
  contentId: Scalars["ID"]
}>

export type FavoriteByContentIdQuery = {
  __typename: "RootQueryType"
  favoriteByContentId:
    | {
        __typename: "Favorite"
        content:
          | { __typename: "Album"; id: string }
          | { __typename: "EditorialPlaylist"; id: string }
          | { __typename: "PerformanceWork" }
          | { __typename: "Video"; id: string }
      }
    | undefined
}

export type FavoritesByVodConcertIdQueryVariables = Exact<{
  vodConcertId: Scalars["ID"]
}>

export type FavoritesByVodConcertIdQuery = {
  __typename: "RootQueryType"
  favoritesByVodConcertId:
    | Array<
        | {
            __typename: "Favorite"
            content:
              | { __typename: "Album" }
              | { __typename: "EditorialPlaylist" }
              | { __typename: "PerformanceWork"; id: string }
              | { __typename: "Video" }
          }
        | undefined
      >
    | undefined
}

export type PlaylistItemFieldsFragment = {
  __typename: "Track"
  id: string
  artistDisplayInfo: string | undefined
  artistAndGroupDisplayInfo: string | undefined
  composerDisplayInfo: string | undefined
  duration: number
  title: string
  trackNumber: number
  workDisplayInfo: string | undefined
  artistsAndGroups: Array<
    | { __typename: "TrackArtist"; name: string }
    | { __typename: "TrackGroup"; name: string }
  >
  album: {
    __typename: "Album"
    id: string
    title: string
    pictures: Array<{
      __typename: "Picture"
      id: string
      url: string
      type: PictureType
    }>
  }
  streamVariants: Array<{
    __typename: "StreamVariant"
    manifestType: StreamManifestType
    url: string
    publicationLevel: PublicationLevel
  }>
}

export type TrackSetFieldsFragment = {
  __typename: "TrackSet"
  composerDisplayInfo: string | undefined
  title: string | undefined
  trackSetNumber: number
  tracks: Array<{
    __typename: "Track"
    id: string
    artistDisplayInfo: string | undefined
    artistAndGroupDisplayInfo: string | undefined
    composerDisplayInfo: string | undefined
    duration: number
    title: string
    trackNumber: number
    album: { __typename: "Album"; id: string }
    streamVariants: Array<{
      __typename: "StreamVariant"
      manifestType: StreamManifestType
      url: string
      publicationLevel: PublicationLevel
    }>
  }>
}

export type AlbumFieldsFragment = {
  __typename: "Album"
  artistAndGroupDisplayInfo: string | undefined
  id: string
  title: string
  atmosUpc: string | undefined
  pictures: Array<{
    __typename: "Picture"
    id: string
    url: string
    type: PictureType
  }>
}

type ApiErrorFields_BasicError_Fragment = {
  __typename: "BasicError"
  message: string
}

type ApiErrorFields_ValidationError_Fragment = {
  __typename: "ValidationError"
  message: string
  validation: string
  field: string
}

export type ApiErrorFieldsFragment =
  | ApiErrorFields_BasicError_Fragment
  | ApiErrorFields_ValidationError_Fragment

export type ArtistFieldsFragment = {
  __typename: "Artist"
  id: string
  name: string
  roles: Array<{
    __typename: "Role"
    id: string
    type: RoleType
    displayName: string
  }>
  pictures: Array<{
    __typename: "Picture"
    id: string
    url: string
    type: PictureType
  }>
}

export type ArtistWithRoleFieldsFragment = {
  __typename: "ArtistWithRoleConnection"
  edges: Array<{
    __typename: "ArtistWithRoleEdge"
    role: {
      __typename: "Role"
      id: string
      type: RoleType
      displayName: string
    }
    node: {
      __typename: "Artist"
      id: string
      name: string
      sortName: string | undefined
    }
  }>
}

export type BannerFieldsFragment = {
  __typename: "Banner"
  description: string
  link: string
  title: string
  pictures: Array<{
    __typename: "Picture"
    id: string
    url: string
    type: PictureType
  }>
}

type CuratedContentFields_Banner_Fragment = {
  __typename: "Banner"
  description: string
  link: string
  title: string
  pictures: Array<{
    __typename: "Picture"
    id: string
    url: string
    type: PictureType
  }>
}

type CuratedContentFields_ListSlider_Fragment = {
  __typename: "ListSlider"
  id: string
  headline: string
  totalResults: number
  layout: SliderLayout | undefined
  items: Array<
    | {
        __typename: "Album"
        artistAndGroupDisplayInfo: string | undefined
        id: string
        title: string
        atmosUpc: string | undefined
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | {
        __typename: "Artist"
        id: string
        name: string
        roles: Array<{
          __typename: "Role"
          id: string
          type: RoleType
          displayName: string
        }>
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | { __typename: "BlogArticleLink" }
    | {
        __typename: "CuratedContentLink"
        id: string
        title: string
        slugV2: string
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | {
        __typename: "EditorialPlaylist"
        id: string
        title: string
        description: string
        metaTitle: string | undefined
        typeDisplayName: string
        metaDescription: string | undefined
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | {
        __typename: "Epoch"
        id: string
        endYear: number | undefined
        startYear: number | undefined
        title: string
        subtitle: string | undefined
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | { __typename: "Favorite" }
    | {
        __typename: "Genre"
        id: string
        title: string
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | {
        __typename: "Group"
        id: string
        name: string
        typeDisplayName: string
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | {
        __typename: "LiveConcert"
        endTime: string
        id: string
        publicationLevel: PublicationLevel
        startTime: string
        streamStartTime: string | undefined
        subtitle: string | undefined
        title: string
        typeDisplayName: string
        geoAccessCountries: Array<string>
        geoAccessMode: GeoAccessMode
        finalEndTime: string
        plannedForVod: boolean
        liveConcertType: LiveConcertType
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        reruns: Array<{
          __typename: "LiveConcertRerun"
          streamStartTime: string | undefined
          endTime: string
          startTime: string
          stream: {
            __typename: "RerunStream"
            publicationLevel: PublicationLevel
            streamType: StreamType
            url: string
          }
        }>
        streamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
        trailerStreamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
      }
    | {
        __typename: "Partner"
        id: string
        name: string
        typeDisplayName: string
        subtypeDisplayName: string | undefined
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | { __typename: "Playback" }
    | { __typename: "PlaybackProgress" }
    | {
        __typename: "Video"
        id: string
        archiveReleaseDate: string | undefined
        title: string
        subtitle: string | undefined
        duration: number
        type: VideoType
        typeDisplayName: string
        geoAccessCountries: Array<string>
        geoAccessMode: GeoAccessMode
        publicationLevel: PublicationLevel
        takedownDate: string | undefined
        isAtmos: boolean
        maxResolution: MaxResolution
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        streamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
        trailerStreamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
      }
    | {
        __typename: "VodConcert"
        id: string
        archiveReleaseDate: string | undefined
        subtitle: string | undefined
        title: string
        typeDisplayName: string
        totalDuration: number
        geoAccessCountries: Array<string>
        geoAccessMode: GeoAccessMode
        publicationLevel: PublicationLevel
        takedownDate: string | undefined
        maxResolution: MaxResolution
        vodConcertType: VodConcertType
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        trailerStreamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
      }
    | {
        __typename: "Work"
        id: string
        title: string
        movements: Array<{ __typename: "Movement"; id: string; title: string }>
        composers: Array<{ __typename: "Artist"; id: string; name: string }>
        genre: { __typename: "Genre"; id: string; title: string } | undefined
      }
  >
}

export type CuratedContentFieldsFragment =
  | CuratedContentFields_Banner_Fragment
  | CuratedContentFields_ListSlider_Fragment

export type CuratedContentLinkFieldsFragment = {
  __typename: "CuratedContentLink"
  id: string
  title: string
  slugV2: string
  pictures: Array<{
    __typename: "Picture"
    id: string
    url: string
    type: PictureType
  }>
}

export type DeviceAttributesFragment = {
  __typename: "Device"
  deviceInfo: string
  id: string
  insertedAt: string
  updatedAt: string
}

export type EditorialPlaylistFieldsFragment = {
  __typename: "EditorialPlaylist"
  id: string
  title: string
  description: string
  metaTitle: string | undefined
  typeDisplayName: string
  metaDescription: string | undefined
  pictures: Array<{
    __typename: "Picture"
    id: string
    url: string
    type: PictureType
  }>
}

export type EditorialPlaylistSectionFieldsFragment = {
  __typename: "EditorialPlaylistSection"
  title: string | undefined
  description: string | undefined
  items: Array<{
    __typename: "Track"
    id: string
    artistDisplayInfo: string | undefined
    artistAndGroupDisplayInfo: string | undefined
    composerDisplayInfo: string | undefined
    duration: number
    title: string
    trackNumber: number
    workDisplayInfo: string | undefined
    artistsAndGroups: Array<
      | { __typename: "TrackArtist"; name: string }
      | { __typename: "TrackGroup"; name: string }
    >
    album: {
      __typename: "Album"
      id: string
      title: string
      pictures: Array<{
        __typename: "Picture"
        id: string
        url: string
        type: PictureType
      }>
    }
    streamVariants: Array<{
      __typename: "StreamVariant"
      manifestType: StreamManifestType
      url: string
      publicationLevel: PublicationLevel
    }>
  }>
}

export type EpochFieldsFragment = {
  __typename: "Epoch"
  id: string
  endYear: number | undefined
  startYear: number | undefined
  title: string
  subtitle: string | undefined
  pictures: Array<{
    __typename: "Picture"
    id: string
    url: string
    type: PictureType
  }>
}

export type GenreFieldsFragment = {
  __typename: "Genre"
  id: string
  title: string
  pictures: Array<{
    __typename: "Picture"
    id: string
    url: string
    type: PictureType
  }>
}

export type GroupFieldsFragment = {
  __typename: "Group"
  id: string
  name: string
  typeDisplayName: string
  pictures: Array<{
    __typename: "Picture"
    id: string
    url: string
    type: PictureType
  }>
}

export type LabelFieldsFragment = {
  __typename: "Label"
  id: string
  title: string
}

export type ListSliderFieldsFragment = {
  __typename: "ListSlider"
  id: string
  headline: string
  totalResults: number
  layout: SliderLayout | undefined
  items: Array<
    | {
        __typename: "Album"
        artistAndGroupDisplayInfo: string | undefined
        id: string
        title: string
        atmosUpc: string | undefined
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | {
        __typename: "Artist"
        id: string
        name: string
        roles: Array<{
          __typename: "Role"
          id: string
          type: RoleType
          displayName: string
        }>
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | { __typename: "BlogArticleLink" }
    | {
        __typename: "CuratedContentLink"
        id: string
        title: string
        slugV2: string
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | {
        __typename: "EditorialPlaylist"
        id: string
        title: string
        description: string
        metaTitle: string | undefined
        typeDisplayName: string
        metaDescription: string | undefined
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | {
        __typename: "Epoch"
        id: string
        endYear: number | undefined
        startYear: number | undefined
        title: string
        subtitle: string | undefined
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | { __typename: "Favorite" }
    | {
        __typename: "Genre"
        id: string
        title: string
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | {
        __typename: "Group"
        id: string
        name: string
        typeDisplayName: string
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | {
        __typename: "LiveConcert"
        endTime: string
        id: string
        publicationLevel: PublicationLevel
        startTime: string
        streamStartTime: string | undefined
        subtitle: string | undefined
        title: string
        typeDisplayName: string
        geoAccessCountries: Array<string>
        geoAccessMode: GeoAccessMode
        finalEndTime: string
        plannedForVod: boolean
        liveConcertType: LiveConcertType
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        reruns: Array<{
          __typename: "LiveConcertRerun"
          streamStartTime: string | undefined
          endTime: string
          startTime: string
          stream: {
            __typename: "RerunStream"
            publicationLevel: PublicationLevel
            streamType: StreamType
            url: string
          }
        }>
        streamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
        trailerStreamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
      }
    | {
        __typename: "Partner"
        id: string
        name: string
        typeDisplayName: string
        subtypeDisplayName: string | undefined
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | { __typename: "Playback" }
    | { __typename: "PlaybackProgress" }
    | {
        __typename: "Video"
        id: string
        archiveReleaseDate: string | undefined
        title: string
        subtitle: string | undefined
        duration: number
        type: VideoType
        typeDisplayName: string
        geoAccessCountries: Array<string>
        geoAccessMode: GeoAccessMode
        publicationLevel: PublicationLevel
        takedownDate: string | undefined
        isAtmos: boolean
        maxResolution: MaxResolution
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        streamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
        trailerStreamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
      }
    | {
        __typename: "VodConcert"
        id: string
        archiveReleaseDate: string | undefined
        subtitle: string | undefined
        title: string
        typeDisplayName: string
        totalDuration: number
        geoAccessCountries: Array<string>
        geoAccessMode: GeoAccessMode
        publicationLevel: PublicationLevel
        takedownDate: string | undefined
        maxResolution: MaxResolution
        vodConcertType: VodConcertType
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        trailerStreamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
      }
    | {
        __typename: "Work"
        id: string
        title: string
        movements: Array<{ __typename: "Movement"; id: string; title: string }>
        composers: Array<{ __typename: "Artist"; id: string; name: string }>
        genre: { __typename: "Genre"; id: string; title: string } | undefined
      }
  >
}

export type LiveConcertFieldsFragment = {
  __typename: "LiveConcert"
  endTime: string
  id: string
  publicationLevel: PublicationLevel
  startTime: string
  streamStartTime: string | undefined
  subtitle: string | undefined
  title: string
  typeDisplayName: string
  geoAccessCountries: Array<string>
  geoAccessMode: GeoAccessMode
  finalEndTime: string
  plannedForVod: boolean
  liveConcertType: LiveConcertType
  pictures: Array<{
    __typename: "Picture"
    id: string
    url: string
    type: PictureType
  }>
  reruns: Array<{
    __typename: "LiveConcertRerun"
    streamStartTime: string | undefined
    endTime: string
    startTime: string
    stream: {
      __typename: "RerunStream"
      publicationLevel: PublicationLevel
      streamType: StreamType
      url: string
    }
  }>
  streamVariants: Array<{
    __typename: "StreamVariant"
    manifestType: StreamManifestType
    url: string
    publicationLevel: PublicationLevel
  }>
  trailerStreamVariants: Array<{
    __typename: "StreamVariant"
    manifestType: StreamManifestType
    url: string
    publicationLevel: PublicationLevel
  }>
}

export type LiveConcertRerunFieldsFragment = {
  __typename: "LiveConcertRerun"
  streamStartTime: string | undefined
  endTime: string
  startTime: string
  stream: {
    __typename: "RerunStream"
    publicationLevel: PublicationLevel
    streamType: StreamType
    url: string
  }
}

export type LivePerformanceWorkFieldsFragment = {
  __typename: "LivePerformanceWork"
  id: string
  duration: number
  artists:
    | {
        __typename: "ArtistWithRoleConnection"
        edges: Array<{
          __typename: "ArtistWithRoleEdge"
          role: {
            __typename: "Role"
            id: string
            type: RoleType
            displayName: string
          }
          node: {
            __typename: "Artist"
            id: string
            name: string
            sortName: string | undefined
          }
        }>
      }
    | undefined
  work: {
    __typename: "Work"
    id: string
    title: string
    movements: Array<{ __typename: "Movement"; id: string; title: string }>
    composers: Array<{ __typename: "Artist"; id: string; name: string }>
    genre: { __typename: "Genre"; id: string; title: string } | undefined
  }
}

export type LiveStreamFieldsFragment = {
  __typename: "LiveStream"
  publicationLevel: PublicationLevel
  streamType: StreamType
  url: string
}

export type PartnerFieldsFragment = {
  __typename: "Partner"
  id: string
  name: string
  typeDisplayName: string
  subtypeDisplayName: string | undefined
  pictures: Array<{
    __typename: "Picture"
    id: string
    url: string
    type: PictureType
  }>
}

export type PerformanceWorkConcertFieldsFragment = {
  __typename: "PerformanceWork"
  id: string
  duration: number
  vodConcert: {
    __typename: "VodConcert"
    id: string
    title: string
    totalDuration: number
    typeDisplayName: string
    publicationLevel: PublicationLevel
    pictures: Array<{
      __typename: "Picture"
      id: string
      url: string
      type: PictureType
    }>
  }
  work: { __typename: "Work"; title: string }
}

export type PerformanceWorkFieldsFragment = {
  __typename: "PerformanceWork"
  id: string
  duration: number
  artists:
    | {
        __typename: "ArtistWithRoleConnection"
        edges: Array<{
          __typename: "ArtistWithRoleEdge"
          role: {
            __typename: "Role"
            id: string
            type: RoleType
            displayName: string
          }
          node: {
            __typename: "Artist"
            id: string
            name: string
            sortName: string | undefined
          }
        }>
      }
    | undefined
  groups:
    | {
        __typename: "GroupConnection"
        edges: Array<{
          __typename: "GroupEdge"
          node: {
            __typename: "Group"
            id: string
            name: string
            typeDisplayName: string
          }
        }>
      }
    | undefined
  work: {
    __typename: "Work"
    id: string
    title: string
    movements: Array<{ __typename: "Movement"; id: string; title: string }>
    composers: Array<{ __typename: "Artist"; id: string; name: string }>
    genre: { __typename: "Genre"; id: string; title: string } | undefined
  }
  streamVariants: Array<{
    __typename: "StreamVariant"
    manifestType: StreamManifestType
    url: string
    publicationLevel: PublicationLevel
  }>
  vodConcert: { __typename: "VodConcert"; id: string }
  cuePoints: Array<{ __typename: "CuePoint"; mark: number; title: string }>
}

export type PictureFieldsFragment = {
  __typename: "Picture"
  id: string
  url: string
  type: PictureType
}

export type RerunStreamFieldsFragment = {
  __typename: "RerunStream"
  publicationLevel: PublicationLevel
  streamType: StreamType
  url: string
}

export type RoleFieldsFragment = {
  __typename: "Role"
  id: string
  type: RoleType
  displayName: string
}

export type SearchImageFieldsFragment = {
  __typename: "SearchImage"
  type: string
  url: string
}

export type SearchVideoFieldsFragment = {
  __typename: "SearchVideosResult"
  totalResults: number
  items: Array<{
    __typename: "SearchVideo"
    id: string
    title: string
    subtitle: string
    duration: number
    geoAccessMode: string
    geoAccessCountries: Array<string | undefined>
    typeDisplayName: string
    videoType: string
    publicationLevel: string
    images: Array<
      { __typename: "SearchImage"; type: string; url: string } | undefined
    >
  }>
}

export type StreamVariantFieldsFragment = {
  __typename: "StreamVariant"
  manifestType: StreamManifestType
  url: string
  publicationLevel: PublicationLevel
}

export type SubscriptionPlansStripeFieldsFragment = {
  __typename: "SubscriptionPlansStripe"
  coupon:
    | {
        __typename: "Coupon"
        productIdsLimitedTo: Array<string>
        percentOff: number
      }
    | undefined
  plans: Array<{
    __typename: "SubscriptionPlanStripe"
    productId: string
    interval: SubscriptionPlanInterval
    trialPeriodDays: number
    prices: Array<{
      __typename: "Price"
      id: string
      currency: string
      amount: number
      amountUndiscounted: number
    }>
  }>
}

export type TrackFieldsFragment = {
  __typename: "Track"
  id: string
  artistDisplayInfo: string | undefined
  artistAndGroupDisplayInfo: string | undefined
  composerDisplayInfo: string | undefined
  duration: number
  title: string
  trackNumber: number
  album: { __typename: "Album"; id: string }
  streamVariants: Array<{
    __typename: "StreamVariant"
    manifestType: StreamManifestType
    url: string
    publicationLevel: PublicationLevel
  }>
}

export type TrackWithAlbumFieldsFragment = {
  __typename: "Track"
  id: string
  artistDisplayInfo: string | undefined
  artistAndGroupDisplayInfo: string | undefined
  composerDisplayInfo: string | undefined
  duration: number
  title: string
  trackNumber: number
  album: {
    __typename: "Album"
    id: string
    artistAndGroupDisplayInfo: string | undefined
    title: string
    atmosUpc: string | undefined
    pictures: Array<{
      __typename: "Picture"
      id: string
      url: string
      type: PictureType
    }>
  }
  streamVariants: Array<{
    __typename: "StreamVariant"
    manifestType: StreamManifestType
    url: string
    publicationLevel: PublicationLevel
  }>
}

export type UserAttributesFragment = {
  __typename: "User"
  academicTitle: string | undefined
  affiliateGroup: string | undefined
  country: string
  email: string
  emailVerified: boolean
  firstName: string
  hasTrialedBefore: boolean
  id: string
  insertedAt: string
  lastName: string
  liveReminderEmail: boolean
  liveReminderPush: boolean
  locale: string
  pushOptin: boolean
  sendNewsletter: boolean
  title: string | undefined
  updatedAt: string
  devices: Array<{
    __typename: "Device"
    deviceInfo: string
    id: string
    insertedAt: string
    updatedAt: string
  }>
  postalAddress:
    | {
        __typename: "PostalAddress"
        city: string | undefined
        country: string | undefined
        firstLine: string | undefined
        insertedAt: string
        secondLine: string | undefined
        state: string | undefined
        updatedAt: string
        zipCode: string | undefined
      }
    | undefined
  ticket:
    | {
        __typename: "Ticket"
        paymentProvider: PaymentProvider
        status: TicketStatus
        validUntil: string | undefined
        isTrial: boolean
      }
    | undefined
}

export type VideoFieldsFragment = {
  __typename: "Video"
  id: string
  archiveReleaseDate: string | undefined
  title: string
  subtitle: string | undefined
  duration: number
  type: VideoType
  typeDisplayName: string
  geoAccessCountries: Array<string>
  geoAccessMode: GeoAccessMode
  publicationLevel: PublicationLevel
  takedownDate: string | undefined
  isAtmos: boolean
  maxResolution: MaxResolution
  pictures: Array<{
    __typename: "Picture"
    id: string
    url: string
    type: PictureType
  }>
  streamVariants: Array<{
    __typename: "StreamVariant"
    manifestType: StreamManifestType
    url: string
    publicationLevel: PublicationLevel
  }>
  trailerStreamVariants: Array<{
    __typename: "StreamVariant"
    manifestType: StreamManifestType
    url: string
    publicationLevel: PublicationLevel
  }>
}

export type VodConcertFieldsFragment = {
  __typename: "VodConcert"
  id: string
  archiveReleaseDate: string | undefined
  subtitle: string | undefined
  title: string
  typeDisplayName: string
  totalDuration: number
  geoAccessCountries: Array<string>
  geoAccessMode: GeoAccessMode
  publicationLevel: PublicationLevel
  takedownDate: string | undefined
  maxResolution: MaxResolution
  vodConcertType: VodConcertType
  pictures: Array<{
    __typename: "Picture"
    id: string
    url: string
    type: PictureType
  }>
  trailerStreamVariants: Array<{
    __typename: "StreamVariant"
    manifestType: StreamManifestType
    url: string
    publicationLevel: PublicationLevel
  }>
}

export type WorkFieldsFragment = {
  __typename: "Work"
  id: string
  title: string
  movements: Array<{ __typename: "Movement"; id: string; title: string }>
  composers: Array<{ __typename: "Artist"; id: string; name: string }>
  genre: { __typename: "Genre"; id: string; title: string } | undefined
}

export type GenrePageQueryVariables = Exact<{
  genreId: Scalars["ID"]
  sliderPageSize?: InputMaybe<Scalars["Int"]>
}>

export type GenrePageQuery = {
  __typename: "RootQueryType"
  genre:
    | {
        __typename: "Genre"
        id: string
        title: string
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        curatedContent: Array<
          | {
              __typename: "Banner"
              description: string
              link: string
              title: string
              pictures: Array<{
                __typename: "Picture"
                id: string
                url: string
                type: PictureType
              }>
            }
          | {
              __typename: "ListSlider"
              id: string
              headline: string
              totalResults: number
              layout: SliderLayout | undefined
              items: Array<
                | {
                    __typename: "Album"
                    artistAndGroupDisplayInfo: string | undefined
                    id: string
                    title: string
                    atmosUpc: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Artist"
                    id: string
                    name: string
                    roles: Array<{
                      __typename: "Role"
                      id: string
                      type: RoleType
                      displayName: string
                    }>
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "BlogArticleLink" }
                | {
                    __typename: "CuratedContentLink"
                    id: string
                    title: string
                    slugV2: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "EditorialPlaylist"
                    id: string
                    title: string
                    description: string
                    metaTitle: string | undefined
                    typeDisplayName: string
                    metaDescription: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Epoch"
                    id: string
                    endYear: number | undefined
                    startYear: number | undefined
                    title: string
                    subtitle: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Favorite" }
                | {
                    __typename: "Genre"
                    id: string
                    title: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Group"
                    id: string
                    name: string
                    typeDisplayName: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "LiveConcert"
                    endTime: string
                    id: string
                    publicationLevel: PublicationLevel
                    startTime: string
                    streamStartTime: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    finalEndTime: string
                    plannedForVod: boolean
                    liveConcertType: LiveConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    reruns: Array<{
                      __typename: "LiveConcertRerun"
                      streamStartTime: string | undefined
                      endTime: string
                      startTime: string
                      stream: {
                        __typename: "RerunStream"
                        publicationLevel: PublicationLevel
                        streamType: StreamType
                        url: string
                      }
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Partner"
                    id: string
                    name: string
                    typeDisplayName: string
                    subtypeDisplayName: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Playback" }
                | { __typename: "PlaybackProgress" }
                | {
                    __typename: "Video"
                    id: string
                    archiveReleaseDate: string | undefined
                    title: string
                    subtitle: string | undefined
                    duration: number
                    type: VideoType
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    isAtmos: boolean
                    maxResolution: MaxResolution
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "VodConcert"
                    id: string
                    archiveReleaseDate: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    totalDuration: number
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    maxResolution: MaxResolution
                    vodConcertType: VodConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Work"
                    id: string
                    title: string
                    movements: Array<{
                      __typename: "Movement"
                      id: string
                      title: string
                    }>
                    composers: Array<{
                      __typename: "Artist"
                      id: string
                      name: string
                    }>
                    genre:
                      | { __typename: "Genre"; id: string; title: string }
                      | undefined
                  }
              >
            }
        >
      }
    | undefined
}

export type GeoInfoQueryVariables = Exact<{ [key: string]: never }>

export type GeoInfoQuery = {
  __typename: "RootQueryType"
  geoinfo: { __typename: "GeoinfoPayload"; countryCode: string } | undefined
}

export type GroupPageQueryVariables = Exact<{
  groupId: Scalars["ID"]
  sliderPageSize?: InputMaybe<Scalars["Int"]>
}>

export type GroupPageQuery = {
  __typename: "RootQueryType"
  group:
    | {
        __typename: "Group"
        id: string
        name: string
        description: string | undefined
        footnote: string | undefined
        typeDisplayName: string
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        curatedContent: Array<
          | {
              __typename: "Banner"
              description: string
              link: string
              title: string
              pictures: Array<{
                __typename: "Picture"
                id: string
                url: string
                type: PictureType
              }>
            }
          | {
              __typename: "ListSlider"
              id: string
              headline: string
              totalResults: number
              layout: SliderLayout | undefined
              items: Array<
                | {
                    __typename: "Album"
                    artistAndGroupDisplayInfo: string | undefined
                    id: string
                    title: string
                    atmosUpc: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Artist"
                    id: string
                    name: string
                    roles: Array<{
                      __typename: "Role"
                      id: string
                      type: RoleType
                      displayName: string
                    }>
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "BlogArticleLink" }
                | {
                    __typename: "CuratedContentLink"
                    id: string
                    title: string
                    slugV2: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "EditorialPlaylist"
                    id: string
                    title: string
                    description: string
                    metaTitle: string | undefined
                    typeDisplayName: string
                    metaDescription: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Epoch"
                    id: string
                    endYear: number | undefined
                    startYear: number | undefined
                    title: string
                    subtitle: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Favorite" }
                | {
                    __typename: "Genre"
                    id: string
                    title: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Group"
                    id: string
                    name: string
                    typeDisplayName: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "LiveConcert"
                    endTime: string
                    id: string
                    publicationLevel: PublicationLevel
                    startTime: string
                    streamStartTime: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    finalEndTime: string
                    plannedForVod: boolean
                    liveConcertType: LiveConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    reruns: Array<{
                      __typename: "LiveConcertRerun"
                      streamStartTime: string | undefined
                      endTime: string
                      startTime: string
                      stream: {
                        __typename: "RerunStream"
                        publicationLevel: PublicationLevel
                        streamType: StreamType
                        url: string
                      }
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Partner"
                    id: string
                    name: string
                    typeDisplayName: string
                    subtypeDisplayName: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Playback" }
                | { __typename: "PlaybackProgress" }
                | {
                    __typename: "Video"
                    id: string
                    archiveReleaseDate: string | undefined
                    title: string
                    subtitle: string | undefined
                    duration: number
                    type: VideoType
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    isAtmos: boolean
                    maxResolution: MaxResolution
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "VodConcert"
                    id: string
                    archiveReleaseDate: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    totalDuration: number
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    maxResolution: MaxResolution
                    vodConcertType: VodConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Work"
                    id: string
                    title: string
                    movements: Array<{
                      __typename: "Movement"
                      id: string
                      title: string
                    }>
                    composers: Array<{
                      __typename: "Artist"
                      id: string
                      name: string
                    }>
                    genre:
                      | { __typename: "Genre"; id: string; title: string }
                      | undefined
                  }
              >
            }
        >
      }
    | undefined
}

export type InfoModalQueryVariables = Exact<{
  nodeId: Scalars["ID"]
  sliderPageSize?: InputMaybe<Scalars["Int"]>
}>

export type InfoModalQuery = {
  __typename: "RootQueryType"
  node:
    | {
        __typename: "Album"
        atmosUpc: string | undefined
        id: string
        phonographicCopyright: string
        releaseDate: string | undefined
        title: string
        totalDuration: number
        upc: string
        artistAndGroupDisplayInfo: string | undefined
        albumCopyright: string
        artists:
          | {
              __typename: "ArtistWithRoleConnection"
              edges: Array<{
                __typename: "ArtistWithRoleEdge"
                role: {
                  __typename: "Role"
                  id: string
                  type: RoleType
                  displayName: string
                }
                node: {
                  __typename: "Artist"
                  id: string
                  name: string
                  sortName: string | undefined
                }
              }>
            }
          | undefined
        groups: Array<{
          __typename: "Group"
          id: string
          name: string
          typeDisplayName: string
        }>
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | { __typename: "Article" }
    | {
        __typename: "Artist"
        id: string
        name: string
        biography: string | undefined
        dateOfBirth: string | undefined
        dateOfDeath: string | undefined
        courtesyOf: string | undefined
        roles: Array<{
          __typename: "Role"
          id: string
          type: RoleType
          displayName: string
        }>
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | { __typename: "BlogArticleLink" }
    | { __typename: "CuratedContentLink" }
    | { __typename: "EditorialPlaylist" }
    | {
        __typename: "Epoch"
        id: string
        title: string
        subtitle: string | undefined
        description: string | undefined
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | { __typename: "Favorite" }
    | {
        __typename: "Genre"
        id: string
        title: string
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | {
        __typename: "Group"
        id: string
        name: string
        description: string | undefined
        footnote: string | undefined
        typeDisplayName: string
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        curatedContent: Array<
          | {
              __typename: "Banner"
              description: string
              link: string
              title: string
              pictures: Array<{
                __typename: "Picture"
                id: string
                url: string
                type: PictureType
              }>
            }
          | {
              __typename: "ListSlider"
              id: string
              headline: string
              totalResults: number
              layout: SliderLayout | undefined
              items: Array<
                | {
                    __typename: "Album"
                    artistAndGroupDisplayInfo: string | undefined
                    id: string
                    title: string
                    atmosUpc: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Artist"
                    id: string
                    name: string
                    roles: Array<{
                      __typename: "Role"
                      id: string
                      type: RoleType
                      displayName: string
                    }>
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "BlogArticleLink" }
                | {
                    __typename: "CuratedContentLink"
                    id: string
                    title: string
                    slugV2: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "EditorialPlaylist"
                    id: string
                    title: string
                    description: string
                    metaTitle: string | undefined
                    typeDisplayName: string
                    metaDescription: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Epoch"
                    id: string
                    endYear: number | undefined
                    startYear: number | undefined
                    title: string
                    subtitle: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Favorite" }
                | {
                    __typename: "Genre"
                    id: string
                    title: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Group"
                    id: string
                    name: string
                    typeDisplayName: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "LiveConcert"
                    endTime: string
                    id: string
                    publicationLevel: PublicationLevel
                    startTime: string
                    streamStartTime: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    finalEndTime: string
                    plannedForVod: boolean
                    liveConcertType: LiveConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    reruns: Array<{
                      __typename: "LiveConcertRerun"
                      streamStartTime: string | undefined
                      endTime: string
                      startTime: string
                      stream: {
                        __typename: "RerunStream"
                        publicationLevel: PublicationLevel
                        streamType: StreamType
                        url: string
                      }
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Partner"
                    id: string
                    name: string
                    typeDisplayName: string
                    subtypeDisplayName: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Playback" }
                | { __typename: "PlaybackProgress" }
                | {
                    __typename: "Video"
                    id: string
                    archiveReleaseDate: string | undefined
                    title: string
                    subtitle: string | undefined
                    duration: number
                    type: VideoType
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    isAtmos: boolean
                    maxResolution: MaxResolution
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "VodConcert"
                    id: string
                    archiveReleaseDate: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    totalDuration: number
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    maxResolution: MaxResolution
                    vodConcertType: VodConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Work"
                    id: string
                    title: string
                    movements: Array<{
                      __typename: "Movement"
                      id: string
                      title: string
                    }>
                    composers: Array<{
                      __typename: "Artist"
                      id: string
                      name: string
                    }>
                    genre:
                      | { __typename: "Genre"; id: string; title: string }
                      | undefined
                  }
              >
            }
        >
      }
    | { __typename: "Label" }
    | {
        __typename: "LiveConcert"
        copyright: string | undefined
        id: string
        isrc: string | undefined
        longFormConcertIntroduction: string | undefined
        photographer: string | undefined
        production: string | undefined
        shortDescription: string | undefined
        subtitle: string | undefined
        title: string
        totalDuration: number
        typeDisplayName: string
        videoDirector: string | undefined
        artists:
          | {
              __typename: "ArtistWithRoleConnection"
              edges: Array<{
                __typename: "ArtistWithRoleEdge"
                role: {
                  __typename: "Role"
                  id: string
                  type: RoleType
                  displayName: string
                }
                node: {
                  __typename: "Artist"
                  id: string
                  name: string
                  sortName: string | undefined
                }
              }>
            }
          | undefined
        groups: Array<{
          __typename: "Group"
          id: string
          name: string
          typeDisplayName: string
        }>
        partners: Array<{
          __typename: "Partner"
          name: string
          type: PartnerType
        }>
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | { __typename: "LivePerformanceWork" }
    | { __typename: "Movement" }
    | {
        __typename: "Partner"
        id: string
        name: string
        description: string | undefined
        typeDisplayName: string
        subtypeDisplayName: string | undefined
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | { __typename: "PerformanceWork" }
    | { __typename: "Picture" }
    | { __typename: "Playback" }
    | { __typename: "PlaybackProgress" }
    | { __typename: "PlaybackProgressV2" }
    | { __typename: "Role" }
    | { __typename: "Slider" }
    | { __typename: "Track" }
    | {
        __typename: "Video"
        description: string | undefined
        copyright: string | undefined
        duration: number
        id: string
        isrc: string | undefined
        photographer: string | undefined
        production: string | undefined
        productionDate: string | undefined
        subtitle: string | undefined
        takedownDate: string | undefined
        title: string
        typeDisplayName: string
        videoDirector: string | undefined
        artists:
          | {
              __typename: "ArtistWithRoleConnection"
              edges: Array<{
                __typename: "ArtistWithRoleEdge"
                role: {
                  __typename: "Role"
                  id: string
                  type: RoleType
                  displayName: string
                }
                node: {
                  __typename: "Artist"
                  id: string
                  name: string
                  sortName: string | undefined
                }
              }>
            }
          | undefined
        groups: Array<{
          __typename: "Group"
          id: string
          name: string
          typeDisplayName: string
        }>
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | {
        __typename: "VodConcert"
        copyright: string | undefined
        id: string
        isrc: string | undefined
        photographer: string | undefined
        production: string | undefined
        productionDate: string | undefined
        longFormConcertIntroduction: string | undefined
        shortDescription: string | undefined
        subtitle: string | undefined
        takedownDate: string | undefined
        title: string
        totalDuration: number
        typeDisplayName: string
        videoDirector: string | undefined
        artists:
          | {
              __typename: "ArtistWithRoleConnection"
              edges: Array<{
                __typename: "ArtistWithRoleEdge"
                role: {
                  __typename: "Role"
                  id: string
                  type: RoleType
                  displayName: string
                }
                node: {
                  __typename: "Artist"
                  id: string
                  name: string
                  sortName: string | undefined
                }
              }>
            }
          | undefined
        groups: Array<{
          __typename: "Group"
          id: string
          name: string
          typeDisplayName: string
        }>
        partners: Array<{
          __typename: "Partner"
          name: string
          type: PartnerType
        }>
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | { __typename: "Work" }
    | undefined
}

export type AddFavoriteMutationVariables = Exact<{
  input: InputMaybe<AddFavoriteInput>
}>

export type AddFavoriteMutation = {
  __typename: "RootMutationType"
  addFavorite:
    | {
        __typename: "AddFavoritePayload"
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
        result: { __typename: "Favorite"; id: string } | undefined
      }
    | undefined
}

export type CancelStripeSubscriptionMutationVariables = Exact<{
  [key: string]: never
}>

export type CancelStripeSubscriptionMutation = {
  __typename: "RootMutationType"
  cancelStripeSubscription:
    | {
        __typename: "CancelSubscriptionPayload"
        result:
          | {
              __typename: "SubscriptionCancelation"
              ticketTerminatesAt: string
            }
          | undefined
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
      }
    | undefined
}

export type ChangePasswordMutationVariables = Exact<{
  input: InputMaybe<ChangePasswordInput>
}>

export type ChangePasswordMutation = {
  __typename: "RootMutationType"
  changePassword:
    | {
        __typename: "ChangePasswordPayload"
        result: boolean | undefined
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
      }
    | undefined
}

export type ChangeStripePaymentMethodMutationVariables = Exact<{
  [key: string]: never
}>

export type ChangeStripePaymentMethodMutation = {
  __typename: "RootMutationType"
  changeStripePaymentMethod:
    | {
        __typename: "ChangeStripePaymentMethodPayload"
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
        result:
          | { __typename: "SetupIntentClientSecret"; clientSecret: string }
          | undefined
      }
    | undefined
}

export type ConsentTrackingMutationVariables = Exact<{
  input: InputMaybe<ConsentTrackingInput>
}>

export type ConsentTrackingMutation = {
  __typename: "RootMutationType"
  consentTracking:
    | {
        __typename: "ConsentTrackingPayload"
        result: boolean | undefined
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
      }
    | undefined
}

export type DeleteUserMutationVariables = Exact<{ [key: string]: never }>

export type DeleteUserMutation = {
  __typename: "RootMutationType"
  deleteUser:
    | {
        __typename: "DeleteUserPayload"
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
        result: { __typename: "User"; email: string } | undefined
      }
    | undefined
}

export type GeneratePinCodeMutationVariables = Exact<{ [key: string]: never }>

export type GeneratePinCodeMutation = {
  __typename: "RootMutationType"
  generatePinCode:
    | {
        __typename: "GeneratePinCodePayload"
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
        result:
          | { __typename: "PinCode"; expiresAt: string; pinCode: string }
          | undefined
      }
    | undefined
}

export type LoginWithPinMutationVariables = Exact<{
  input: InputMaybe<LoginUserWithPinCodeInput>
}>

export type LoginWithPinMutation = {
  __typename: "RootMutationType"
  loginUserWithPinCode:
    | {
        __typename: "LoginUserWithPinCodePayload"
        errors:
          | Array<
              | {
                  __typename: "BasicError"
                  message: string
                  path: Array<string>
                }
              | {
                  __typename: "ValidationError"
                  message: string
                  path: Array<string>
                }
            >
          | undefined
        result:
          | {
              __typename: "UserAndToken"
              accessToken: string
              refreshToken: string
              user: {
                __typename: "User"
                academicTitle: string | undefined
                affiliateGroup: string | undefined
                country: string
                email: string
                emailVerified: boolean
                firstName: string
                hasTrialedBefore: boolean
                id: string
                insertedAt: string
                lastName: string
                liveReminderEmail: boolean
                liveReminderPush: boolean
                locale: string
                pushOptin: boolean
                sendNewsletter: boolean
                title: string | undefined
                updatedAt: string
                devices: Array<{
                  __typename: "Device"
                  deviceInfo: string
                  id: string
                  insertedAt: string
                  updatedAt: string
                }>
                postalAddress:
                  | {
                      __typename: "PostalAddress"
                      city: string | undefined
                      country: string | undefined
                      firstLine: string | undefined
                      insertedAt: string
                      secondLine: string | undefined
                      state: string | undefined
                      updatedAt: string
                      zipCode: string | undefined
                    }
                  | undefined
                ticket:
                  | {
                      __typename: "Ticket"
                      paymentProvider: PaymentProvider
                      status: TicketStatus
                      validUntil: string | undefined
                      isTrial: boolean
                    }
                  | undefined
              }
            }
          | undefined
      }
    | undefined
}

export type ReactivateStripeSubscriptionMutationVariables = Exact<{
  [key: string]: never
}>

export type ReactivateStripeSubscriptionMutation = {
  __typename: "RootMutationType"
  reactivateStripeSubscription:
    | {
        __typename: "ReactivateSubscriptionPayload"
        result:
          | {
              __typename: "Ticket"
              status: TicketStatus
              validUntil: string | undefined
            }
          | undefined
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
      }
    | undefined
}

export type RecordPlaybackProgressMutationVariables = Exact<{
  input: RecordPlaybackProgressInputV2
}>

export type RecordPlaybackProgressMutation = {
  __typename: "RootMutationType"
  recordPlaybackProgressV2:
    | {
        __typename: "RecordPlaybackProgressPayloadV2"
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
        result: { __typename: "PlaybackProgressV2"; id: string } | undefined
      }
    | undefined
}

export type RegisterUserMutationVariables = Exact<{
  input: InputMaybe<RegisterUserInput>
}>

export type RegisterUserMutation = {
  __typename: "RootMutationType"
  registerUser:
    | {
        __typename: "RegisterUserPayload"
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
        result:
          | {
              __typename: "UserAndToken"
              accessToken: string
              refreshToken: string
              user: { __typename: "User"; locale: string }
            }
          | undefined
      }
    | undefined
}

export type RemoveDeviceMutationVariables = Exact<{
  input: InputMaybe<RemoveDeviceInput>
}>

export type RemoveDeviceMutation = {
  __typename: "RootMutationType"
  removeDevice:
    | {
        __typename: "RemoveDeviceInputPayload"
        result: string | undefined
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
      }
    | undefined
}

export type RemoveFavoriteByContentIdMutationVariables = Exact<{
  input: InputMaybe<RemoveFavoriteByContentIdInput>
}>

export type RemoveFavoriteByContentIdMutation = {
  __typename: "RootMutationType"
  removeFavoriteByContentId:
    | {
        __typename: "RemoveFavoriteByContentIdPayload"
        result: boolean | undefined
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
      }
    | undefined
}

export type RemoveFavoriteByContentTypeMutationVariables = Exact<{
  input: InputMaybe<RemoveFavoriteByContentTypeInput>
}>

export type RemoveFavoriteByContentTypeMutation = {
  __typename: "RootMutationType"
  removeFavoriteByContentType:
    | {
        __typename: "RemoveFavoriteByContentTypePayload"
        result: boolean | undefined
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
      }
    | undefined
}

export type ResendEmailConfirmationMutationVariables = Exact<{
  [key: string]: never
}>

export type ResendEmailConfirmationMutation = {
  __typename: "RootMutationType"
  resendEmailConfirmation:
    | {
        __typename: "ResendEmailConfirmationPayload"
        result: boolean | undefined
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
      }
    | undefined
}

export type ResetAllPlaybackProgressMutationVariables = Exact<{
  [key: string]: never
}>

export type ResetAllPlaybackProgressMutation = {
  __typename: "RootMutationType"
  resetAllPlaybackProgress:
    | {
        __typename: "ResetAllPlaybackProgressPayload"
        result: boolean | undefined
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
      }
    | undefined
}

export type ResetPasswordMutationVariables = Exact<{
  input: InputMaybe<ResetPasswordInput>
}>

export type ResetPasswordMutation = {
  __typename: "RootMutationType"
  resetPassword:
    | {
        __typename: "ResetPasswordPayload"
        result: boolean | undefined
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
      }
    | undefined
}

export type SendChangeEmailAddressEmailMutationVariables = Exact<{
  input: InputMaybe<SendChangeEmailAddressEmailInput>
}>

export type SendChangeEmailAddressEmailMutation = {
  __typename: "RootMutationType"
  sendChangeEmailAddressEmail:
    | {
        __typename: "SendChangeEmailAddressEmailPayload"
        result: boolean | undefined
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
      }
    | undefined
}

export type SendResetPasswordEmailMutationVariables = Exact<{
  input: InputMaybe<SendResetPasswordEmailInput>
}>

export type SendResetPasswordEmailMutation = {
  __typename: "RootMutationType"
  sendResetPasswordEmail:
    | {
        __typename: "SendResetPasswordEmailPayload"
        result: boolean | undefined
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
      }
    | undefined
}

export type SubscribeDgNewsletterMutationVariables = Exact<{
  input: InputMaybe<SubscribeDgNewsletterInput>
}>

export type SubscribeDgNewsletterMutation = {
  __typename: "RootMutationType"
  subscribeDgNewsletter:
    | {
        __typename: "SubscribeDgNewsletterPayload"
        result: boolean | undefined
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
      }
    | undefined
}

export type SubscribeStagePlusEmailNotificationMutationVariables = Exact<{
  [key: string]: never
}>

export type SubscribeStagePlusEmailNotificationMutation = {
  __typename: "RootMutationType"
  subscribeStagePlusEmailNotification:
    | {
        __typename: "SubscribeStagePlusEmailNotificationPayload"
        result: boolean | undefined
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
      }
    | undefined
}

export type SubscribeViaStripeMutationVariables = Exact<{
  input: InputMaybe<SubscribeViaStripeInput>
}>

export type SubscribeViaStripeMutation = {
  __typename: "RootMutationType"
  subscribeViaStripe:
    | {
        __typename: "SubscribeViaStripePayload"
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
        result:
          | { __typename: "PaymentIntentClientSecret"; clientSecret: string }
          | { __typename: "SetupIntentClientSecret"; clientSecret: string }
          | undefined
      }
    | undefined
}

export type UpdatePostalAddressMutationVariables = Exact<{
  input: InputMaybe<UpdatePostalAddressInput>
}>

export type UpdatePostalAddressMutation = {
  __typename: "RootMutationType"
  updatePostalAddress:
    | {
        __typename: "UpdatePostalAddressPayload"
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
      }
    | undefined
}

export type UpdateUserMutationVariables = Exact<{
  input: InputMaybe<UpdateUserInput>
}>

export type UpdateUserMutation = {
  __typename: "RootMutationType"
  updateUser:
    | {
        __typename: "UpdateUserPayload"
        errors:
          | Array<
              | { __typename: "BasicError"; message: string }
              | {
                  __typename: "ValidationError"
                  message: string
                  validation: string
                  field: string
                }
            >
          | undefined
      }
    | undefined
}

export type MyStagePageQueryVariables = Exact<{
  sliderPageSize: Scalars["Int"]
  cursor: InputMaybe<Scalars["String"]>
}>

export type MyStagePageQuery = {
  __typename: "RootQueryType"
  currentUser:
    | {
        __typename: "User"
        videoFavorites:
          | {
              __typename: "FavoriteConnection"
              totalResults: number
              edges: Array<{
                __typename: "FavoriteEdge"
                node: {
                  __typename: "Favorite"
                  id: string
                  content:
                    | { __typename: "Album" }
                    | { __typename: "EditorialPlaylist" }
                    | {
                        __typename: "PerformanceWork"
                        id: string
                        duration: number
                        vodConcert: {
                          __typename: "VodConcert"
                          id: string
                          title: string
                          totalDuration: number
                          typeDisplayName: string
                          publicationLevel: PublicationLevel
                          pictures: Array<{
                            __typename: "Picture"
                            id: string
                            url: string
                            type: PictureType
                          }>
                        }
                        work: { __typename: "Work"; title: string }
                      }
                    | {
                        __typename: "Video"
                        id: string
                        archiveReleaseDate: string | undefined
                        title: string
                        subtitle: string | undefined
                        duration: number
                        type: VideoType
                        typeDisplayName: string
                        geoAccessCountries: Array<string>
                        geoAccessMode: GeoAccessMode
                        publicationLevel: PublicationLevel
                        takedownDate: string | undefined
                        isAtmos: boolean
                        maxResolution: MaxResolution
                        pictures: Array<{
                          __typename: "Picture"
                          id: string
                          url: string
                          type: PictureType
                        }>
                        streamVariants: Array<{
                          __typename: "StreamVariant"
                          manifestType: StreamManifestType
                          url: string
                          publicationLevel: PublicationLevel
                        }>
                        trailerStreamVariants: Array<{
                          __typename: "StreamVariant"
                          manifestType: StreamManifestType
                          url: string
                          publicationLevel: PublicationLevel
                        }>
                      }
                }
              }>
              pageInfo: {
                __typename: "PageInfo"
                hasNextPage: boolean
                endCursor: string | undefined
              }
            }
          | undefined
        albumFavorites:
          | {
              __typename: "FavoriteConnection"
              totalResults: number
              edges: Array<{
                __typename: "FavoriteEdge"
                node: {
                  __typename: "Favorite"
                  id: string
                  content:
                    | {
                        __typename: "Album"
                        artistAndGroupDisplayInfo: string | undefined
                        id: string
                        title: string
                        atmosUpc: string | undefined
                        pictures: Array<{
                          __typename: "Picture"
                          id: string
                          url: string
                          type: PictureType
                        }>
                      }
                    | { __typename: "EditorialPlaylist" }
                    | { __typename: "PerformanceWork" }
                    | { __typename: "Video" }
                }
              }>
              pageInfo: {
                __typename: "PageInfo"
                hasNextPage: boolean
                endCursor: string | undefined
              }
            }
          | undefined
        editorialPlaylistFavorites:
          | {
              __typename: "FavoriteConnection"
              totalResults: number
              edges: Array<{
                __typename: "FavoriteEdge"
                node: {
                  __typename: "Favorite"
                  id: string
                  content:
                    | { __typename: "Album" }
                    | {
                        __typename: "EditorialPlaylist"
                        id: string
                        title: string
                        description: string
                        metaTitle: string | undefined
                        typeDisplayName: string
                        metaDescription: string | undefined
                        pictures: Array<{
                          __typename: "Picture"
                          id: string
                          url: string
                          type: PictureType
                        }>
                      }
                    | { __typename: "PerformanceWork" }
                    | { __typename: "Video" }
                }
              }>
              pageInfo: {
                __typename: "PageInfo"
                hasNextPage: boolean
                endCursor: string | undefined
              }
            }
          | undefined
        videoRecentlyPlayed:
          | {
              __typename: "PlaybackProgressConnection"
              totalResults: number
              edges: Array<{
                __typename: "PlaybackProgressEdge"
                node: {
                  __typename: "PlaybackProgress"
                  id: string
                  mark: number
                  content:
                    | {
                        __typename: "PerformanceWork"
                        id: string
                        duration: number
                        vodConcert: {
                          __typename: "VodConcert"
                          id: string
                          title: string
                          totalDuration: number
                          typeDisplayName: string
                          publicationLevel: PublicationLevel
                          pictures: Array<{
                            __typename: "Picture"
                            id: string
                            url: string
                            type: PictureType
                          }>
                        }
                        work: { __typename: "Work"; title: string }
                      }
                    | { __typename: "Track" }
                    | {
                        __typename: "Video"
                        id: string
                        archiveReleaseDate: string | undefined
                        title: string
                        subtitle: string | undefined
                        duration: number
                        type: VideoType
                        typeDisplayName: string
                        geoAccessCountries: Array<string>
                        geoAccessMode: GeoAccessMode
                        publicationLevel: PublicationLevel
                        takedownDate: string | undefined
                        isAtmos: boolean
                        maxResolution: MaxResolution
                        pictures: Array<{
                          __typename: "Picture"
                          id: string
                          url: string
                          type: PictureType
                        }>
                        streamVariants: Array<{
                          __typename: "StreamVariant"
                          manifestType: StreamManifestType
                          url: string
                          publicationLevel: PublicationLevel
                        }>
                        trailerStreamVariants: Array<{
                          __typename: "StreamVariant"
                          manifestType: StreamManifestType
                          url: string
                          publicationLevel: PublicationLevel
                        }>
                      }
                }
              }>
              pageInfo: {
                __typename: "PageInfo"
                hasNextPage: boolean
                endCursor: string | undefined
              }
            }
          | undefined
        albumRecentlyPlayed:
          | {
              __typename: "PlaybackProgressConnection"
              totalResults: number
              edges: Array<{
                __typename: "PlaybackProgressEdge"
                node: {
                  __typename: "PlaybackProgress"
                  id: string
                  mark: number
                  content:
                    | { __typename: "PerformanceWork" }
                    | {
                        __typename: "Track"
                        id: string
                        artistDisplayInfo: string | undefined
                        artistAndGroupDisplayInfo: string | undefined
                        composerDisplayInfo: string | undefined
                        duration: number
                        title: string
                        trackNumber: number
                        album: {
                          __typename: "Album"
                          id: string
                          artistAndGroupDisplayInfo: string | undefined
                          title: string
                          atmosUpc: string | undefined
                          pictures: Array<{
                            __typename: "Picture"
                            id: string
                            url: string
                            type: PictureType
                          }>
                        }
                        streamVariants: Array<{
                          __typename: "StreamVariant"
                          manifestType: StreamManifestType
                          url: string
                          publicationLevel: PublicationLevel
                        }>
                      }
                    | { __typename: "Video" }
                }
              }>
              pageInfo: {
                __typename: "PageInfo"
                hasNextPage: boolean
                endCursor: string | undefined
              }
            }
          | undefined
      }
    | undefined
}

export type PartnerPageQueryVariables = Exact<{
  partnerId: Scalars["ID"]
  sliderPageSize?: InputMaybe<Scalars["Int"]>
}>

export type PartnerPageQuery = {
  __typename: "RootQueryType"
  partner:
    | {
        __typename: "Partner"
        id: string
        name: string
        description: string | undefined
        typeDisplayName: string
        subtypeDisplayName: string | undefined
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        curatedContent: Array<
          | {
              __typename: "Banner"
              description: string
              link: string
              title: string
              pictures: Array<{
                __typename: "Picture"
                id: string
                url: string
                type: PictureType
              }>
            }
          | {
              __typename: "ListSlider"
              id: string
              headline: string
              totalResults: number
              layout: SliderLayout | undefined
              items: Array<
                | {
                    __typename: "Album"
                    artistAndGroupDisplayInfo: string | undefined
                    id: string
                    title: string
                    atmosUpc: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Artist"
                    id: string
                    name: string
                    roles: Array<{
                      __typename: "Role"
                      id: string
                      type: RoleType
                      displayName: string
                    }>
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "BlogArticleLink" }
                | {
                    __typename: "CuratedContentLink"
                    id: string
                    title: string
                    slugV2: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "EditorialPlaylist"
                    id: string
                    title: string
                    description: string
                    metaTitle: string | undefined
                    typeDisplayName: string
                    metaDescription: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Epoch"
                    id: string
                    endYear: number | undefined
                    startYear: number | undefined
                    title: string
                    subtitle: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Favorite" }
                | {
                    __typename: "Genre"
                    id: string
                    title: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Group"
                    id: string
                    name: string
                    typeDisplayName: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "LiveConcert"
                    endTime: string
                    id: string
                    publicationLevel: PublicationLevel
                    startTime: string
                    streamStartTime: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    finalEndTime: string
                    plannedForVod: boolean
                    liveConcertType: LiveConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    reruns: Array<{
                      __typename: "LiveConcertRerun"
                      streamStartTime: string | undefined
                      endTime: string
                      startTime: string
                      stream: {
                        __typename: "RerunStream"
                        publicationLevel: PublicationLevel
                        streamType: StreamType
                        url: string
                      }
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Partner"
                    id: string
                    name: string
                    typeDisplayName: string
                    subtypeDisplayName: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Playback" }
                | { __typename: "PlaybackProgress" }
                | {
                    __typename: "Video"
                    id: string
                    archiveReleaseDate: string | undefined
                    title: string
                    subtitle: string | undefined
                    duration: number
                    type: VideoType
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    isAtmos: boolean
                    maxResolution: MaxResolution
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "VodConcert"
                    id: string
                    archiveReleaseDate: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    totalDuration: number
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    maxResolution: MaxResolution
                    vodConcertType: VodConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Work"
                    id: string
                    title: string
                    movements: Array<{
                      __typename: "Movement"
                      id: string
                      title: string
                    }>
                    composers: Array<{
                      __typename: "Artist"
                      id: string
                      name: string
                    }>
                    genre:
                      | { __typename: "Genre"; id: string; title: string }
                      | undefined
                  }
              >
            }
        >
      }
    | undefined
}

export type PaymentPageQueryVariables = Exact<{
  couponCode: InputMaybe<Scalars["String"]>
}>

export type PaymentPageQuery = {
  __typename: "RootQueryType"
  subscriptionPlansStripe: {
    __typename: "SubscriptionPlansStripe"
    coupon:
      | {
          __typename: "Coupon"
          productIdsLimitedTo: Array<string>
          percentOff: number
        }
      | undefined
    plans: Array<{
      __typename: "SubscriptionPlanStripe"
      productId: string
      interval: SubscriptionPlanInterval
      trialPeriodDays: number
      prices: Array<{
        __typename: "Price"
        id: string
        currency: string
        amount: number
        amountUndiscounted: number
      }>
    }>
  }
}

export type PlaybackProgressQueryVariables = Exact<{
  id: Scalars["ID"]
}>

export type PlaybackProgressQuery = {
  __typename: "RootQueryType"
  playbackProgressByContentId:
    | { __typename: "PlaybackProgress"; mark: number }
    | undefined
}

export type PlayerContentQueryVariables = Exact<{
  contentId: Scalars["ID"]
}>

export type PlayerContentQuery = {
  __typename: "RootQueryType"
  node:
    | {
        __typename: "Album"
        atmosUpc: string | undefined
        totalDuration: number
        releaseDate: string | undefined
        artistAndGroupDisplayInfo: string | undefined
        id: string
        title: string
        groups: Array<{
          __typename: "Group"
          id: string
          name: string
          typeDisplayName: string
          pictures: Array<{
            __typename: "Picture"
            id: string
            url: string
            type: PictureType
          }>
        }>
        trackSets: Array<{
          __typename: "TrackSet"
          composerDisplayInfo: string | undefined
          title: string | undefined
          trackSetNumber: number
          tracks: Array<{
            __typename: "Track"
            id: string
            artistDisplayInfo: string | undefined
            artistAndGroupDisplayInfo: string | undefined
            composerDisplayInfo: string | undefined
            duration: number
            title: string
            trackNumber: number
            album: { __typename: "Album"; id: string }
            streamVariants: Array<{
              __typename: "StreamVariant"
              manifestType: StreamManifestType
              url: string
              publicationLevel: PublicationLevel
            }>
          }>
        }>
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | { __typename: "Article" }
    | { __typename: "Artist" }
    | { __typename: "BlogArticleLink" }
    | { __typename: "CuratedContentLink" }
    | { __typename: "EditorialPlaylist" }
    | { __typename: "Epoch" }
    | { __typename: "Favorite" }
    | { __typename: "Genre" }
    | { __typename: "Group" }
    | { __typename: "Label" }
    | {
        __typename: "LiveConcert"
        shortDescription: string | undefined
        endTime: string
        id: string
        publicationLevel: PublicationLevel
        startTime: string
        streamStartTime: string | undefined
        subtitle: string | undefined
        title: string
        typeDisplayName: string
        geoAccessCountries: Array<string>
        geoAccessMode: GeoAccessMode
        finalEndTime: string
        plannedForVod: boolean
        liveConcertType: LiveConcertType
        artists:
          | {
              __typename: "ArtistWithRoleConnection"
              edges: Array<{
                __typename: "ArtistWithRoleEdge"
                role: {
                  __typename: "Role"
                  id: string
                  type: RoleType
                  displayName: string
                }
                node: {
                  __typename: "Artist"
                  id: string
                  name: string
                  sortName: string | undefined
                }
              }>
            }
          | undefined
        groups: Array<{
          __typename: "Group"
          id: string
          name: string
          type: GroupType
        }>
        performanceWorks: Array<{
          __typename: "LivePerformanceWork"
          id: string
          duration: number
          artists:
            | {
                __typename: "ArtistWithRoleConnection"
                edges: Array<{
                  __typename: "ArtistWithRoleEdge"
                  role: {
                    __typename: "Role"
                    id: string
                    type: RoleType
                    displayName: string
                  }
                  node: {
                    __typename: "Artist"
                    id: string
                    name: string
                    sortName: string | undefined
                  }
                }>
              }
            | undefined
          work: {
            __typename: "Work"
            id: string
            title: string
            movements: Array<{
              __typename: "Movement"
              id: string
              title: string
            }>
            composers: Array<{ __typename: "Artist"; id: string; name: string }>
            genre:
              | { __typename: "Genre"; id: string; title: string }
              | undefined
          }
        }>
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        reruns: Array<{
          __typename: "LiveConcertRerun"
          streamStartTime: string | undefined
          endTime: string
          startTime: string
          stream: {
            __typename: "RerunStream"
            publicationLevel: PublicationLevel
            streamType: StreamType
            url: string
          }
        }>
        streamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
        trailerStreamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
      }
    | { __typename: "LivePerformanceWork" }
    | { __typename: "Movement" }
    | { __typename: "Partner" }
    | { __typename: "PerformanceWork" }
    | { __typename: "Picture" }
    | { __typename: "Playback" }
    | { __typename: "PlaybackProgress" }
    | { __typename: "PlaybackProgressV2" }
    | { __typename: "Role" }
    | { __typename: "Slider" }
    | { __typename: "Track" }
    | {
        __typename: "Video"
        description: string | undefined
        id: string
        archiveReleaseDate: string | undefined
        title: string
        subtitle: string | undefined
        duration: number
        type: VideoType
        typeDisplayName: string
        geoAccessCountries: Array<string>
        geoAccessMode: GeoAccessMode
        publicationLevel: PublicationLevel
        takedownDate: string | undefined
        isAtmos: boolean
        maxResolution: MaxResolution
        artists:
          | {
              __typename: "ArtistWithRoleConnection"
              edges: Array<{
                __typename: "ArtistWithRoleEdge"
                role: {
                  __typename: "Role"
                  id: string
                  type: RoleType
                  displayName: string
                }
                node: {
                  __typename: "Artist"
                  id: string
                  name: string
                  sortName: string | undefined
                }
              }>
            }
          | undefined
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        streamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
        trailerStreamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
      }
    | {
        __typename: "VodConcert"
        shortDescription: string | undefined
        id: string
        archiveReleaseDate: string | undefined
        subtitle: string | undefined
        title: string
        typeDisplayName: string
        totalDuration: number
        geoAccessCountries: Array<string>
        geoAccessMode: GeoAccessMode
        publicationLevel: PublicationLevel
        takedownDate: string | undefined
        maxResolution: MaxResolution
        vodConcertType: VodConcertType
        artists:
          | {
              __typename: "ArtistWithRoleConnection"
              edges: Array<{
                __typename: "ArtistWithRoleEdge"
                role: {
                  __typename: "Role"
                  id: string
                  type: RoleType
                  displayName: string
                }
                node: {
                  __typename: "Artist"
                  id: string
                  name: string
                  sortName: string | undefined
                }
              }>
            }
          | undefined
        groups: Array<{
          __typename: "Group"
          id: string
          name: string
          type: GroupType
        }>
        performanceWorks: Array<{
          __typename: "PerformanceWork"
          id: string
          duration: number
          artists:
            | {
                __typename: "ArtistWithRoleConnection"
                edges: Array<{
                  __typename: "ArtistWithRoleEdge"
                  role: {
                    __typename: "Role"
                    id: string
                    type: RoleType
                    displayName: string
                  }
                  node: {
                    __typename: "Artist"
                    id: string
                    name: string
                    sortName: string | undefined
                  }
                }>
              }
            | undefined
          groups:
            | {
                __typename: "GroupConnection"
                edges: Array<{
                  __typename: "GroupEdge"
                  node: {
                    __typename: "Group"
                    id: string
                    name: string
                    typeDisplayName: string
                  }
                }>
              }
            | undefined
          work: {
            __typename: "Work"
            id: string
            title: string
            movements: Array<{
              __typename: "Movement"
              id: string
              title: string
            }>
            composers: Array<{ __typename: "Artist"; id: string; name: string }>
            genre:
              | { __typename: "Genre"; id: string; title: string }
              | undefined
          }
          streamVariants: Array<{
            __typename: "StreamVariant"
            manifestType: StreamManifestType
            url: string
            publicationLevel: PublicationLevel
          }>
          vodConcert: { __typename: "VodConcert"; id: string }
          cuePoints: Array<{
            __typename: "CuePoint"
            mark: number
            title: string
          }>
        }>
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        trailerStreamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
      }
    | { __typename: "Work" }
    | undefined
}

export type ReminderModalQueryVariables = Exact<{
  liveConcertId: Scalars["ID"]
}>

export type ReminderModalQuery = {
  __typename: "RootQueryType"
  liveConcert:
    | {
        __typename: "LiveConcert"
        endTime: string
        id: string
        seriesTitle: string | undefined
        shortDescription: string | undefined
        startTime: string
        subtitle: string | undefined
        title: string
        typeDisplayName: string
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        reruns: Array<{
          __typename: "LiveConcertRerun"
          endTime: string
          startTime: string
        }>
      }
    | undefined
}

export type SearchByFacetTypeQueryVariables = Exact<{
  input: FacetType
}>

export type SearchByFacetTypeQuery = {
  __typename: "RootQueryType"
  searchByFacetType:
    | {
        __typename: "SearchByFacetTypeResult"
        sections: Array<{
          __typename: "SearchByFacetTypeSection"
          glyph: string
          items: Array<{
            __typename: "SearchGlyphItem"
            count: number
            id: string
            label: string
          }>
        }>
      }
    | undefined
}

export type SearchByFacetValueQueryVariables = Exact<{
  type: FacetType
  value: Scalars["String"]
  sliderPageSize: Scalars["Int"]
}>

export type SearchByFacetValueQuery = {
  __typename: "RootQueryType"
  searchByFacetValue:
    | {
        __typename: "SearchByFacetValueResult"
        id: string
        title: string
        subtitle: string
        imageUrl: string
        artists: {
          __typename: "SearchArtistsResult"
          totalResults: number
          items: Array<{
            __typename: "SearchArtist"
            id: string
            name: string
            images: Array<{
              __typename: "SearchImage"
              type: string
              url: string
            }>
          }>
        }
        documentaries: {
          __typename: "SearchVideosResult"
          totalResults: number
          items: Array<{
            __typename: "SearchVideo"
            id: string
            title: string
            subtitle: string
            duration: number
            geoAccessMode: string
            geoAccessCountries: Array<string | undefined>
            typeDisplayName: string
            videoType: string
            publicationLevel: string
            images: Array<
              | { __typename: "SearchImage"; type: string; url: string }
              | undefined
            >
          }>
        }
        groups: {
          __typename: "SearchGroupsResult"
          totalResults: number
          items: Array<{
            __typename: "SearchGroup"
            id: string
            name: string
            subtype: string
            images: Array<{
              __typename: "SearchImage"
              type: string
              url: string
            }>
          }>
        }
        interviews: {
          __typename: "SearchVideosResult"
          totalResults: number
          items: Array<{
            __typename: "SearchVideo"
            id: string
            title: string
            subtitle: string
            duration: number
            geoAccessMode: string
            geoAccessCountries: Array<string | undefined>
            typeDisplayName: string
            videoType: string
            publicationLevel: string
            images: Array<
              | { __typename: "SearchImage"; type: string; url: string }
              | undefined
            >
          }>
        }
        liveConcerts: {
          __typename: "SearchLiveConcertsResult"
          totalResults: number
          items: Array<{
            __typename: "SearchLiveConcert"
            id: string
            title: string
            subtitle: string
            startDate: string
            typeDisplayName: string
            images: Array<
              | { __typename: "SearchImage"; type: string; url: string }
              | undefined
            >
          }>
        }
        partners: {
          __typename: "SearchPartnersResult"
          totalResults: number
          items: Array<{
            __typename: "SearchPartner"
            id: string
            name: string
            description: string
            images: Array<{
              __typename: "SearchImage"
              type: string
              url: string
            }>
          }>
        }
        shorts: {
          __typename: "SearchVideosResult"
          totalResults: number
          items: Array<{
            __typename: "SearchVideo"
            id: string
            title: string
            subtitle: string
            duration: number
            geoAccessMode: string
            geoAccessCountries: Array<string | undefined>
            typeDisplayName: string
            videoType: string
            publicationLevel: string
            images: Array<
              | { __typename: "SearchImage"; type: string; url: string }
              | undefined
            >
          }>
        }
        vodConcerts: {
          __typename: "SearchVodConcertsResult"
          totalResults: number
          items: Array<{
            __typename: "SearchVodConcert"
            id: string
            title: string
            subtitle: string
            duration: number
            typeDisplayName: string
            geoAccessCountries: Array<string | undefined>
            geoAccessMode: string
            publicationLevel: string
            images: Array<
              | { __typename: "SearchImage"; type: string; url: string }
              | undefined
            >
          }>
        }
        albums: {
          __typename: "SearchAlbumsResult"
          totalResults: number
          items: Array<{
            __typename: "SearchAlbum"
            id: string
            title: string
            artistsAndGroups: string
            images: Array<
              | { __typename: "SearchImage"; type: string; url: string }
              | undefined
            >
          }>
        }
        editorialPlaylists: {
          __typename: "SearchEditorialPlaylistsResult"
          totalResults: number
          items: Array<{
            __typename: "SearchEditorialPlaylist"
            id: string
            title: string
            description: string
            images: Array<{
              __typename: "SearchImage"
              type: string
              url: string
            }>
          }>
        }
      }
    | undefined
}

export type SearchByTextQueryVariables = Exact<{
  input: Scalars["String"]
  sliderPageSize: Scalars["Int"]
}>

export type SearchByTextQuery = {
  __typename: "RootQueryType"
  searchByText:
    | {
        __typename: "SearchByTextResult"
        artists: {
          __typename: "SearchArtistsResult"
          totalResults: number
          items: Array<{
            __typename: "SearchArtist"
            id: string
            name: string
            roles: Array<string | undefined>
            images: Array<{
              __typename: "SearchImage"
              type: string
              url: string
            }>
          }>
        }
        documentaries: {
          __typename: "SearchVideosResult"
          totalResults: number
          items: Array<{
            __typename: "SearchVideo"
            id: string
            title: string
            subtitle: string
            duration: number
            geoAccessMode: string
            geoAccessCountries: Array<string | undefined>
            typeDisplayName: string
            videoType: string
            publicationLevel: string
            images: Array<
              | { __typename: "SearchImage"; type: string; url: string }
              | undefined
            >
          }>
        }
        groups: {
          __typename: "SearchGroupsResult"
          totalResults: number
          items: Array<{
            __typename: "SearchGroup"
            id: string
            name: string
            subtype: string
            images: Array<{
              __typename: "SearchImage"
              type: string
              url: string
            }>
          }>
        }
        interviews: {
          __typename: "SearchVideosResult"
          totalResults: number
          items: Array<{
            __typename: "SearchVideo"
            id: string
            title: string
            subtitle: string
            duration: number
            geoAccessMode: string
            geoAccessCountries: Array<string | undefined>
            typeDisplayName: string
            videoType: string
            publicationLevel: string
            images: Array<
              | { __typename: "SearchImage"; type: string; url: string }
              | undefined
            >
          }>
        }
        liveConcerts: {
          __typename: "SearchLiveConcertsResult"
          totalResults: number
          items: Array<{
            __typename: "SearchLiveConcert"
            id: string
            title: string
            subtitle: string
            startDate: string
            typeDisplayName: string
            images: Array<
              | { __typename: "SearchImage"; type: string; url: string }
              | undefined
            >
          }>
        }
        partners: {
          __typename: "SearchPartnersResult"
          totalResults: number
          items: Array<{
            __typename: "SearchPartner"
            id: string
            name: string
            description: string
            images: Array<{
              __typename: "SearchImage"
              type: string
              url: string
            }>
          }>
        }
        shorts: {
          __typename: "SearchVideosResult"
          totalResults: number
          items: Array<{
            __typename: "SearchVideo"
            id: string
            title: string
            subtitle: string
            duration: number
            geoAccessMode: string
            geoAccessCountries: Array<string | undefined>
            typeDisplayName: string
            videoType: string
            publicationLevel: string
            images: Array<
              | { __typename: "SearchImage"; type: string; url: string }
              | undefined
            >
          }>
        }
        vodConcerts: {
          __typename: "SearchVodConcertsResult"
          totalResults: number
          items: Array<{
            __typename: "SearchVodConcert"
            id: string
            title: string
            subtitle: string
            duration: number
            typeDisplayName: string
            geoAccessCountries: Array<string | undefined>
            geoAccessMode: string
            publicationLevel: string
            images: Array<
              | { __typename: "SearchImage"; type: string; url: string }
              | undefined
            >
          }>
        }
        albums: {
          __typename: "SearchAlbumsResult"
          totalResults: number
          items: Array<{
            __typename: "SearchAlbum"
            id: string
            title: string
            artistsAndGroups: string
            images: Array<
              | { __typename: "SearchImage"; type: string; url: string }
              | undefined
            >
          }>
        }
        editorialPlaylists: {
          __typename: "SearchEditorialPlaylistsResult"
          totalResults: number
          items: Array<{
            __typename: "SearchEditorialPlaylist"
            id: string
            title: string
            description: string
            typeDisplayName: string
            images: Array<{
              __typename: "SearchImage"
              type: string
              url: string
            }>
          }>
        }
      }
    | undefined
}

export type SearchDetailPageQueryVariables = Exact<{
  nodeId: Scalars["ID"]
}>

export type SearchDetailPageQuery = {
  __typename: "RootQueryType"
  node:
    | { __typename: "Album" }
    | { __typename: "Article" }
    | {
        __typename: "Artist"
        id: string
        name: string
        roles: Array<{
          __typename: "Role"
          id: string
          type: RoleType
          displayName: string
        }>
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | { __typename: "BlogArticleLink" }
    | { __typename: "CuratedContentLink" }
    | { __typename: "EditorialPlaylist" }
    | { __typename: "Epoch" }
    | { __typename: "Favorite" }
    | { __typename: "Genre" }
    | {
        __typename: "Group"
        id: string
        name: string
        typeDisplayName: string
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | { __typename: "Label" }
    | { __typename: "LiveConcert" }
    | { __typename: "LivePerformanceWork" }
    | { __typename: "Movement" }
    | {
        __typename: "Partner"
        id: string
        name: string
        typeDisplayName: string
        subtypeDisplayName: string | undefined
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
      }
    | { __typename: "PerformanceWork" }
    | { __typename: "Picture" }
    | { __typename: "Playback" }
    | { __typename: "PlaybackProgress" }
    | { __typename: "PlaybackProgressV2" }
    | { __typename: "Role" }
    | { __typename: "Slider" }
    | { __typename: "Track" }
    | { __typename: "Video" }
    | { __typename: "VodConcert" }
    | { __typename: "Work" }
    | undefined
}

export type SessionQueryVariables = Exact<{
  isAuthenticated: Scalars["Boolean"]
}>

export type SessionQuery = {
  __typename: "RootQueryType"
  currentUser?:
    | {
        __typename: "User"
        email: string
        emailVerified: boolean
        insertedAt: string
        ticket:
          | {
              __typename: "Ticket"
              interval: SubscriptionPlanInterval
              status: TicketStatus
              validUntil: string | undefined
              paymentProvider: PaymentProvider
            }
          | undefined
        postalAddress:
          | { __typename: "PostalAddress"; country: string | undefined }
          | undefined
        favorites:
          | {
              __typename: "FavoriteConnection"
              edges: Array<{
                __typename: "FavoriteEdge"
                node: {
                  __typename: "Favorite"
                  content:
                    | { __typename: "Album"; id: string }
                    | { __typename: "EditorialPlaylist"; id: string }
                    | { __typename: "PerformanceWork"; id: string }
                    | { __typename: "Video"; id: string }
                }
              }>
            }
          | undefined
        recentlyPlayed:
          | {
              __typename: "PlaybackProgressConnection"
              edges: Array<{
                __typename: "PlaybackProgressEdge"
                node: {
                  __typename: "PlaybackProgress"
                  mark: number
                  content:
                    | {
                        __typename: "PerformanceWork"
                        id: string
                        duration: number
                      }
                    | { __typename: "Track"; id: string; duration: number }
                    | { __typename: "Video"; id: string; duration: number }
                }
              }>
            }
          | undefined
      }
    | undefined
  geoinfo:
    | {
        __typename: "GeoinfoPayload"
        countryCode: string
        currencyCode: string
      }
    | undefined
}

export type ShareModalQueryVariables = Exact<{
  nodeId: Scalars["ID"]
}>

export type ShareModalQuery = {
  __typename: "RootQueryType"
  node:
    | {
        __typename: "Album"
        id: string
        title: string
        artistAndGroupDisplayInfo: string | undefined
      }
    | { __typename: "Article" }
    | { __typename: "Artist"; id: string; name: string }
    | { __typename: "BlogArticleLink" }
    | { __typename: "CuratedContentLink" }
    | { __typename: "EditorialPlaylist" }
    | { __typename: "Epoch"; id: string; title: string }
    | { __typename: "Favorite" }
    | { __typename: "Genre"; id: string; title: string }
    | { __typename: "Group"; id: string; name: string }
    | { __typename: "Label" }
    | {
        __typename: "LiveConcert"
        id: string
        title: string
        shortDescription: string | undefined
      }
    | { __typename: "LivePerformanceWork" }
    | { __typename: "Movement" }
    | { __typename: "Partner"; id: string; name: string }
    | {
        __typename: "PerformanceWork"
        id: string
        work: { __typename: "Work"; title: string }
      }
    | { __typename: "Picture" }
    | { __typename: "Playback" }
    | { __typename: "PlaybackProgress" }
    | { __typename: "PlaybackProgressV2" }
    | { __typename: "Role" }
    | { __typename: "Slider" }
    | { __typename: "Track"; id: string; title: string }
    | {
        __typename: "Video"
        id: string
        title: string
        description: string | undefined
      }
    | {
        __typename: "VodConcert"
        id: string
        title: string
        shortDescription: string | undefined
      }
    | { __typename: "Work" }
    | undefined
}

export type SliderPageQueryVariables = Exact<{
  sliderId: Scalars["ID"]
  sliderPageSize: Scalars["Int"]
  cursor: InputMaybe<Scalars["String"]>
}>

export type SliderPageQuery = {
  __typename: "RootQueryType"
  slider:
    | {
        __typename: "Slider"
        id: string
        headline: string
        layout: SliderLayout | undefined
        sliderItems:
          | {
              __typename: "SliderItemConnection"
              totalResults: number
              pageInfo: {
                __typename: "PageInfo"
                hasNextPage: boolean
                endCursor: string | undefined
              }
              edges: Array<{
                __typename: "SliderItemEdge"
                node:
                  | {
                      __typename: "Album"
                      artistAndGroupDisplayInfo: string | undefined
                      id: string
                      title: string
                      atmosUpc: string | undefined
                      pictures: Array<{
                        __typename: "Picture"
                        id: string
                        url: string
                        type: PictureType
                      }>
                    }
                  | {
                      __typename: "Artist"
                      id: string
                      name: string
                      roles: Array<{
                        __typename: "Role"
                        id: string
                        type: RoleType
                        displayName: string
                      }>
                      pictures: Array<{
                        __typename: "Picture"
                        id: string
                        url: string
                        type: PictureType
                      }>
                    }
                  | { __typename: "BlogArticleLink" }
                  | { __typename: "CuratedContentLink" }
                  | {
                      __typename: "EditorialPlaylist"
                      id: string
                      title: string
                      description: string
                      metaTitle: string | undefined
                      typeDisplayName: string
                      metaDescription: string | undefined
                      pictures: Array<{
                        __typename: "Picture"
                        id: string
                        url: string
                        type: PictureType
                      }>
                    }
                  | {
                      __typename: "Epoch"
                      id: string
                      endYear: number | undefined
                      startYear: number | undefined
                      title: string
                      subtitle: string | undefined
                      pictures: Array<{
                        __typename: "Picture"
                        id: string
                        url: string
                        type: PictureType
                      }>
                    }
                  | { __typename: "Favorite" }
                  | {
                      __typename: "Genre"
                      id: string
                      title: string
                      pictures: Array<{
                        __typename: "Picture"
                        id: string
                        url: string
                        type: PictureType
                      }>
                    }
                  | {
                      __typename: "Group"
                      id: string
                      name: string
                      typeDisplayName: string
                      pictures: Array<{
                        __typename: "Picture"
                        id: string
                        url: string
                        type: PictureType
                      }>
                    }
                  | {
                      __typename: "LiveConcert"
                      endTime: string
                      id: string
                      publicationLevel: PublicationLevel
                      startTime: string
                      streamStartTime: string | undefined
                      subtitle: string | undefined
                      title: string
                      typeDisplayName: string
                      geoAccessCountries: Array<string>
                      geoAccessMode: GeoAccessMode
                      finalEndTime: string
                      plannedForVod: boolean
                      liveConcertType: LiveConcertType
                      pictures: Array<{
                        __typename: "Picture"
                        id: string
                        url: string
                        type: PictureType
                      }>
                      reruns: Array<{
                        __typename: "LiveConcertRerun"
                        streamStartTime: string | undefined
                        endTime: string
                        startTime: string
                        stream: {
                          __typename: "RerunStream"
                          publicationLevel: PublicationLevel
                          streamType: StreamType
                          url: string
                        }
                      }>
                      streamVariants: Array<{
                        __typename: "StreamVariant"
                        manifestType: StreamManifestType
                        url: string
                        publicationLevel: PublicationLevel
                      }>
                      trailerStreamVariants: Array<{
                        __typename: "StreamVariant"
                        manifestType: StreamManifestType
                        url: string
                        publicationLevel: PublicationLevel
                      }>
                    }
                  | {
                      __typename: "Partner"
                      id: string
                      name: string
                      typeDisplayName: string
                      subtypeDisplayName: string | undefined
                      pictures: Array<{
                        __typename: "Picture"
                        id: string
                        url: string
                        type: PictureType
                      }>
                    }
                  | { __typename: "Playback" }
                  | { __typename: "PlaybackProgress" }
                  | {
                      __typename: "Video"
                      id: string
                      archiveReleaseDate: string | undefined
                      title: string
                      subtitle: string | undefined
                      duration: number
                      type: VideoType
                      typeDisplayName: string
                      geoAccessCountries: Array<string>
                      geoAccessMode: GeoAccessMode
                      publicationLevel: PublicationLevel
                      takedownDate: string | undefined
                      isAtmos: boolean
                      maxResolution: MaxResolution
                      pictures: Array<{
                        __typename: "Picture"
                        id: string
                        url: string
                        type: PictureType
                      }>
                      streamVariants: Array<{
                        __typename: "StreamVariant"
                        manifestType: StreamManifestType
                        url: string
                        publicationLevel: PublicationLevel
                      }>
                      trailerStreamVariants: Array<{
                        __typename: "StreamVariant"
                        manifestType: StreamManifestType
                        url: string
                        publicationLevel: PublicationLevel
                      }>
                    }
                  | {
                      __typename: "VodConcert"
                      id: string
                      archiveReleaseDate: string | undefined
                      subtitle: string | undefined
                      title: string
                      typeDisplayName: string
                      totalDuration: number
                      geoAccessCountries: Array<string>
                      geoAccessMode: GeoAccessMode
                      publicationLevel: PublicationLevel
                      takedownDate: string | undefined
                      maxResolution: MaxResolution
                      vodConcertType: VodConcertType
                      pictures: Array<{
                        __typename: "Picture"
                        id: string
                        url: string
                        type: PictureType
                      }>
                      trailerStreamVariants: Array<{
                        __typename: "StreamVariant"
                        manifestType: StreamManifestType
                        url: string
                        publicationLevel: PublicationLevel
                      }>
                    }
                  | { __typename: "Work" }
              }>
            }
          | undefined
      }
    | undefined
}

export type SubscriptionPlansQueryVariables = Exact<{
  couponCode: InputMaybe<Scalars["String"]>
}>

export type SubscriptionPlansQuery = {
  __typename: "RootQueryType"
  subscriptionPlansStripe: {
    __typename: "SubscriptionPlansStripe"
    coupon:
      | {
          __typename: "Coupon"
          productIdsLimitedTo: Array<string>
          percentOff: number
        }
      | undefined
    plans: Array<{
      __typename: "SubscriptionPlanStripe"
      productId: string
      interval: SubscriptionPlanInterval
      trialPeriodDays: number
      prices: Array<{
        __typename: "Price"
        id: string
        currency: string
        amount: number
        amountUndiscounted: number
      }>
    }>
  }
}

export type SubscriptionSettingsQueryVariables = Exact<{ [key: string]: never }>

export type SubscriptionSettingsQuery = {
  __typename: "RootQueryType"
  currentUser:
    | {
        __typename: "User"
        hasTrialedBefore: boolean
        stripeInvoices: Array<{
          __typename: "StripeInvoice"
          billedAt: string
          currency: string
          description: string
          number: string
          pdfUrl: string
          total: number
        }>
        ticket:
          | {
              __typename: "Ticket"
              interval: SubscriptionPlanInterval
              paymentProvider: PaymentProvider
              status: TicketStatus
              validUntil: string | undefined
              stripeBillingInfo:
                | {
                    __typename: "StripeBillingInfo"
                    amount: number
                    billedFirstAt: string | undefined
                    billedNextAt: string | undefined
                    currency: string
                    card:
                      | {
                          __typename: "StripeCard"
                          brand: string
                          expMonth: number
                          expYear: number
                          funding: string
                          country: string
                          last4: string
                        }
                      | undefined
                  }
                | undefined
            }
          | undefined
      }
    | undefined
}

export type TicketsPageQueryVariables = Exact<{ [key: string]: never }>

export type TicketsPageQuery = {
  __typename: "RootQueryType"
  subscriptionPlansStripe: {
    __typename: "SubscriptionPlansStripe"
    coupon:
      | {
          __typename: "Coupon"
          productIdsLimitedTo: Array<string>
          percentOff: number
        }
      | undefined
    plans: Array<{
      __typename: "SubscriptionPlanStripe"
      productId: string
      interval: SubscriptionPlanInterval
      trialPeriodDays: number
      prices: Array<{
        __typename: "Price"
        id: string
        currency: string
        amount: number
        amountUndiscounted: number
      }>
    }>
  }
}

export type VideoDetailPageQueryVariables = Exact<{
  videoId: Scalars["ID"]
  sliderPageSize?: InputMaybe<Scalars["Int"]>
}>

export type VideoDetailPageQuery = {
  __typename: "RootQueryType"
  node:
    | { __typename: "Album" }
    | { __typename: "Article" }
    | { __typename: "Artist" }
    | { __typename: "BlogArticleLink" }
    | { __typename: "CuratedContentLink" }
    | { __typename: "EditorialPlaylist" }
    | { __typename: "Epoch" }
    | { __typename: "Favorite" }
    | { __typename: "Genre" }
    | { __typename: "Group" }
    | { __typename: "Label" }
    | {
        __typename: "LiveConcert"
        isAtmos: boolean
        maxResolution: MaxResolution
        shortDescription: string | undefined
        endTime: string
        id: string
        publicationLevel: PublicationLevel
        startTime: string
        streamStartTime: string | undefined
        subtitle: string | undefined
        title: string
        typeDisplayName: string
        geoAccessCountries: Array<string>
        geoAccessMode: GeoAccessMode
        finalEndTime: string
        plannedForVod: boolean
        liveConcertType: LiveConcertType
        artists:
          | {
              __typename: "ArtistWithRoleConnection"
              edges: Array<{
                __typename: "ArtistWithRoleEdge"
                role: {
                  __typename: "Role"
                  id: string
                  type: RoleType
                  displayName: string
                }
                node: {
                  __typename: "Artist"
                  id: string
                  name: string
                  sortName: string | undefined
                }
              }>
            }
          | undefined
        groups: Array<{
          __typename: "Group"
          id: string
          name: string
          typeDisplayName: string
        }>
        performanceWorks: Array<{
          __typename: "LivePerformanceWork"
          id: string
          duration: number
          artists:
            | {
                __typename: "ArtistWithRoleConnection"
                edges: Array<{
                  __typename: "ArtistWithRoleEdge"
                  role: {
                    __typename: "Role"
                    id: string
                    type: RoleType
                    displayName: string
                  }
                  node: {
                    __typename: "Artist"
                    id: string
                    name: string
                    sortName: string | undefined
                  }
                }>
              }
            | undefined
          work: {
            __typename: "Work"
            id: string
            title: string
            movements: Array<{
              __typename: "Movement"
              id: string
              title: string
            }>
            composers: Array<{ __typename: "Artist"; id: string; name: string }>
            genre:
              | { __typename: "Genre"; id: string; title: string }
              | undefined
          }
        }>
        curatedContent: Array<
          | {
              __typename: "Banner"
              description: string
              link: string
              title: string
              pictures: Array<{
                __typename: "Picture"
                id: string
                url: string
                type: PictureType
              }>
            }
          | {
              __typename: "ListSlider"
              id: string
              headline: string
              totalResults: number
              layout: SliderLayout | undefined
              items: Array<
                | {
                    __typename: "Album"
                    artistAndGroupDisplayInfo: string | undefined
                    id: string
                    title: string
                    atmosUpc: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Artist"
                    id: string
                    name: string
                    roles: Array<{
                      __typename: "Role"
                      id: string
                      type: RoleType
                      displayName: string
                    }>
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "BlogArticleLink" }
                | {
                    __typename: "CuratedContentLink"
                    id: string
                    title: string
                    slugV2: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "EditorialPlaylist"
                    id: string
                    title: string
                    description: string
                    metaTitle: string | undefined
                    typeDisplayName: string
                    metaDescription: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Epoch"
                    id: string
                    endYear: number | undefined
                    startYear: number | undefined
                    title: string
                    subtitle: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Favorite" }
                | {
                    __typename: "Genre"
                    id: string
                    title: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Group"
                    id: string
                    name: string
                    typeDisplayName: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "LiveConcert"
                    endTime: string
                    id: string
                    publicationLevel: PublicationLevel
                    startTime: string
                    streamStartTime: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    finalEndTime: string
                    plannedForVod: boolean
                    liveConcertType: LiveConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    reruns: Array<{
                      __typename: "LiveConcertRerun"
                      streamStartTime: string | undefined
                      endTime: string
                      startTime: string
                      stream: {
                        __typename: "RerunStream"
                        publicationLevel: PublicationLevel
                        streamType: StreamType
                        url: string
                      }
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Partner"
                    id: string
                    name: string
                    typeDisplayName: string
                    subtypeDisplayName: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Playback" }
                | { __typename: "PlaybackProgress" }
                | {
                    __typename: "Video"
                    id: string
                    archiveReleaseDate: string | undefined
                    title: string
                    subtitle: string | undefined
                    duration: number
                    type: VideoType
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    isAtmos: boolean
                    maxResolution: MaxResolution
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "VodConcert"
                    id: string
                    archiveReleaseDate: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    totalDuration: number
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    maxResolution: MaxResolution
                    vodConcertType: VodConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Work"
                    id: string
                    title: string
                    movements: Array<{
                      __typename: "Movement"
                      id: string
                      title: string
                    }>
                    composers: Array<{
                      __typename: "Artist"
                      id: string
                      name: string
                    }>
                    genre:
                      | { __typename: "Genre"; id: string; title: string }
                      | undefined
                  }
              >
            }
        >
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        reruns: Array<{
          __typename: "LiveConcertRerun"
          streamStartTime: string | undefined
          endTime: string
          startTime: string
          stream: {
            __typename: "RerunStream"
            publicationLevel: PublicationLevel
            streamType: StreamType
            url: string
          }
        }>
        streamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
        trailerStreamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
      }
    | { __typename: "LivePerformanceWork" }
    | { __typename: "Movement" }
    | { __typename: "Partner" }
    | { __typename: "PerformanceWork" }
    | { __typename: "Picture" }
    | { __typename: "Playback" }
    | { __typename: "PlaybackProgress" }
    | { __typename: "PlaybackProgressV2" }
    | { __typename: "Role" }
    | { __typename: "Slider" }
    | { __typename: "Track" }
    | {
        __typename: "Video"
        isAtmos: boolean
        maxResolution: MaxResolution
        isLossless: boolean
        description: string | undefined
        productionDate: string | undefined
        takedownDate: string | undefined
        id: string
        archiveReleaseDate: string | undefined
        title: string
        subtitle: string | undefined
        duration: number
        type: VideoType
        typeDisplayName: string
        geoAccessCountries: Array<string>
        geoAccessMode: GeoAccessMode
        publicationLevel: PublicationLevel
        artists:
          | {
              __typename: "ArtistWithRoleConnection"
              edges: Array<{
                __typename: "ArtistWithRoleEdge"
                role: {
                  __typename: "Role"
                  id: string
                  type: RoleType
                  displayName: string
                }
                node: {
                  __typename: "Artist"
                  id: string
                  name: string
                  sortName: string | undefined
                }
              }>
            }
          | undefined
        epochsByRelevance: Array<{
          __typename: "Epoch"
          id: string
          title: string
        }>
        genresByRelevance: Array<{
          __typename: "Genre"
          id: string
          title: string
        }>
        curatedContent: Array<
          | {
              __typename: "Banner"
              description: string
              link: string
              title: string
              pictures: Array<{
                __typename: "Picture"
                id: string
                url: string
                type: PictureType
              }>
            }
          | {
              __typename: "ListSlider"
              id: string
              headline: string
              totalResults: number
              layout: SliderLayout | undefined
              items: Array<
                | {
                    __typename: "Album"
                    artistAndGroupDisplayInfo: string | undefined
                    id: string
                    title: string
                    atmosUpc: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Artist"
                    id: string
                    name: string
                    roles: Array<{
                      __typename: "Role"
                      id: string
                      type: RoleType
                      displayName: string
                    }>
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "BlogArticleLink" }
                | {
                    __typename: "CuratedContentLink"
                    id: string
                    title: string
                    slugV2: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "EditorialPlaylist"
                    id: string
                    title: string
                    description: string
                    metaTitle: string | undefined
                    typeDisplayName: string
                    metaDescription: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Epoch"
                    id: string
                    endYear: number | undefined
                    startYear: number | undefined
                    title: string
                    subtitle: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Favorite" }
                | {
                    __typename: "Genre"
                    id: string
                    title: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Group"
                    id: string
                    name: string
                    typeDisplayName: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "LiveConcert"
                    endTime: string
                    id: string
                    publicationLevel: PublicationLevel
                    startTime: string
                    streamStartTime: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    finalEndTime: string
                    plannedForVod: boolean
                    liveConcertType: LiveConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    reruns: Array<{
                      __typename: "LiveConcertRerun"
                      streamStartTime: string | undefined
                      endTime: string
                      startTime: string
                      stream: {
                        __typename: "RerunStream"
                        publicationLevel: PublicationLevel
                        streamType: StreamType
                        url: string
                      }
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Partner"
                    id: string
                    name: string
                    typeDisplayName: string
                    subtypeDisplayName: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Playback" }
                | { __typename: "PlaybackProgress" }
                | {
                    __typename: "Video"
                    id: string
                    archiveReleaseDate: string | undefined
                    title: string
                    subtitle: string | undefined
                    duration: number
                    type: VideoType
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    isAtmos: boolean
                    maxResolution: MaxResolution
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "VodConcert"
                    id: string
                    archiveReleaseDate: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    totalDuration: number
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    maxResolution: MaxResolution
                    vodConcertType: VodConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Work"
                    id: string
                    title: string
                    movements: Array<{
                      __typename: "Movement"
                      id: string
                      title: string
                    }>
                    composers: Array<{
                      __typename: "Artist"
                      id: string
                      name: string
                    }>
                    genre:
                      | { __typename: "Genre"; id: string; title: string }
                      | undefined
                  }
              >
            }
        >
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        streamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
        trailerStreamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
      }
    | {
        __typename: "VodConcert"
        isAtmos: boolean
        maxResolution: MaxResolution
        shortDescription: string | undefined
        productionDate: string | undefined
        takedownDate: string | undefined
        id: string
        archiveReleaseDate: string | undefined
        subtitle: string | undefined
        title: string
        typeDisplayName: string
        totalDuration: number
        geoAccessCountries: Array<string>
        geoAccessMode: GeoAccessMode
        publicationLevel: PublicationLevel
        vodConcertType: VodConcertType
        artists:
          | {
              __typename: "ArtistWithRoleConnection"
              edges: Array<{
                __typename: "ArtistWithRoleEdge"
                role: {
                  __typename: "Role"
                  id: string
                  type: RoleType
                  displayName: string
                }
                node: {
                  __typename: "Artist"
                  id: string
                  name: string
                  sortName: string | undefined
                }
              }>
            }
          | undefined
        groups: Array<{
          __typename: "Group"
          id: string
          name: string
          typeDisplayName: string
        }>
        performanceWorks: Array<{
          __typename: "PerformanceWork"
          id: string
          duration: number
          artists:
            | {
                __typename: "ArtistWithRoleConnection"
                edges: Array<{
                  __typename: "ArtistWithRoleEdge"
                  role: {
                    __typename: "Role"
                    id: string
                    type: RoleType
                    displayName: string
                  }
                  node: {
                    __typename: "Artist"
                    id: string
                    name: string
                    sortName: string | undefined
                  }
                }>
              }
            | undefined
          groups:
            | {
                __typename: "GroupConnection"
                edges: Array<{
                  __typename: "GroupEdge"
                  node: {
                    __typename: "Group"
                    id: string
                    name: string
                    typeDisplayName: string
                  }
                }>
              }
            | undefined
          work: {
            __typename: "Work"
            id: string
            title: string
            movements: Array<{
              __typename: "Movement"
              id: string
              title: string
            }>
            composers: Array<{ __typename: "Artist"; id: string; name: string }>
            genre:
              | { __typename: "Genre"; id: string; title: string }
              | undefined
          }
          streamVariants: Array<{
            __typename: "StreamVariant"
            manifestType: StreamManifestType
            url: string
            publicationLevel: PublicationLevel
          }>
          vodConcert: { __typename: "VodConcert"; id: string }
          cuePoints: Array<{
            __typename: "CuePoint"
            mark: number
            title: string
          }>
        }>
        epochsByRelevance: Array<{
          __typename: "Epoch"
          id: string
          title: string
        }>
        genresByRelevance: Array<{
          __typename: "Genre"
          id: string
          title: string
        }>
        curatedContent: Array<
          | {
              __typename: "Banner"
              description: string
              link: string
              title: string
              pictures: Array<{
                __typename: "Picture"
                id: string
                url: string
                type: PictureType
              }>
            }
          | {
              __typename: "ListSlider"
              id: string
              headline: string
              totalResults: number
              layout: SliderLayout | undefined
              items: Array<
                | {
                    __typename: "Album"
                    artistAndGroupDisplayInfo: string | undefined
                    id: string
                    title: string
                    atmosUpc: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Artist"
                    id: string
                    name: string
                    roles: Array<{
                      __typename: "Role"
                      id: string
                      type: RoleType
                      displayName: string
                    }>
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "BlogArticleLink" }
                | {
                    __typename: "CuratedContentLink"
                    id: string
                    title: string
                    slugV2: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "EditorialPlaylist"
                    id: string
                    title: string
                    description: string
                    metaTitle: string | undefined
                    typeDisplayName: string
                    metaDescription: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Epoch"
                    id: string
                    endYear: number | undefined
                    startYear: number | undefined
                    title: string
                    subtitle: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Favorite" }
                | {
                    __typename: "Genre"
                    id: string
                    title: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Group"
                    id: string
                    name: string
                    typeDisplayName: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "LiveConcert"
                    endTime: string
                    id: string
                    publicationLevel: PublicationLevel
                    startTime: string
                    streamStartTime: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    finalEndTime: string
                    plannedForVod: boolean
                    liveConcertType: LiveConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    reruns: Array<{
                      __typename: "LiveConcertRerun"
                      streamStartTime: string | undefined
                      endTime: string
                      startTime: string
                      stream: {
                        __typename: "RerunStream"
                        publicationLevel: PublicationLevel
                        streamType: StreamType
                        url: string
                      }
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Partner"
                    id: string
                    name: string
                    typeDisplayName: string
                    subtypeDisplayName: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Playback" }
                | { __typename: "PlaybackProgress" }
                | {
                    __typename: "Video"
                    id: string
                    archiveReleaseDate: string | undefined
                    title: string
                    subtitle: string | undefined
                    duration: number
                    type: VideoType
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    isAtmos: boolean
                    maxResolution: MaxResolution
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "VodConcert"
                    id: string
                    archiveReleaseDate: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    totalDuration: number
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    maxResolution: MaxResolution
                    vodConcertType: VodConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Work"
                    id: string
                    title: string
                    movements: Array<{
                      __typename: "Movement"
                      id: string
                      title: string
                    }>
                    composers: Array<{
                      __typename: "Artist"
                      id: string
                      name: string
                    }>
                    genre:
                      | { __typename: "Genre"; id: string; title: string }
                      | undefined
                  }
              >
            }
        >
        pictures: Array<{
          __typename: "Picture"
          id: string
          url: string
          type: PictureType
        }>
        trailerStreamVariants: Array<{
          __typename: "StreamVariant"
          manifestType: StreamManifestType
          url: string
          publicationLevel: PublicationLevel
        }>
      }
    | { __typename: "Work" }
    | undefined
}

export type WorkPageQueryVariables = Exact<{
  workId: Scalars["ID"]
  sliderPageSize?: InputMaybe<Scalars["Int"]>
}>

export type WorkPageQuery = {
  __typename: "RootQueryType"
  work:
    | {
        __typename: "Work"
        id: string
        title: string
        curatedContent: Array<
          | {
              __typename: "Banner"
              description: string
              link: string
              title: string
              pictures: Array<{
                __typename: "Picture"
                id: string
                url: string
                type: PictureType
              }>
            }
          | {
              __typename: "ListSlider"
              id: string
              headline: string
              totalResults: number
              layout: SliderLayout | undefined
              items: Array<
                | {
                    __typename: "Album"
                    artistAndGroupDisplayInfo: string | undefined
                    id: string
                    title: string
                    atmosUpc: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Artist"
                    id: string
                    name: string
                    roles: Array<{
                      __typename: "Role"
                      id: string
                      type: RoleType
                      displayName: string
                    }>
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "BlogArticleLink" }
                | {
                    __typename: "CuratedContentLink"
                    id: string
                    title: string
                    slugV2: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "EditorialPlaylist"
                    id: string
                    title: string
                    description: string
                    metaTitle: string | undefined
                    typeDisplayName: string
                    metaDescription: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Epoch"
                    id: string
                    endYear: number | undefined
                    startYear: number | undefined
                    title: string
                    subtitle: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Favorite" }
                | {
                    __typename: "Genre"
                    id: string
                    title: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "Group"
                    id: string
                    name: string
                    typeDisplayName: string
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | {
                    __typename: "LiveConcert"
                    endTime: string
                    id: string
                    publicationLevel: PublicationLevel
                    startTime: string
                    streamStartTime: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    finalEndTime: string
                    plannedForVod: boolean
                    liveConcertType: LiveConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    reruns: Array<{
                      __typename: "LiveConcertRerun"
                      streamStartTime: string | undefined
                      endTime: string
                      startTime: string
                      stream: {
                        __typename: "RerunStream"
                        publicationLevel: PublicationLevel
                        streamType: StreamType
                        url: string
                      }
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Partner"
                    id: string
                    name: string
                    typeDisplayName: string
                    subtypeDisplayName: string | undefined
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                  }
                | { __typename: "Playback" }
                | { __typename: "PlaybackProgress" }
                | {
                    __typename: "Video"
                    id: string
                    archiveReleaseDate: string | undefined
                    title: string
                    subtitle: string | undefined
                    duration: number
                    type: VideoType
                    typeDisplayName: string
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    isAtmos: boolean
                    maxResolution: MaxResolution
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    streamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "VodConcert"
                    id: string
                    archiveReleaseDate: string | undefined
                    subtitle: string | undefined
                    title: string
                    typeDisplayName: string
                    totalDuration: number
                    geoAccessCountries: Array<string>
                    geoAccessMode: GeoAccessMode
                    publicationLevel: PublicationLevel
                    takedownDate: string | undefined
                    maxResolution: MaxResolution
                    vodConcertType: VodConcertType
                    pictures: Array<{
                      __typename: "Picture"
                      id: string
                      url: string
                      type: PictureType
                    }>
                    trailerStreamVariants: Array<{
                      __typename: "StreamVariant"
                      manifestType: StreamManifestType
                      url: string
                      publicationLevel: PublicationLevel
                    }>
                  }
                | {
                    __typename: "Work"
                    id: string
                    title: string
                    movements: Array<{
                      __typename: "Movement"
                      id: string
                      title: string
                    }>
                    composers: Array<{
                      __typename: "Artist"
                      id: string
                      name: string
                    }>
                    genre:
                      | { __typename: "Genre"; id: string; title: string }
                      | undefined
                  }
              >
            }
        >
        movements: Array<{ __typename: "Movement"; id: string; title: string }>
        composers: Array<{ __typename: "Artist"; id: string; name: string }>
        genre: { __typename: "Genre"; id: string; title: string } | undefined
      }
    | undefined
}

export const StreamVariantFieldsFragmentDoc = gql`
  fragment streamVariantFields on StreamVariant {
    manifestType
    url
    publicationLevel
  }
`
export const TrackFieldsFragmentDoc = gql`
  fragment trackFields on Track {
    __typename
    id
    artistDisplayInfo
    artistAndGroupDisplayInfo
    composerDisplayInfo
    duration
    title
    trackNumber
    duration
    album {
      id
    }
    streamVariants {
      ...streamVariantFields
    }
  }
  ${StreamVariantFieldsFragmentDoc}
`
export const TrackSetFieldsFragmentDoc = gql`
  fragment TrackSetFields on TrackSet {
    composerDisplayInfo
    title
    trackSetNumber
    tracks {
      ...trackFields
    }
  }
  ${TrackFieldsFragmentDoc}
`
export const ApiErrorFieldsFragmentDoc = gql`
  fragment ApiErrorFields on ApiError {
    ... on BasicError {
      message
    }
    ... on ValidationError {
      message
      validation
      field
    }
  }
`
export const PictureFieldsFragmentDoc = gql`
  fragment PictureFields on Picture {
    id
    url
    type
  }
`
export const BannerFieldsFragmentDoc = gql`
  fragment BannerFields on Banner {
    description
    link
    pictures {
      ...PictureFields
    }
    title
  }
  ${PictureFieldsFragmentDoc}
`
export const AlbumFieldsFragmentDoc = gql`
  fragment AlbumFields on Album {
    artistAndGroupDisplayInfo
    id
    pictures {
      ...PictureFields
    }
    title
    atmosUpc
  }
  ${PictureFieldsFragmentDoc}
`
export const RoleFieldsFragmentDoc = gql`
  fragment RoleFields on Role {
    __typename
    id
    type
    displayName
  }
`
export const ArtistFieldsFragmentDoc = gql`
  fragment ArtistFields on Artist {
    id
    name
    roles {
      ...RoleFields
    }
    pictures {
      ...PictureFields
    }
  }
  ${RoleFieldsFragmentDoc}
  ${PictureFieldsFragmentDoc}
`
export const EpochFieldsFragmentDoc = gql`
  fragment EpochFields on Epoch {
    id
    endYear
    pictures {
      ...PictureFields
    }
    startYear
    title
    subtitle
  }
  ${PictureFieldsFragmentDoc}
`
export const GenreFieldsFragmentDoc = gql`
  fragment GenreFields on Genre {
    id
    pictures {
      ...PictureFields
    }
    title
  }
  ${PictureFieldsFragmentDoc}
`
export const GroupFieldsFragmentDoc = gql`
  fragment GroupFields on Group {
    id
    name
    typeDisplayName
    pictures {
      ...PictureFields
    }
  }
  ${PictureFieldsFragmentDoc}
`
export const RerunStreamFieldsFragmentDoc = gql`
  fragment rerunStreamFields on RerunStream {
    publicationLevel
    streamType
    url
  }
`
export const LiveConcertRerunFieldsFragmentDoc = gql`
  fragment liveConcertRerunFields on LiveConcertRerun {
    streamStartTime
    endTime
    startTime
    stream {
      ...rerunStreamFields
    }
  }
  ${RerunStreamFieldsFragmentDoc}
`
export const LiveConcertFieldsFragmentDoc = gql`
  fragment LiveConcertFields on LiveConcert {
    endTime
    id
    pictures {
      ...PictureFields
    }
    reruns {
      ...liveConcertRerunFields
    }
    publicationLevel
    startTime
    streamStartTime
    subtitle
    title
    typeDisplayName
    streamVariants {
      ...streamVariantFields
    }
    trailerStreamVariants {
      ...streamVariantFields
    }
    geoAccessCountries
    geoAccessMode
    liveConcertType: type
    finalEndTime
    plannedForVod
  }
  ${PictureFieldsFragmentDoc}
  ${LiveConcertRerunFieldsFragmentDoc}
  ${StreamVariantFieldsFragmentDoc}
`
export const PartnerFieldsFragmentDoc = gql`
  fragment PartnerFields on Partner {
    id
    name
    typeDisplayName
    subtypeDisplayName
    pictures {
      ...PictureFields
    }
  }
  ${PictureFieldsFragmentDoc}
`
export const VideoFieldsFragmentDoc = gql`
  fragment VideoFields on Video {
    id
    archiveReleaseDate
    title
    subtitle
    pictures {
      ...PictureFields
    }
    streamVariants {
      ...streamVariantFields
    }
    trailerStreamVariants {
      ...streamVariantFields
    }
    duration
    type
    typeDisplayName
    duration
    geoAccessCountries
    geoAccessMode
    publicationLevel
    takedownDate
    isAtmos
    maxResolution
  }
  ${PictureFieldsFragmentDoc}
  ${StreamVariantFieldsFragmentDoc}
`
export const VodConcertFieldsFragmentDoc = gql`
  fragment VodConcertFields on VodConcert {
    id
    archiveReleaseDate
    pictures {
      ...PictureFields
    }
    subtitle
    title
    typeDisplayName
    totalDuration
    geoAccessCountries
    geoAccessMode
    trailerStreamVariants {
      ...streamVariantFields
    }
    publicationLevel
    takedownDate
    maxResolution
    vodConcertType: type
  }
  ${PictureFieldsFragmentDoc}
  ${StreamVariantFieldsFragmentDoc}
`
export const EditorialPlaylistFieldsFragmentDoc = gql`
  fragment EditorialPlaylistFields on EditorialPlaylist {
    id
    title
    description
    metaTitle
    typeDisplayName
    metaDescription
    pictures {
      ...PictureFields
    }
  }
  ${PictureFieldsFragmentDoc}
`
export const CuratedContentLinkFieldsFragmentDoc = gql`
  fragment CuratedContentLinkFields on CuratedContentLink {
    id
    title
    slugV2
    pictures {
      ...PictureFields
    }
  }
  ${PictureFieldsFragmentDoc}
`
export const WorkFieldsFragmentDoc = gql`
  fragment workFields on Work {
    id
    title
    movements {
      id
      title
    }
    composers {
      id
      name
    }
    genre {
      id
      title
    }
  }
`
export const ListSliderFieldsFragmentDoc = gql`
  fragment ListSliderFields on ListSlider {
    id
    headline
    totalResults
    layout
    items(
      first: $sliderPageSize
      sizeOverrides: {
        byLayout: [{ layout: WEEKLY_TOP10, pageSize: 10 }]
        byType: [
          { typename: "Work", pageSize: 999 }
          { typename: "CuratedContentLink", pageSize: 999 }
        ]
      }
    ) {
      __typename
      ...AlbumFields
      ...ArtistFields
      ...EpochFields
      ...GenreFields
      ...GroupFields
      ...LiveConcertFields
      ...PartnerFields
      ...VideoFields
      ...VodConcertFields
      ...EditorialPlaylistFields
      ...CuratedContentLinkFields
      ...workFields
    }
  }
  ${AlbumFieldsFragmentDoc}
  ${ArtistFieldsFragmentDoc}
  ${EpochFieldsFragmentDoc}
  ${GenreFieldsFragmentDoc}
  ${GroupFieldsFragmentDoc}
  ${LiveConcertFieldsFragmentDoc}
  ${PartnerFieldsFragmentDoc}
  ${VideoFieldsFragmentDoc}
  ${VodConcertFieldsFragmentDoc}
  ${EditorialPlaylistFieldsFragmentDoc}
  ${CuratedContentLinkFieldsFragmentDoc}
  ${WorkFieldsFragmentDoc}
`
export const CuratedContentFieldsFragmentDoc = gql`
  fragment CuratedContentFields on CuratedContentContainerV2 {
    __typename
    ...BannerFields
    ...ListSliderFields
  }
  ${BannerFieldsFragmentDoc}
  ${ListSliderFieldsFragmentDoc}
`
export const PlaylistItemFieldsFragmentDoc = gql`
  fragment PlaylistItemFields on Track {
    __typename
    id
    artistsAndGroups {
      ... on TrackArtist {
        name
      }
      ... on TrackGroup {
        name
      }
    }
    artistDisplayInfo
    artistAndGroupDisplayInfo
    composerDisplayInfo
    duration
    title
    trackNumber
    workDisplayInfo
    duration
    album {
      id
      title
      pictures {
        ...PictureFields
      }
    }
    streamVariants {
      ...streamVariantFields
    }
  }
  ${PictureFieldsFragmentDoc}
  ${StreamVariantFieldsFragmentDoc}
`
export const EditorialPlaylistSectionFieldsFragmentDoc = gql`
  fragment EditorialPlaylistSectionFields on EditorialPlaylistSection {
    title
    description
    items {
      ...PlaylistItemFields
    }
  }
  ${PlaylistItemFieldsFragmentDoc}
`
export const LabelFieldsFragmentDoc = gql`
  fragment LabelFields on Label {
    id
    title
  }
`
export const ArtistWithRoleFieldsFragmentDoc = gql`
  fragment artistWithRoleFields on ArtistWithRoleConnection {
    edges {
      role {
        ...RoleFields
      }
      node {
        id
        name
        sortName
      }
    }
  }
  ${RoleFieldsFragmentDoc}
`
export const LivePerformanceWorkFieldsFragmentDoc = gql`
  fragment livePerformanceWorkFields on LivePerformanceWork {
    __typename
    id
    duration
    artists {
      ...artistWithRoleFields
    }
    work {
      ...workFields
    }
  }
  ${ArtistWithRoleFieldsFragmentDoc}
  ${WorkFieldsFragmentDoc}
`
export const LiveStreamFieldsFragmentDoc = gql`
  fragment liveStreamFields on LiveStream {
    publicationLevel
    streamType
    url
  }
`
export const PerformanceWorkConcertFieldsFragmentDoc = gql`
  fragment performanceWorkConcertFields on PerformanceWork {
    id
    vodConcert {
      __typename
      id
      pictures {
        ...PictureFields
      }
      title
      totalDuration
      typeDisplayName
      publicationLevel
    }
    duration
    work {
      title
    }
  }
  ${PictureFieldsFragmentDoc}
`
export const PerformanceWorkFieldsFragmentDoc = gql`
  fragment PerformanceWorkFields on PerformanceWork {
    __typename
    id
    artists {
      ...artistWithRoleFields
    }
    groups {
      edges {
        node {
          id
          name
          typeDisplayName
        }
      }
    }
    work {
      ...workFields
    }
    streamVariants {
      ...streamVariantFields
    }
    vodConcert {
      __typename
      id
    }
    duration
    cuePoints {
      mark
      title
    }
  }
  ${ArtistWithRoleFieldsFragmentDoc}
  ${WorkFieldsFragmentDoc}
  ${StreamVariantFieldsFragmentDoc}
`
export const SearchImageFieldsFragmentDoc = gql`
  fragment SearchImageFields on SearchImage {
    type
    url
  }
`
export const SearchVideoFieldsFragmentDoc = gql`
  fragment SearchVideoFields on SearchVideosResult {
    totalResults
    items {
      __typename
      id
      title
      subtitle
      duration
      geoAccessMode
      geoAccessCountries
      typeDisplayName
      videoType
      publicationLevel
      images {
        ...SearchImageFields
      }
    }
  }
  ${SearchImageFieldsFragmentDoc}
`
export const SubscriptionPlansStripeFieldsFragmentDoc = gql`
  fragment subscriptionPlansStripeFields on SubscriptionPlansStripe {
    __typename
    coupon {
      productIdsLimitedTo
      percentOff
    }
    plans {
      productId
      interval
      prices {
        id
        currency
        amount
        amountUndiscounted
      }
      trialPeriodDays
    }
  }
`
export const TrackWithAlbumFieldsFragmentDoc = gql`
  fragment trackWithAlbumFields on Track {
    ...trackFields
    album {
      __typename
      ...AlbumFields
    }
  }
  ${TrackFieldsFragmentDoc}
  ${AlbumFieldsFragmentDoc}
`
export const DeviceAttributesFragmentDoc = gql`
  fragment DeviceAttributes on Device {
    deviceInfo
    id
    insertedAt
    updatedAt
  }
`
export const UserAttributesFragmentDoc = gql`
  fragment UserAttributes on User {
    academicTitle
    affiliateGroup
    country
    devices {
      ...DeviceAttributes
    }
    email
    emailVerified
    firstName
    hasTrialedBefore
    id
    insertedAt
    lastName
    liveReminderEmail
    liveReminderPush
    locale
    postalAddress {
      city
      country
      firstLine
      insertedAt
      secondLine
      state
      updatedAt
      zipCode
    }
    pushOptin
    sendNewsletter
    ticket {
      paymentProvider
      status
      validUntil
      isTrial
    }
    title
    updatedAt
  }
  ${DeviceAttributesFragmentDoc}
`
export const AccountSettingsDocument = gql`
  query accountSettings {
    currentUser {
      academicTitle
      country
      email
      firstName
      lastName
      locale
      sendNewsletter
      title
      postalAddress {
        city
        country
        firstLine
        secondLine
        state
        zipCode
      }
    }
  }
`
export const ArtistCollectionPageDocument = gql`
  query artistCollectionPage($artistId: ID!, $sliderPageSize: Int = 7) {
    artist(id: $artistId) {
      __typename
      id
      name
      title
      biography
      dateOfBirth
      dateOfDeath
      courtesyOf
      roles {
        ...RoleFields
      }
      pictures {
        ...PictureFields
      }
      curatedContent(options: { profile: FILTERED }) {
        ...CuratedContentFields
      }
      epoch {
        __typename
        id
        title
      }
    }
  }
  ${RoleFieldsFragmentDoc}
  ${PictureFieldsFragmentDoc}
  ${CuratedContentFieldsFragmentDoc}
`
export const AudioDetailPageDocument = gql`
  query audioDetailPage($albumId: ID!, $sliderPageSize: Int = 7) {
    album(id: $albumId) {
      __typename
      artistAndGroupDisplayInfo
      atmosUpc
      id
      title
      totalDuration
      releaseDate
      pictures {
        ...PictureFields
      }
      trackSets {
        ...TrackSetFields
      }
      curatedContent(options: { profile: FILTERED }) {
        ...CuratedContentFields
      }
      artists {
        ...artistWithRoleFields
      }
      groups {
        id
        name
        typeDisplayName
      }
      epochsByRelevance {
        __typename
        id
        title
      }
      genresByRelevance {
        __typename
        id
        title
      }
    }
  }
  ${PictureFieldsFragmentDoc}
  ${TrackSetFieldsFragmentDoc}
  ${CuratedContentFieldsFragmentDoc}
  ${ArtistWithRoleFieldsFragmentDoc}
`
export const CountriesDocument = gql`
  query countries {
    countries {
      __typename
      iso
      displayName
    }
  }
`
export const CuratedContentPageDocument = gql`
  query curatedContentPage($slug: String!, $sliderPageSize: Int = 7) {
    curatedContentPage(slug: $slug) {
      title
      metaTitle
      metaDescription
      navigation {
        __typename
        ...ListSliderFields
      }
      stageSlider {
        label
        subtitle
        title
        item {
          ... on Node {
            __typename
          }
          ...AlbumFields
          ...ArtistFields
          ...GroupFields
          ...LiveConcertFields
          ...PartnerFields
          ...VideoFields
          ...VodConcertFields
          ...EditorialPlaylistFields
        }
      }
      curatedContent(options: { profile: FILTERED }) {
        ...CuratedContentFields
      }
    }
  }
  ${ListSliderFieldsFragmentDoc}
  ${AlbumFieldsFragmentDoc}
  ${ArtistFieldsFragmentDoc}
  ${GroupFieldsFragmentDoc}
  ${LiveConcertFieldsFragmentDoc}
  ${PartnerFieldsFragmentDoc}
  ${VideoFieldsFragmentDoc}
  ${VodConcertFieldsFragmentDoc}
  ${EditorialPlaylistFieldsFragmentDoc}
  ${CuratedContentFieldsFragmentDoc}
`
export const CurrentUserDocument = gql`
  query currentUser {
    currentUser {
      ...UserAttributes
    }
  }
  ${UserAttributesFragmentDoc}
`
export const DevicesDocument = gql`
  query devices {
    currentUser {
      devices {
        id
        deviceInfo
        insertedAt
        updatedAt
      }
    }
  }
`
export const EditorialPlaylistPageDocument = gql`
  query editorialPlaylistPage(
    $editorialPlaylistId: ID!
    $sliderPageSize: Int = 7
  ) {
    editorialPlaylist(id: $editorialPlaylistId) {
      __typename
      id
      title
      metaTitle
      metaDescription
      totalDuration
      totalItems
      typeDisplayName
      pictures {
        ...PictureFields
      }
      curatedContent(options: { profile: FILTERED }) {
        ...CuratedContentFields
      }
      sections {
        ...EditorialPlaylistSectionFields
      }
    }
  }
  ${PictureFieldsFragmentDoc}
  ${CuratedContentFieldsFragmentDoc}
  ${EditorialPlaylistSectionFieldsFragmentDoc}
`
export const EpochPageDocument = gql`
  query epochPage($epochId: ID!, $sliderPageSize: Int = 7) {
    epoch(id: $epochId) {
      __typename
      id
      title
      subtitle
      description
      startYear
      endYear
      pictures {
        ...PictureFields
      }
      curatedContent(options: { profile: FILTERED }) {
        ...CuratedContentFields
      }
    }
  }
  ${PictureFieldsFragmentDoc}
  ${CuratedContentFieldsFragmentDoc}
`
export const FavoriteByContentIdDocument = gql`
  query favoriteByContentId($contentId: ID!) {
    favoriteByContentId(contentId: $contentId) {
      content {
        __typename
        ... on Album {
          id
        }
        ... on Video {
          id
        }
        ... on EditorialPlaylist {
          id
        }
      }
    }
  }
`
export const FavoritesByVodConcertIdDocument = gql`
  query favoritesByVodConcertId($vodConcertId: ID!) {
    favoritesByVodConcertId(contentId: $vodConcertId) {
      content {
        __typename
        ... on PerformanceWork {
          id
        }
      }
    }
  }
`
export const GenrePageDocument = gql`
  query genrePage($genreId: ID!, $sliderPageSize: Int = 7) {
    genre(id: $genreId) {
      __typename
      id
      title
      pictures {
        ...PictureFields
      }
      curatedContent(options: { profile: FILTERED }) {
        ...CuratedContentFields
      }
    }
  }
  ${PictureFieldsFragmentDoc}
  ${CuratedContentFieldsFragmentDoc}
`
export const GeoInfoDocument = gql`
  query geoInfo {
    geoinfo {
      countryCode
    }
  }
`
export const GroupPageDocument = gql`
  query groupPage($groupId: ID!, $sliderPageSize: Int = 7) {
    group(id: $groupId) {
      __typename
      id
      name
      description
      footnote
      typeDisplayName
      pictures {
        ...PictureFields
      }
      curatedContent(options: { profile: FILTERED }) {
        ...CuratedContentFields
      }
    }
  }
  ${PictureFieldsFragmentDoc}
  ${CuratedContentFieldsFragmentDoc}
`
export const InfoModalDocument = gql`
  query infoModal($nodeId: ID!, $sliderPageSize: Int = 7) {
    node(id: $nodeId) {
      __typename
      ... on Album {
        artists {
          ...artistWithRoleFields
        }
        atmosUpc
        albumCopyright: copyright
        groups {
          id
          name
          typeDisplayName
        }
        id
        phonographicCopyright
        pictures {
          ...PictureFields
        }
        releaseDate
        title
        totalDuration
        upc
        artistAndGroupDisplayInfo
      }
      ... on LiveConcert {
        artists {
          ...artistWithRoleFields
        }
        copyright
        groups {
          id
          name
          typeDisplayName
        }
        id
        isrc
        longFormConcertIntroduction
        partners {
          name
          type
        }
        photographer
        pictures {
          ...PictureFields
        }
        production
        shortDescription
        subtitle
        title
        totalDuration
        typeDisplayName
        videoDirector
      }
      ... on Video {
        artists {
          ...artistWithRoleFields
        }
        description
        copyright
        duration
        groups {
          id
          name
          typeDisplayName
        }
        id
        isrc
        photographer
        pictures {
          ...PictureFields
        }
        production
        productionDate
        subtitle
        takedownDate
        title
        typeDisplayName
        videoDirector
      }
      ... on VodConcert {
        artists {
          ...artistWithRoleFields
        }
        copyright
        groups {
          id
          name
          typeDisplayName
        }
        id
        isrc
        partners {
          name
          type
        }
        photographer
        pictures {
          ...PictureFields
        }
        production
        productionDate
        longFormConcertIntroduction
        shortDescription
        subtitle
        takedownDate
        title
        totalDuration
        typeDisplayName
        videoDirector
      }
      ... on Artist {
        id
        name
        biography
        dateOfBirth
        dateOfDeath
        courtesyOf
        roles {
          ...RoleFields
        }
        pictures {
          ...PictureFields
        }
      }
      ... on Group {
        id
        name
        description
        footnote
        typeDisplayName
        pictures {
          ...PictureFields
        }
        curatedContent(options: { profile: FILTERED }) {
          ...CuratedContentFields
        }
      }
      ... on Partner {
        id
        name
        description
        typeDisplayName
        subtypeDisplayName
        pictures {
          ...PictureFields
        }
      }
      ... on Epoch {
        id
        title
        subtitle
        description
        pictures {
          ...PictureFields
        }
      }
      ... on Genre {
        id
        title
        pictures {
          ...PictureFields
        }
      }
    }
  }
  ${ArtistWithRoleFieldsFragmentDoc}
  ${PictureFieldsFragmentDoc}
  ${RoleFieldsFragmentDoc}
  ${CuratedContentFieldsFragmentDoc}
`
export const AddFavoriteDocument = gql`
  mutation addFavorite($input: AddFavoriteInput) {
    addFavorite(input: $input) {
      errors {
        ...ApiErrorFields
      }
      result {
        id
      }
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const CancelStripeSubscriptionDocument = gql`
  mutation cancelStripeSubscription {
    cancelStripeSubscription {
      result {
        ticketTerminatesAt
      }
      errors {
        ...ApiErrorFields
      }
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const ChangePasswordDocument = gql`
  mutation changePassword($input: ChangePasswordInput) {
    changePassword(input: $input) {
      errors {
        ...ApiErrorFields
      }
      result
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const ChangeStripePaymentMethodDocument = gql`
  mutation changeStripePaymentMethod {
    changeStripePaymentMethod {
      errors {
        ...ApiErrorFields
      }
      result {
        clientSecret
      }
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const ConsentTrackingDocument = gql`
  mutation consentTracking($input: ConsentTrackingInput) {
    consentTracking(input: $input) {
      errors {
        ...ApiErrorFields
      }
      result
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const DeleteUserDocument = gql`
  mutation deleteUser {
    deleteUser {
      errors {
        ...ApiErrorFields
      }
      result {
        email
      }
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const GeneratePinCodeDocument = gql`
  mutation generatePinCode {
    generatePinCode {
      errors {
        ...ApiErrorFields
      }
      result {
        expiresAt
        pinCode
      }
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const LoginWithPinDocument = gql`
  mutation LoginWithPin($input: LoginUserWithPinCodeInput) {
    loginUserWithPinCode(input: $input) {
      errors {
        message
        path
      }
      result {
        accessToken
        refreshToken
        user {
          ...UserAttributes
        }
      }
    }
  }
  ${UserAttributesFragmentDoc}
`
export const ReactivateStripeSubscriptionDocument = gql`
  mutation reactivateStripeSubscription {
    reactivateStripeSubscription {
      result {
        status
        validUntil
      }
      errors {
        ...ApiErrorFields
      }
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const RecordPlaybackProgressDocument = gql`
  mutation recordPlaybackProgress($input: RecordPlaybackProgressInputV2!) {
    recordPlaybackProgressV2(input: $input) {
      errors {
        ...ApiErrorFields
      }
      result {
        id
      }
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const RegisterUserDocument = gql`
  mutation registerUser($input: RegisterUserInput) {
    registerUser(input: $input) {
      errors {
        ...ApiErrorFields
      }
      result {
        accessToken
        refreshToken
        user {
          locale
        }
      }
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const RemoveDeviceDocument = gql`
  mutation removeDevice($input: RemoveDeviceInput) {
    removeDevice(input: $input) {
      errors {
        ...ApiErrorFields
      }
      result
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const RemoveFavoriteByContentIdDocument = gql`
  mutation removeFavoriteByContentId($input: RemoveFavoriteByContentIdInput) {
    removeFavoriteByContentId(input: $input) {
      errors {
        ...ApiErrorFields
      }
      result
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const RemoveFavoriteByContentTypeDocument = gql`
  mutation removeFavoriteByContentType(
    $input: RemoveFavoriteByContentTypeInput
  ) {
    removeFavoriteByContentType(input: $input) {
      errors {
        ...ApiErrorFields
      }
      result
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const ResendEmailConfirmationDocument = gql`
  mutation resendEmailConfirmation {
    resendEmailConfirmation {
      errors {
        ...ApiErrorFields
      }
      result
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const ResetAllPlaybackProgressDocument = gql`
  mutation resetAllPlaybackProgress {
    resetAllPlaybackProgress(input: { contentType: VIDEO }) {
      errors {
        ...ApiErrorFields
      }
      result
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const ResetPasswordDocument = gql`
  mutation resetPassword($input: ResetPasswordInput) {
    resetPassword(input: $input) {
      errors {
        ...ApiErrorFields
      }
      result
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const SendChangeEmailAddressEmailDocument = gql`
  mutation sendChangeEmailAddressEmail(
    $input: SendChangeEmailAddressEmailInput
  ) {
    sendChangeEmailAddressEmail(input: $input) {
      errors {
        ...ApiErrorFields
      }
      result
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const SendResetPasswordEmailDocument = gql`
  mutation sendResetPasswordEmail($input: SendResetPasswordEmailInput) {
    sendResetPasswordEmail(input: $input) {
      errors {
        ...ApiErrorFields
      }
      result
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const SubscribeDgNewsletterDocument = gql`
  mutation subscribeDgNewsletter($input: SubscribeDgNewsletterInput) {
    subscribeDgNewsletter(input: $input) {
      result
      errors {
        ...ApiErrorFields
      }
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const SubscribeStagePlusEmailNotificationDocument = gql`
  mutation subscribeStagePlusEmailNotification {
    subscribeStagePlusEmailNotification {
      result
      errors {
        ...ApiErrorFields
      }
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const SubscribeViaStripeDocument = gql`
  mutation subscribeViaStripe($input: SubscribeViaStripeInput) {
    subscribeViaStripe(input: $input) {
      errors {
        ...ApiErrorFields
      }
      result {
        __typename
        ... on PaymentIntentClientSecret {
          clientSecret
        }
        ... on SetupIntentClientSecret {
          clientSecret
        }
      }
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const UpdatePostalAddressDocument = gql`
  mutation updatePostalAddress($input: UpdatePostalAddressInput) {
    updatePostalAddress(input: $input) {
      errors {
        ...ApiErrorFields
      }
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const UpdateUserDocument = gql`
  mutation updateUser($input: UpdateUserInput) {
    updateUser(input: $input) {
      errors {
        ...ApiErrorFields
      }
    }
  }
  ${ApiErrorFieldsFragmentDoc}
`
export const MyStagePageDocument = gql`
  query myStagePage($sliderPageSize: Int!, $cursor: String) {
    currentUser {
      videoFavorites: favorites(
        filter: PERFORMANCE_WORK_AND_VIDEO
        first: $sliderPageSize
        after: $cursor
      ) {
        edges {
          node {
            id
            content {
              __typename
              ... on Video {
                ...VideoFields
              }
              ... on PerformanceWork {
                ...performanceWorkConcertFields
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        totalResults
      }
      albumFavorites: favorites(filter: ALBUM, first: $sliderPageSize) {
        edges {
          node {
            id
            content {
              __typename
              ... on Album {
                ...AlbumFields
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        totalResults
      }
      editorialPlaylistFavorites: favorites(
        filter: EDITORIAL_PLAYLIST
        first: $sliderPageSize
      ) {
        edges {
          node {
            id
            content {
              __typename
              ... on EditorialPlaylist {
                ...EditorialPlaylistFields
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        totalResults
      }
      videoRecentlyPlayed: recentlyPlayed(
        filter: PERFORMANCE_WORK_AND_VIDEO
        first: $sliderPageSize
        after: $cursor
      ) {
        edges {
          node {
            id
            mark
            content {
              __typename
              ... on Video {
                ...VideoFields
              }
              ... on PerformanceWork {
                ...performanceWorkConcertFields
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        totalResults
      }
      albumRecentlyPlayed: recentlyPlayed(
        filter: TRACK
        first: $sliderPageSize
      ) {
        edges {
          node {
            id
            mark
            content {
              __typename
              ... on Track {
                ...trackWithAlbumFields
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        totalResults
      }
    }
  }
  ${VideoFieldsFragmentDoc}
  ${PerformanceWorkConcertFieldsFragmentDoc}
  ${AlbumFieldsFragmentDoc}
  ${EditorialPlaylistFieldsFragmentDoc}
  ${TrackWithAlbumFieldsFragmentDoc}
`
export const PartnerPageDocument = gql`
  query partnerPage($partnerId: ID!, $sliderPageSize: Int = 7) {
    partner(id: $partnerId) {
      __typename
      id
      name
      description
      typeDisplayName
      subtypeDisplayName
      pictures {
        ...PictureFields
      }
      curatedContent(options: { profile: FILTERED }) {
        ...CuratedContentFields
      }
    }
  }
  ${PictureFieldsFragmentDoc}
  ${CuratedContentFieldsFragmentDoc}
`
export const PaymentPageDocument = gql`
  query paymentPage($couponCode: String) {
    subscriptionPlansStripe(couponCode: $couponCode) {
      ...subscriptionPlansStripeFields
    }
  }
  ${SubscriptionPlansStripeFieldsFragmentDoc}
`
export const PlaybackProgressDocument = gql`
  query playbackProgress($id: ID!) {
    playbackProgressByContentId(contentId: $id) {
      mark
    }
  }
`
export const PlayerContentDocument = gql`
  query playerContent($contentId: ID!) {
    node(id: $contentId) {
      __typename
      ...LiveConcertFields
      ... on LiveConcert {
        artists {
          ...artistWithRoleFields
        }
        groups {
          id
          name
          type
        }
        shortDescription
        performanceWorks {
          ...livePerformanceWorkFields
        }
      }
      ...VideoFields
      ... on Video {
        artists {
          ...artistWithRoleFields
        }
        description
      }
      ...AlbumFields
      ... on Album {
        groups {
          ...GroupFields
        }
        atmosUpc
        totalDuration
        releaseDate
        trackSets {
          ...TrackSetFields
        }
      }
      ...VodConcertFields
      ... on VodConcert {
        artists {
          ...artistWithRoleFields
        }
        groups {
          id
          name
          type
        }
        performanceWorks {
          ...PerformanceWorkFields
        }
        shortDescription
      }
    }
  }
  ${LiveConcertFieldsFragmentDoc}
  ${ArtistWithRoleFieldsFragmentDoc}
  ${LivePerformanceWorkFieldsFragmentDoc}
  ${VideoFieldsFragmentDoc}
  ${AlbumFieldsFragmentDoc}
  ${GroupFieldsFragmentDoc}
  ${TrackSetFieldsFragmentDoc}
  ${VodConcertFieldsFragmentDoc}
  ${PerformanceWorkFieldsFragmentDoc}
`
export const ReminderModalDocument = gql`
  query reminderModal($liveConcertId: ID!) {
    liveConcert(id: $liveConcertId) {
      __typename
      endTime
      id
      pictures {
        ...PictureFields
      }
      reruns {
        endTime
        startTime
      }
      seriesTitle
      shortDescription
      startTime
      subtitle
      title
      typeDisplayName
    }
  }
  ${PictureFieldsFragmentDoc}
`
export const SearchByFacetTypeDocument = gql`
  query searchByFacetType($input: FacetType!) {
    searchByFacetType(input: { facetType: $input }) {
      sections {
        glyph
        items {
          count
          id
          label
        }
      }
    }
  }
`
export const SearchByFacetValueDocument = gql`
  query searchByFacetValue(
    $type: FacetType!
    $value: String!
    $sliderPageSize: Int!
  ) {
    searchByFacetValue(input: { facetType: $type, facetValue: $value }) {
      id
      title
      subtitle
      imageUrl
      artists(first: $sliderPageSize) {
        totalResults
        items {
          __typename
          id
          name
          images {
            ...SearchImageFields
          }
        }
      }
      documentaries(first: $sliderPageSize) {
        ...SearchVideoFields
      }
      groups(first: $sliderPageSize) {
        totalResults
        items {
          __typename
          id
          name
          subtype
          images {
            ...SearchImageFields
          }
        }
      }
      interviews(first: $sliderPageSize) {
        ...SearchVideoFields
      }
      liveConcerts(first: $sliderPageSize) {
        totalResults
        items {
          __typename
          id
          title
          subtitle
          startDate
          typeDisplayName
          images {
            ...SearchImageFields
          }
        }
      }
      partners(first: $sliderPageSize) {
        totalResults
        items {
          __typename
          id
          name
          description
          images {
            ...SearchImageFields
          }
        }
      }
      shorts(first: $sliderPageSize) {
        ...SearchVideoFields
      }
      vodConcerts(first: $sliderPageSize) {
        totalResults
        items {
          __typename
          id
          title
          subtitle
          duration
          typeDisplayName
          geoAccessCountries
          geoAccessMode
          publicationLevel
          images {
            ...SearchImageFields
          }
        }
      }
      albums(first: $sliderPageSize) {
        totalResults
        items {
          __typename
          id
          title
          artistsAndGroups
          images {
            ...SearchImageFields
          }
        }
      }
      editorialPlaylists(first: $sliderPageSize) {
        totalResults
        items {
          __typename
          id
          title
          description
          images {
            ...SearchImageFields
          }
        }
      }
    }
  }
  ${SearchImageFieldsFragmentDoc}
  ${SearchVideoFieldsFragmentDoc}
`
export const SearchByTextDocument = gql`
  query searchByText($input: String!, $sliderPageSize: Int!) {
    searchByText(input: { text: $input }) {
      artists(first: $sliderPageSize) {
        totalResults
        items {
          __typename
          id
          name
          roles
          images {
            ...SearchImageFields
          }
        }
      }
      documentaries(first: $sliderPageSize) {
        ...SearchVideoFields
      }
      groups(first: $sliderPageSize) {
        totalResults
        items {
          __typename
          id
          name
          subtype
          images {
            ...SearchImageFields
          }
        }
      }
      interviews(first: $sliderPageSize) {
        ...SearchVideoFields
      }
      liveConcerts(first: $sliderPageSize) {
        totalResults
        items {
          __typename
          id
          title
          subtitle
          startDate
          typeDisplayName
          images {
            ...SearchImageFields
          }
        }
      }
      partners(first: $sliderPageSize) {
        totalResults
        items {
          __typename
          id
          name
          description
          images {
            ...SearchImageFields
          }
        }
      }
      shorts(first: $sliderPageSize) {
        ...SearchVideoFields
      }
      vodConcerts(first: $sliderPageSize) {
        totalResults
        items {
          __typename
          id
          title
          subtitle
          duration
          typeDisplayName
          geoAccessCountries
          geoAccessMode
          publicationLevel
          images {
            ...SearchImageFields
          }
        }
      }
      albums(first: $sliderPageSize) {
        totalResults
        items {
          __typename
          id
          title
          artistsAndGroups
          images {
            ...SearchImageFields
          }
        }
      }
      editorialPlaylists(first: $sliderPageSize) {
        totalResults
        items {
          __typename
          id
          title
          description
          typeDisplayName
          images {
            ...SearchImageFields
          }
        }
      }
    }
  }
  ${SearchImageFieldsFragmentDoc}
  ${SearchVideoFieldsFragmentDoc}
`
export const SearchDetailPageDocument = gql`
  query searchDetailPage($nodeId: ID!) {
    node(id: $nodeId) {
      __typename
      ...ArtistFields
      ...GroupFields
      ...PartnerFields
    }
  }
  ${ArtistFieldsFragmentDoc}
  ${GroupFieldsFragmentDoc}
  ${PartnerFieldsFragmentDoc}
`
export const SessionDocument = gql`
  query session($isAuthenticated: Boolean!) {
    currentUser @include(if: $isAuthenticated) {
      email
      emailVerified
      insertedAt
      ticket {
        interval
        status
        validUntil
        paymentProvider
      }
      postalAddress {
        country
      }
      favorites {
        edges {
          node {
            content {
              __typename
              ... on Node {
                id
              }
            }
          }
        }
      }
      recentlyPlayed {
        edges {
          node {
            mark
            content {
              __typename
              ... on Video {
                id
                duration
              }
              ... on PerformanceWork {
                id
                duration
              }
              ... on Track {
                id
                duration
              }
            }
          }
        }
      }
    }
    geoinfo {
      countryCode
      currencyCode
    }
  }
`
export const ShareModalDocument = gql`
  query shareModal($nodeId: ID!) {
    node(id: $nodeId) {
      __typename
      ... on Album {
        id
        title
        artistAndGroupDisplayInfo
      }
      ... on LiveConcert {
        id
        title
        shortDescription
      }
      ... on Video {
        id
        title
        description
      }
      ... on Track {
        id
        title
      }
      ... on PerformanceWork {
        id
        work {
          title
        }
      }
      ... on VodConcert {
        id
        title
        shortDescription
        title
      }
      ... on Artist {
        id
        name
      }
      ... on Group {
        id
        name
      }
      ... on Partner {
        id
        name
      }
      ... on Epoch {
        id
        title
      }
      ... on Genre {
        id
        title
      }
    }
  }
`
export const SliderPageDocument = gql`
  query sliderPage($sliderId: ID!, $sliderPageSize: Int!, $cursor: String) {
    slider(id: $sliderId) {
      __typename
      id
      headline
      layout
      sliderItems(first: $sliderPageSize, by: CUSTOM, after: $cursor) {
        totalResults
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            __typename
            ...AlbumFields
            ...ArtistFields
            ...EpochFields
            ...GenreFields
            ...GroupFields
            ...LiveConcertFields
            ...PartnerFields
            ...VideoFields
            ...VodConcertFields
            ...EditorialPlaylistFields
          }
        }
      }
    }
  }
  ${AlbumFieldsFragmentDoc}
  ${ArtistFieldsFragmentDoc}
  ${EpochFieldsFragmentDoc}
  ${GenreFieldsFragmentDoc}
  ${GroupFieldsFragmentDoc}
  ${LiveConcertFieldsFragmentDoc}
  ${PartnerFieldsFragmentDoc}
  ${VideoFieldsFragmentDoc}
  ${VodConcertFieldsFragmentDoc}
  ${EditorialPlaylistFieldsFragmentDoc}
`
export const SubscriptionPlansDocument = gql`
  query subscriptionPlans($couponCode: String) {
    subscriptionPlansStripe(couponCode: $couponCode) {
      ...subscriptionPlansStripeFields
    }
  }
  ${SubscriptionPlansStripeFieldsFragmentDoc}
`
export const SubscriptionSettingsDocument = gql`
  query subscriptionSettings {
    currentUser {
      hasTrialedBefore
      stripeInvoices {
        billedAt
        currency
        description
        number
        pdfUrl
        total
      }
      ticket {
        interval
        paymentProvider
        status
        validUntil
        stripeBillingInfo {
          amount
          billedFirstAt
          billedNextAt
          card {
            brand
            expMonth
            expYear
            funding
            country
            last4
          }
          currency
        }
      }
    }
  }
`
export const TicketsPageDocument = gql`
  query ticketsPage {
    subscriptionPlansStripe {
      ...subscriptionPlansStripeFields
    }
  }
  ${SubscriptionPlansStripeFieldsFragmentDoc}
`
export const VideoDetailPageDocument = gql`
  query videoDetailPage($videoId: ID!, $sliderPageSize: Int = 7) {
    node(id: $videoId) {
      __typename
      ...LiveConcertFields
      ... on LiveConcert {
        artists {
          edges {
            role {
              ...RoleFields
            }
            node {
              id
              name
              sortName
            }
          }
        }
        isAtmos
        maxResolution
        groups {
          id
          name
          typeDisplayName
        }
        shortDescription
        performanceWorks {
          ...livePerformanceWorkFields
        }
        curatedContent(options: { profile: FILTERED }) {
          ...CuratedContentFields
        }
      }
      ...VideoFields
      ... on Video {
        artists {
          edges {
            role {
              ...RoleFields
            }
            node {
              id
              name
              sortName
            }
          }
        }
        isAtmos
        maxResolution
        isLossless
        description
        productionDate
        takedownDate
        epochsByRelevance {
          __typename
          id
          title
        }
        genresByRelevance {
          __typename
          id
          title
        }
        curatedContent(options: { profile: FILTERED }) {
          ...CuratedContentFields
        }
      }
      ...VodConcertFields
      ... on VodConcert {
        artists {
          edges {
            role {
              ...RoleFields
            }
            node {
              id
              name
              sortName
            }
          }
        }
        isAtmos
        maxResolution
        groups {
          id
          name
          typeDisplayName
        }
        performanceWorks {
          ...PerformanceWorkFields
        }
        shortDescription
        productionDate
        takedownDate
        epochsByRelevance {
          __typename
          id
          title
        }
        genresByRelevance {
          __typename
          id
          title
        }
        curatedContent(options: { profile: FILTERED }) {
          ...CuratedContentFields
        }
      }
    }
  }
  ${LiveConcertFieldsFragmentDoc}
  ${RoleFieldsFragmentDoc}
  ${LivePerformanceWorkFieldsFragmentDoc}
  ${CuratedContentFieldsFragmentDoc}
  ${VideoFieldsFragmentDoc}
  ${VodConcertFieldsFragmentDoc}
  ${PerformanceWorkFieldsFragmentDoc}
`
export const WorkPageDocument = gql`
  query workPage($workId: ID!, $sliderPageSize: Int = 7) {
    work(id: $workId) {
      __typename
      ...workFields
      ... on Work {
        curatedContent(options: { profile: FILTERED }) {
          ...CuratedContentFields
        }
      }
    }
  }
  ${WorkFieldsFragmentDoc}
  ${CuratedContentFieldsFragmentDoc}
`

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
) => Promise<T>

const defaultWrapper: SdkFunctionWrapper = (
  action,
  _operationName,
  _operationType,
) => action()

export function getSdk(
  client: GraphQLClient,
  withWrapper: SdkFunctionWrapper = defaultWrapper,
) {
  return {
    accountSettings(
      variables?: AccountSettingsQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<AccountSettingsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AccountSettingsQuery>(
            AccountSettingsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "accountSettings",
        "query",
      )
    },
    artistCollectionPage(
      variables: ArtistCollectionPageQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<ArtistCollectionPageQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ArtistCollectionPageQuery>(
            ArtistCollectionPageDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "artistCollectionPage",
        "query",
      )
    },
    audioDetailPage(
      variables: AudioDetailPageQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<AudioDetailPageQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AudioDetailPageQuery>(
            AudioDetailPageDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "audioDetailPage",
        "query",
      )
    },
    countries(
      variables?: CountriesQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<CountriesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CountriesQuery>(CountriesDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "countries",
        "query",
      )
    },
    curatedContentPage(
      variables: CuratedContentPageQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<CuratedContentPageQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CuratedContentPageQuery>(
            CuratedContentPageDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "curatedContentPage",
        "query",
      )
    },
    currentUser(
      variables?: CurrentUserQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<CurrentUserQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CurrentUserQuery>(CurrentUserDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "currentUser",
        "query",
      )
    },
    devices(
      variables?: DevicesQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<DevicesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DevicesQuery>(DevicesDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "devices",
        "query",
      )
    },
    editorialPlaylistPage(
      variables: EditorialPlaylistPageQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<EditorialPlaylistPageQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<EditorialPlaylistPageQuery>(
            EditorialPlaylistPageDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "editorialPlaylistPage",
        "query",
      )
    },
    epochPage(
      variables: EpochPageQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<EpochPageQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<EpochPageQuery>(EpochPageDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "epochPage",
        "query",
      )
    },
    favoriteByContentId(
      variables: FavoriteByContentIdQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<FavoriteByContentIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<FavoriteByContentIdQuery>(
            FavoriteByContentIdDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "favoriteByContentId",
        "query",
      )
    },
    favoritesByVodConcertId(
      variables: FavoritesByVodConcertIdQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<FavoritesByVodConcertIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<FavoritesByVodConcertIdQuery>(
            FavoritesByVodConcertIdDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "favoritesByVodConcertId",
        "query",
      )
    },
    genrePage(
      variables: GenrePageQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<GenrePageQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GenrePageQuery>(GenrePageDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "genrePage",
        "query",
      )
    },
    geoInfo(
      variables?: GeoInfoQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<GeoInfoQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GeoInfoQuery>(GeoInfoDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "geoInfo",
        "query",
      )
    },
    groupPage(
      variables: GroupPageQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<GroupPageQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GroupPageQuery>(GroupPageDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "groupPage",
        "query",
      )
    },
    infoModal(
      variables: InfoModalQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<InfoModalQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<InfoModalQuery>(InfoModalDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "infoModal",
        "query",
      )
    },
    addFavorite(
      variables?: AddFavoriteMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<AddFavoriteMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AddFavoriteMutation>(AddFavoriteDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "addFavorite",
        "mutation",
      )
    },
    cancelStripeSubscription(
      variables?: CancelStripeSubscriptionMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<CancelStripeSubscriptionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CancelStripeSubscriptionMutation>(
            CancelStripeSubscriptionDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "cancelStripeSubscription",
        "mutation",
      )
    },
    changePassword(
      variables?: ChangePasswordMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<ChangePasswordMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ChangePasswordMutation>(
            ChangePasswordDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "changePassword",
        "mutation",
      )
    },
    changeStripePaymentMethod(
      variables?: ChangeStripePaymentMethodMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<ChangeStripePaymentMethodMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ChangeStripePaymentMethodMutation>(
            ChangeStripePaymentMethodDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "changeStripePaymentMethod",
        "mutation",
      )
    },
    consentTracking(
      variables?: ConsentTrackingMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<ConsentTrackingMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ConsentTrackingMutation>(
            ConsentTrackingDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "consentTracking",
        "mutation",
      )
    },
    deleteUser(
      variables?: DeleteUserMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<DeleteUserMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DeleteUserMutation>(DeleteUserDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "deleteUser",
        "mutation",
      )
    },
    generatePinCode(
      variables?: GeneratePinCodeMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<GeneratePinCodeMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GeneratePinCodeMutation>(
            GeneratePinCodeDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "generatePinCode",
        "mutation",
      )
    },
    LoginWithPin(
      variables?: LoginWithPinMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<LoginWithPinMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<LoginWithPinMutation>(
            LoginWithPinDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "LoginWithPin",
        "mutation",
      )
    },
    reactivateStripeSubscription(
      variables?: ReactivateStripeSubscriptionMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<ReactivateStripeSubscriptionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ReactivateStripeSubscriptionMutation>(
            ReactivateStripeSubscriptionDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "reactivateStripeSubscription",
        "mutation",
      )
    },
    recordPlaybackProgress(
      variables: RecordPlaybackProgressMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<RecordPlaybackProgressMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RecordPlaybackProgressMutation>(
            RecordPlaybackProgressDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "recordPlaybackProgress",
        "mutation",
      )
    },
    registerUser(
      variables?: RegisterUserMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<RegisterUserMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RegisterUserMutation>(
            RegisterUserDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "registerUser",
        "mutation",
      )
    },
    removeDevice(
      variables?: RemoveDeviceMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<RemoveDeviceMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RemoveDeviceMutation>(
            RemoveDeviceDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "removeDevice",
        "mutation",
      )
    },
    removeFavoriteByContentId(
      variables?: RemoveFavoriteByContentIdMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<RemoveFavoriteByContentIdMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RemoveFavoriteByContentIdMutation>(
            RemoveFavoriteByContentIdDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "removeFavoriteByContentId",
        "mutation",
      )
    },
    removeFavoriteByContentType(
      variables?: RemoveFavoriteByContentTypeMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<RemoveFavoriteByContentTypeMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RemoveFavoriteByContentTypeMutation>(
            RemoveFavoriteByContentTypeDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "removeFavoriteByContentType",
        "mutation",
      )
    },
    resendEmailConfirmation(
      variables?: ResendEmailConfirmationMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<ResendEmailConfirmationMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ResendEmailConfirmationMutation>(
            ResendEmailConfirmationDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "resendEmailConfirmation",
        "mutation",
      )
    },
    resetAllPlaybackProgress(
      variables?: ResetAllPlaybackProgressMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<ResetAllPlaybackProgressMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ResetAllPlaybackProgressMutation>(
            ResetAllPlaybackProgressDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "resetAllPlaybackProgress",
        "mutation",
      )
    },
    resetPassword(
      variables?: ResetPasswordMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<ResetPasswordMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ResetPasswordMutation>(
            ResetPasswordDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "resetPassword",
        "mutation",
      )
    },
    sendChangeEmailAddressEmail(
      variables?: SendChangeEmailAddressEmailMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<SendChangeEmailAddressEmailMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SendChangeEmailAddressEmailMutation>(
            SendChangeEmailAddressEmailDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "sendChangeEmailAddressEmail",
        "mutation",
      )
    },
    sendResetPasswordEmail(
      variables?: SendResetPasswordEmailMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<SendResetPasswordEmailMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SendResetPasswordEmailMutation>(
            SendResetPasswordEmailDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "sendResetPasswordEmail",
        "mutation",
      )
    },
    subscribeDgNewsletter(
      variables?: SubscribeDgNewsletterMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<SubscribeDgNewsletterMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubscribeDgNewsletterMutation>(
            SubscribeDgNewsletterDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "subscribeDgNewsletter",
        "mutation",
      )
    },
    subscribeStagePlusEmailNotification(
      variables?: SubscribeStagePlusEmailNotificationMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<SubscribeStagePlusEmailNotificationMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubscribeStagePlusEmailNotificationMutation>(
            SubscribeStagePlusEmailNotificationDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "subscribeStagePlusEmailNotification",
        "mutation",
      )
    },
    subscribeViaStripe(
      variables?: SubscribeViaStripeMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<SubscribeViaStripeMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubscribeViaStripeMutation>(
            SubscribeViaStripeDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "subscribeViaStripe",
        "mutation",
      )
    },
    updatePostalAddress(
      variables?: UpdatePostalAddressMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<UpdatePostalAddressMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdatePostalAddressMutation>(
            UpdatePostalAddressDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "updatePostalAddress",
        "mutation",
      )
    },
    updateUser(
      variables?: UpdateUserMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<UpdateUserMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateUserMutation>(UpdateUserDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "updateUser",
        "mutation",
      )
    },
    myStagePage(
      variables: MyStagePageQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<MyStagePageQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<MyStagePageQuery>(MyStagePageDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "myStagePage",
        "query",
      )
    },
    partnerPage(
      variables: PartnerPageQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<PartnerPageQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<PartnerPageQuery>(PartnerPageDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "partnerPage",
        "query",
      )
    },
    paymentPage(
      variables?: PaymentPageQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<PaymentPageQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<PaymentPageQuery>(PaymentPageDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "paymentPage",
        "query",
      )
    },
    playbackProgress(
      variables: PlaybackProgressQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<PlaybackProgressQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<PlaybackProgressQuery>(
            PlaybackProgressDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "playbackProgress",
        "query",
      )
    },
    playerContent(
      variables: PlayerContentQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<PlayerContentQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<PlayerContentQuery>(PlayerContentDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "playerContent",
        "query",
      )
    },
    reminderModal(
      variables: ReminderModalQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<ReminderModalQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ReminderModalQuery>(ReminderModalDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "reminderModal",
        "query",
      )
    },
    searchByFacetType(
      variables: SearchByFacetTypeQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<SearchByFacetTypeQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SearchByFacetTypeQuery>(
            SearchByFacetTypeDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "searchByFacetType",
        "query",
      )
    },
    searchByFacetValue(
      variables: SearchByFacetValueQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<SearchByFacetValueQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SearchByFacetValueQuery>(
            SearchByFacetValueDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "searchByFacetValue",
        "query",
      )
    },
    searchByText(
      variables: SearchByTextQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<SearchByTextQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SearchByTextQuery>(SearchByTextDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "searchByText",
        "query",
      )
    },
    searchDetailPage(
      variables: SearchDetailPageQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<SearchDetailPageQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SearchDetailPageQuery>(
            SearchDetailPageDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "searchDetailPage",
        "query",
      )
    },
    session(
      variables: SessionQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<SessionQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SessionQuery>(SessionDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "session",
        "query",
      )
    },
    shareModal(
      variables: ShareModalQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<ShareModalQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ShareModalQuery>(ShareModalDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "shareModal",
        "query",
      )
    },
    sliderPage(
      variables: SliderPageQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<SliderPageQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SliderPageQuery>(SliderPageDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "sliderPage",
        "query",
      )
    },
    subscriptionPlans(
      variables?: SubscriptionPlansQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<SubscriptionPlansQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubscriptionPlansQuery>(
            SubscriptionPlansDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "subscriptionPlans",
        "query",
      )
    },
    subscriptionSettings(
      variables?: SubscriptionSettingsQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<SubscriptionSettingsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubscriptionSettingsQuery>(
            SubscriptionSettingsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "subscriptionSettings",
        "query",
      )
    },
    ticketsPage(
      variables?: TicketsPageQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<TicketsPageQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<TicketsPageQuery>(TicketsPageDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "ticketsPage",
        "query",
      )
    },
    videoDetailPage(
      variables: VideoDetailPageQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<VideoDetailPageQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<VideoDetailPageQuery>(
            VideoDetailPageDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "videoDetailPage",
        "query",
      )
    },
    workPage(
      variables: WorkPageQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"],
    ): Promise<WorkPageQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<WorkPageQuery>(WorkPageDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "workPage",
        "query",
      )
    },
  }
}
export type Sdk = ReturnType<typeof getSdk>
